var _style, _path, _path2, _feBlend, _feBlend2, _path3, _feBlend3, _feBlend4, _feBlend5, _feBlend6, _path4, _path5, _g, _feBlend7, _feBlend8, _path6, _feBlend9, _feBlend10, _feBlend11, _feBlend12, _feBlend13, _feBlend14, _feBlend15, _feBlend16, _path7, _feBlend17, _feBlend18, _feBlend19, _feBlend20, _path8, _feBlend21, _feBlend22, _feBlend23, _feBlend24, _path9, _path10, _feBlend25, _feBlend26, _g2, _feBlend27, _feBlend28, _path11, _feBlend29, _feBlend30, _g3, _feBlend31, _feBlend32, _feBlend33, _feBlend34, _feBlend35, _feBlend36, _feBlend37, _feBlend38, _path12, _path13, _path14, _g4, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _feBlend39, _feBlend40, _path31, _path32, _path33, _path34, _path35, _path36, _g5, _path37, _path38, _feBlend41, _feBlend42, _feBlend43, _feBlend44, _feBlend45, _feBlend46, _feBlend47, _feBlend48, _feBlend49, _feBlend50, _feBlend51, _feBlend52, _path39, _path40, _path41, _path42, _feBlend53, _feBlend54, _path43, _path44, _feBlend55, _feBlend56, _path45, _path46, _feBlend57, _feBlend58, _feBlend59, _feBlend60, _path47, _path48, _path49, _g6, _feBlend61, _feBlend62, _feBlend63, _feBlend64, _feBlend65, _feBlend66, _path50, _path51, _feBlend67, _feBlend68, _path52, _feBlend69, _feBlend70, _feBlend71, _feBlend72, _feBlend73, _feBlend74, _path53, _path54, _path55, _path56, _g7, _g8, _g9, _g10, _path57, _path58, _path59, _path60, _g11, _path61, _feBlend75, _feBlend76, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _feBlend77, _feBlend78, _feBlend79, _feBlend80, _path69, _path70, _feBlend81, _feBlend82, _path71, _feBlend83, _feBlend84, _feBlend85, _feBlend86, _path72, _feBlend87, _feBlend88, _feBlend89, _feBlend90, _feBlend91, _feBlend92, _feBlend93, _feBlend94, _feBlend95, _feBlend96, _path73, _path74, _path75, _path76, _feBlend97, _feBlend98, _path77, _path78, _path79, _feBlend99, _feBlend100, _path80, _feBlend101, _feBlend102, _path81, _feBlend103, _feBlend104, _feBlend105, _feBlend106, _path82, _path83, _feBlend107, _feBlend108, _feBlend109, _feBlend110, _feBlend111, _feBlend112, _feBlend113, _feBlend114, _feBlend115, _feBlend116, _feBlend117, _feBlend118, _feBlend119, _feBlend120, _feBlend121, _feBlend122, _feBlend123, _feBlend124, _feBlend125, _feBlend126, _feBlend127, _feBlend128, _feBlend129, _feBlend130, _feBlend131, _feBlend132, _feBlend133, _feBlend134, _feBlend135, _feBlend136, _feBlend137, _feBlend138, _feBlend139, _feBlend140, _feBlend141, _feBlend142, _feBlend143, _feBlend144, _feBlend145, _feBlend146, _feBlend147, _feBlend148, _feBlend149, _feBlend150, _feBlend151, _feBlend152, _feBlend153, _feBlend154, _feBlend155, _feBlend156, _path84, _path85, _feBlend157, _feBlend158, _feBlend159, _feBlend160, _feBlend161, _feBlend162, _feBlend163, _feBlend164;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChristmasMobileProductDetailsCardSanta1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1380.46 1724.36",
    style: {
      enableBackground: "new 0 0 1380.46 1724.36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#A6B2C6;}\r\n\t.st1{fill:#EBF4FB;}\r\n\t.st2{filter:url(#Adobe_OpacityMaskFilter);}\r\n\t.st3{filter:url(#Adobe_OpacityMaskFilter_00000041254898742705661930000005949745012045459111_);}\r\n\t.st4{mask:url(#SVGID_1_);fill:url(#SVGID_00000146495805933102221330000012139777184501508499_);}\r\n\t.st5{fill:url(#SVGID_00000183247803024336103290000000751249806694476676_);}\r\n\t.st6{fill:#DC0000;}\r\n\t.st7{filter:url(#Adobe_OpacityMaskFilter_00000064332701116595659910000012580234863739506828_);}\r\n\t.st8{filter:url(#Adobe_OpacityMaskFilter_00000000185125309935106850000003410518988550184338_);}\r\n\t\r\n\t\t.st9{mask:url(#SVGID_00000004527202586335535940000005405686623716110990_);fill:url(#SVGID_00000113322502995551054610000015230914211296017081_);}\r\n\t.st10{opacity:0.4;fill:url(#SVGID_00000163074753123656846060000005459604915569597086_);}\r\n\t.st11{filter:url(#Adobe_OpacityMaskFilter_00000121971922471064869270000012574201374036104348_);}\r\n\t.st12{filter:url(#Adobe_OpacityMaskFilter_00000067921950475907607770000016070413737798336385_);}\r\n\t\r\n\t\t.st13{mask:url(#SVGID_00000045587314840880098700000003433883608444606384_);fill:url(#SVGID_00000163046499604265655040000017489810374423894948_);}\r\n\t.st14{opacity:0.4;fill:url(#SVGID_00000031889897458588777860000007129282510191938726_);}\r\n\t.st15{fill:#FFBA48;}\r\n\t.st16{fill:#FFCC83;}\r\n\t.st17{fill:#FFC874;}\r\n\t.st18{fill:#FFC366;}\r\n\t.st19{fill:#FFBF57;}\r\n\t.st20{filter:url(#Adobe_OpacityMaskFilter_00000083788163685728660750000005386686166174250936_);}\r\n\t.st21{filter:url(#Adobe_OpacityMaskFilter_00000183936731776147100310000012935109715128436657_);}\r\n\t\r\n\t\t.st22{mask:url(#SVGID_00000104706629674605300490000017864566915964413579_);fill:url(#SVGID_00000007406205470958982660000000019111632918581639_);}\r\n\t.st23{opacity:0.55;fill:url(#SVGID_00000142150437556374048690000000750366970074014087_);}\r\n\t.st24{filter:url(#Adobe_OpacityMaskFilter_00000032646104067548692070000016216494423786280075_);}\r\n\t.st25{filter:url(#Adobe_OpacityMaskFilter_00000166633831651187888820000011469154583453448330_);}\r\n\t\r\n\t\t.st26{mask:url(#SVGID_00000164511730221118070390000009221481352533633416_);fill:url(#SVGID_00000171715617198783383660000004246255734721171116_);}\r\n\t.st27{opacity:0.62;fill:url(#SVGID_00000096018122090302068250000007454950706126708404_);}\r\n\t.st28{filter:url(#Adobe_OpacityMaskFilter_00000170998543652450547440000001311702229628039326_);}\r\n\t.st29{filter:url(#Adobe_OpacityMaskFilter_00000070105738545886498240000009360284017629194906_);}\r\n\t\r\n\t\t.st30{mask:url(#SVGID_00000178922581313074082840000006566315892795081634_);fill:url(#SVGID_00000088133066158979107010000003254494896994319514_);}\r\n\t.st31{opacity:0.62;fill:url(#SVGID_00000039825559346634137530000014448129753586049187_);}\r\n\t.st32{filter:url(#Adobe_OpacityMaskFilter_00000057120632724486420540000012487359221011542438_);}\r\n\t.st33{filter:url(#Adobe_OpacityMaskFilter_00000167377931440133505580000006492036048477027720_);}\r\n\t\r\n\t\t.st34{mask:url(#SVGID_00000101062188373237269050000002218326010052754075_);fill:url(#SVGID_00000134961342983698949660000002383991217005595535_);}\r\n\t.st35{opacity:0.62;fill:url(#SVGID_00000057144419812787391240000002598727656594638268_);}\r\n\t.st36{filter:url(#Adobe_OpacityMaskFilter_00000085949426223816452580000012009920486819819690_);}\r\n\t.st37{filter:url(#Adobe_OpacityMaskFilter_00000080902951914610143080000009145225403213012888_);}\r\n\t\r\n\t\t.st38{mask:url(#SVGID_00000163755496130300923670000013848058383726680450_);fill:url(#SVGID_00000127035414273363749260000003450302047553185666_);}\r\n\t.st39{opacity:0.62;fill:url(#SVGID_00000118379724617464601650000007514418539607495819_);}\r\n\t.st40{fill:#FAB07B;}\r\n\t.st41{filter:url(#Adobe_OpacityMaskFilter_00000150074207028516963640000004533967048098181258_);}\r\n\t.st42{filter:url(#Adobe_OpacityMaskFilter_00000064339425534358600890000013896121515525171123_);}\r\n\t\r\n\t\t.st43{mask:url(#SVGID_00000170997882064365366970000015946442542266502327_);fill:url(#SVGID_00000135677930328421467540000007930605612694650776_);}\r\n\t.st44{opacity:0.38;fill:url(#SVGID_00000061466502212073660340000010941217442491543943_);}\r\n\t.st45{filter:url(#Adobe_OpacityMaskFilter_00000123407965515923190690000004909208237382305959_);}\r\n\t.st46{filter:url(#Adobe_OpacityMaskFilter_00000093157854272543250290000011535204232321206156_);}\r\n\t\r\n\t\t.st47{mask:url(#SVGID_00000103224168434779458770000001940394877738641331_);fill:url(#SVGID_00000043425945730850943010000009577769877799542430_);}\r\n\t.st48{opacity:0.62;fill:url(#SVGID_00000063606369286847885050000004831892627498787519_);}\r\n\t.st49{opacity:0.36;fill:#E05D2B;}\r\n\t.st50{filter:url(#Adobe_OpacityMaskFilter_00000095303723761723341910000017872256010328399788_);}\r\n\t.st51{filter:url(#Adobe_OpacityMaskFilter_00000115511685600472104400000002672163878288221615_);}\r\n\t\r\n\t\t.st52{mask:url(#SVGID_00000109028488518810595150000016085367052827330436_);fill:url(#SVGID_00000170959421479538927510000011418724135630680217_);}\r\n\t.st53{opacity:0.37;fill:url(#SVGID_00000085939169377251526690000011562689390224616122_);}\r\n\t.st54{filter:url(#Adobe_OpacityMaskFilter_00000057842993298818570150000003593182602397421754_);}\r\n\t.st55{filter:url(#Adobe_OpacityMaskFilter_00000133502770895303673030000015905323234158709410_);}\r\n\t\r\n\t\t.st56{mask:url(#SVGID_00000147189222827509665120000002791137170246660759_);fill:url(#SVGID_00000004546853880647761420000016438300580748871337_);}\r\n\t.st57{opacity:0.59;fill:url(#SVGID_00000017501168423266278540000013578731519106646415_);}\r\n\t.st58{fill:#F6F5F7;}\r\n\t.st59{filter:url(#Adobe_OpacityMaskFilter_00000021827064329930277080000001612753847292011421_);}\r\n\t.st60{filter:url(#Adobe_OpacityMaskFilter_00000048467120366982603630000004464261307280565929_);}\r\n\t\r\n\t\t.st61{mask:url(#SVGID_00000087394257411040767780000000432059742136887705_);fill:url(#SVGID_00000034079125881043730920000005480453655889044374_);}\r\n\t.st62{fill:url(#SVGID_00000151514675940580314390000004249433529538302389_);}\r\n\t.st63{filter:url(#Adobe_OpacityMaskFilter_00000145042028412123084380000001104389075061747350_);}\r\n\t.st64{filter:url(#Adobe_OpacityMaskFilter_00000114758623650126179610000009240141799043011503_);}\r\n\t\r\n\t\t.st65{mask:url(#SVGID_00000047057278014728756950000007463954689841955999_);fill:url(#SVGID_00000128479651453974539380000011769923505412599455_);}\r\n\t.st66{opacity:0.37;fill:url(#SVGID_00000034055115070467161490000015323751356130388893_);}\r\n\t.st67{opacity:0.21;fill:#E05D2B;}\r\n\t.st68{filter:url(#Adobe_OpacityMaskFilter_00000173874387156203380070000000571452348852973231_);}\r\n\t.st69{filter:url(#Adobe_OpacityMaskFilter_00000083806481915334583700000016150193490743162543_);}\r\n\t\r\n\t\t.st70{mask:url(#SVGID_00000020378428792626130900000014232185341203826347_);fill:url(#SVGID_00000081645139119490852430000008128427391767484566_);}\r\n\t.st71{opacity:0.43;fill:url(#SVGID_00000071544012172473422600000017733468018282651028_);}\r\n\t.st72{opacity:0.48;}\r\n\t.st73{filter:url(#Adobe_OpacityMaskFilter_00000012456163665659693800000002853042074765380781_);}\r\n\t.st74{filter:url(#Adobe_OpacityMaskFilter_00000008136388577457761030000002802134423722128308_);}\r\n\t\r\n\t\t.st75{mask:url(#SVGID_00000044865043454363169170000015264491578156897213_);fill:url(#SVGID_00000005224757565904403890000014820217694802643895_);}\r\n\t.st76{fill:url(#SVGID_00000068651228058541888370000002487431343482211986_);}\r\n\t.st77{filter:url(#Adobe_OpacityMaskFilter_00000162328949285194420070000014204696591453370549_);}\r\n\t.st78{filter:url(#Adobe_OpacityMaskFilter_00000105412388493690501750000001082865108204744068_);}\r\n\t\r\n\t\t.st79{mask:url(#SVGID_00000063599373341595775980000007055796256586043780_);fill:url(#SVGID_00000103245553775804537830000004681644955625252024_);}\r\n\t.st80{opacity:0.42;fill:url(#SVGID_00000029004577888050497200000017144796984508151180_);}\r\n\t.st81{filter:url(#Adobe_OpacityMaskFilter_00000167395761571300788800000004467893963429337735_);}\r\n\t.st82{filter:url(#Adobe_OpacityMaskFilter_00000121263315579652245700000016402956663650392984_);}\r\n\t\r\n\t\t.st83{mask:url(#SVGID_00000132086222969268205570000011127024333605487530_);fill:url(#SVGID_00000116936768628284372500000000639958211769548679_);}\r\n\t.st84{opacity:0.68;fill:url(#SVGID_00000084504189445091226730000013959299588146732456_);}\r\n\t.st85{filter:url(#Adobe_OpacityMaskFilter_00000112630081861834811080000001007603470027163566_);}\r\n\t.st86{filter:url(#Adobe_OpacityMaskFilter_00000111905808041854299080000017634036716653181082_);}\r\n\t\r\n\t\t.st87{mask:url(#SVGID_00000075841546478409283460000014203519687972975783_);fill:url(#SVGID_00000069363465625889793670000006065034416082372022_);}\r\n\t.st88{fill:url(#SVGID_00000048476996086389797210000014420922938401798786_);}\r\n\t.st89{fill:url(#SVGID_00000000211877875722409790000000401579380630633374_);}\r\n\t.st90{fill:#DD4C35;}\r\n\t.st91{fill:#8B1325;}\r\n\t.st92{fill:#2D0200;}\r\n\t.st93{fill:#BF3E2E;}\r\n\t.st94{fill:#BD3829;}\r\n\t.st95{fill:#BB3123;}\r\n\t.st96{fill:#B92B1E;}\r\n\t.st97{fill:#B72418;}\r\n\t.st98{fill:url(#SVGID_00000155132257648755059450000004025717259839409594_);}\r\n\t.st99{fill:#FFFFFF;}\r\n\t.st100{fill:#F4F6F7;}\r\n\t.st101{fill:#D7DADB;}\r\n\t.st102{opacity:0.48;fill:#A6B2C6;}\r\n\t.st103{fill:#5D7F94;}\r\n\t.st104{fill:#2B566B;}\r\n\t.st105{fill:#FAC890;}\r\n\t.st106{fill:#455057;}\r\n\t.st107{filter:url(#Adobe_OpacityMaskFilter_00000132088890761739492790000015410191829882308245_);}\r\n\t.st108{filter:url(#Adobe_OpacityMaskFilter_00000079447462518966759950000015593371712354874244_);}\r\n\t\r\n\t\t.st109{mask:url(#SVGID_00000009566306396267353200000018243333817872944295_);fill:url(#SVGID_00000127032978425465090370000000831430379509762966_);}\r\n\t.st110{opacity:0.4;fill:url(#SVGID_00000023985089987899504010000001855479506019324808_);}\r\n\t.st111{opacity:0.2;fill:#FFFFFF;}\r\n\t.st112{opacity:0.48;fill:#FFFFFF;}\r\n\t.st113{fill:#0D0000;}\r\n\t.st114{filter:url(#Adobe_OpacityMaskFilter_00000060720110820866472660000001518492181069868212_);}\r\n\t.st115{filter:url(#Adobe_OpacityMaskFilter_00000101083399850045990560000011900989906549998978_);}\r\n\t\r\n\t\t.st116{mask:url(#SVGID_00000074435558024963013440000005311057004255659916_);fill:url(#SVGID_00000012460134297969941850000014720391798956107452_);}\r\n\t.st117{fill:url(#SVGID_00000111886412520312830960000004775664353642592413_);}\r\n\t.st118{filter:url(#Adobe_OpacityMaskFilter_00000036947291198614773200000014714996008751262604_);}\r\n\t.st119{filter:url(#Adobe_OpacityMaskFilter_00000147940149883625182740000012578386784631847844_);}\r\n\t\r\n\t\t.st120{mask:url(#SVGID_00000109009425966384701160000017395159118356706448_);fill:url(#SVGID_00000003811745936689349140000013396746133002293384_);}\r\n\t.st121{fill:url(#SVGID_00000054965125500679315660000003389554888397437629_);}\r\n\t.st122{filter:url(#Adobe_OpacityMaskFilter_00000040558948398772639960000003839508679387274371_);}\r\n\t.st123{filter:url(#Adobe_OpacityMaskFilter_00000064344651681756512400000008718659667727073199_);}\r\n\t\r\n\t\t.st124{mask:url(#SVGID_00000139265781912016149010000002098322065236993701_);fill:url(#SVGID_00000098939654099946241250000014984823084940279483_);}\r\n\t.st125{fill:url(#SVGID_00000017488328932374098960000014923754624993019801_);}\r\n\t.st126{filter:url(#Adobe_OpacityMaskFilter_00000010307850171614578840000014508161717716763028_);}\r\n\t.st127{filter:url(#Adobe_OpacityMaskFilter_00000181080669416103164640000007534454911589628833_);}\r\n\t\r\n\t\t.st128{mask:url(#SVGID_00000000199272235427840470000012847622427535896723_);fill:url(#SVGID_00000018946135263671470520000017376625887248584590_);}\r\n\t.st129{fill:url(#SVGID_00000171714144087607925740000016736825514742209980_);}\r\n\t.st130{filter:url(#Adobe_OpacityMaskFilter_00000088099722517440553650000004816051519816594067_);}\r\n\t.st131{filter:url(#Adobe_OpacityMaskFilter_00000067200698914884968160000009595289242032440970_);}\r\n\t\r\n\t\t.st132{mask:url(#SVGID_00000165941060084146537970000004524298383285180602_);fill:url(#SVGID_00000101104225598987902240000002821253955992615049_);}\r\n\t.st133{fill:url(#SVGID_00000082361993737046516170000018015036074740506301_);}\r\n\t.st134{filter:url(#Adobe_OpacityMaskFilter_00000034792380789943244580000001422889396497228192_);}\r\n\t.st135{filter:url(#Adobe_OpacityMaskFilter_00000111901313646246898440000001891347090552784256_);}\r\n\t\r\n\t\t.st136{mask:url(#SVGID_00000132080233505722949820000002220261162628904628_);fill:url(#SVGID_00000073715326797072053790000018252854010211939207_);}\r\n\t.st137{fill:url(#SVGID_00000181051276572364410660000011602911118492742076_);}\r\n\t.st138{fill:#A63345;}\r\n\t.st139{filter:url(#Adobe_OpacityMaskFilter_00000011723131875349137120000000188758153980918657_);}\r\n\t.st140{filter:url(#Adobe_OpacityMaskFilter_00000183218970771550739950000015522335294067049384_);}\r\n\t\r\n\t\t.st141{mask:url(#SVGID_00000105394706453980004250000000923347134225243561_);fill:url(#SVGID_00000071530945101487377630000005418532055722178738_);}\r\n\t.st142{fill:url(#SVGID_00000148629513560089037300000007925046495940002988_);}\r\n\t.st143{filter:url(#Adobe_OpacityMaskFilter_00000019649383950927994740000007181221480366292412_);}\r\n\t.st144{filter:url(#Adobe_OpacityMaskFilter_00000098909934347723360790000010451377320538809255_);}\r\n\t\r\n\t\t.st145{mask:url(#SVGID_00000060750273741214154210000001311296539934955665_);fill:url(#SVGID_00000020361007213554658990000004921637993096722622_);}\r\n\t.st146{opacity:0.62;fill:url(#SVGID_00000132766799747709802480000005082708058352016791_);}\r\n\t.st147{fill:#425666;}\r\n\t.st148{fill:#D4DFED;}\r\n\t.st149{filter:url(#Adobe_OpacityMaskFilter_00000161594753612388923020000016217241532179283077_);}\r\n\t.st150{filter:url(#Adobe_OpacityMaskFilter_00000174599963484210525620000007171550840275912882_);}\r\n\t\r\n\t\t.st151{mask:url(#SVGID_00000150788582450423123050000011839899786861387935_);fill:url(#SVGID_00000180364435510363528430000013020315452856448133_);}\r\n\t.st152{opacity:0.65;fill:url(#SVGID_00000015348555884198768960000004130355932555746723_);}\r\n\t.st153{filter:url(#Adobe_OpacityMaskFilter_00000137818298871841550600000003500366543857102264_);}\r\n\t.st154{filter:url(#Adobe_OpacityMaskFilter_00000021811382198146439070000006833372638608543921_);}\r\n\t\r\n\t\t.st155{mask:url(#SVGID_00000152970229313527410530000016880728433030058411_);fill:url(#SVGID_00000178171256634732431780000014176946909244869032_);}\r\n\t.st156{fill:url(#SVGID_00000082346947993294936260000002863350493343584907_);}\r\n\t.st157{fill:#F5F5F5;}\r\n\t.st158{filter:url(#Adobe_OpacityMaskFilter_00000007410533927699577870000015895434858627988138_);}\r\n\t.st159{filter:url(#Adobe_OpacityMaskFilter_00000135667608019596224570000014817198355492682171_);}\r\n\t\r\n\t\t.st160{mask:url(#SVGID_00000070828842855045573260000006114772601651020714_);fill:url(#SVGID_00000120543564278180576310000016699867428377021588_);}\r\n\t.st161{fill:url(#SVGID_00000106106044875047940780000017922370413899440305_);}\r\n\t.st162{filter:url(#Adobe_OpacityMaskFilter_00000056389538277573927270000018113379534191557805_);}\r\n\t.st163{filter:url(#Adobe_OpacityMaskFilter_00000113327185697407087110000007164134255539877001_);}\r\n\t\r\n\t\t.st164{mask:url(#SVGID_00000118354976238484733130000000638453697328994725_);fill:url(#SVGID_00000087408409735938644340000013942848320695995550_);}\r\n\t.st165{fill:url(#SVGID_00000058582308824522732910000016739456157762885007_);}\r\n\t.st166{filter:url(#Adobe_OpacityMaskFilter_00000065057060360196365190000016328904989247404705_);}\r\n\t.st167{filter:url(#Adobe_OpacityMaskFilter_00000132072380212618331680000001492518030352640659_);}\r\n\t\r\n\t\t.st168{mask:url(#SVGID_00000182493215554455074660000017759177063354221757_);fill:url(#SVGID_00000075160782497302186880000001627112538865798786_);}\r\n\t.st169{fill:url(#SVGID_00000183238016644087142090000003634752793581541556_);}\r\n\t.st170{filter:url(#Adobe_OpacityMaskFilter_00000009563588372974688840000000189857532862182041_);}\r\n\t.st171{filter:url(#Adobe_OpacityMaskFilter_00000036965190883787037420000008538803663542678194_);}\r\n\t\r\n\t\t.st172{mask:url(#SVGID_00000181083538566928910800000000897979325698197389_);fill:url(#SVGID_00000116914916891575261020000015611000436348804765_);}\r\n\t.st173{fill:url(#SVGID_00000090283421679477874700000007585077355362247868_);}\r\n\t.st174{filter:url(#Adobe_OpacityMaskFilter_00000139252682393875619360000015374586801081407136_);}\r\n\t.st175{filter:url(#Adobe_OpacityMaskFilter_00000070077725609569344400000002454961023157386161_);}\r\n\t\r\n\t\t.st176{mask:url(#SVGID_00000067921576782193685610000012533174946916979631_);fill:url(#SVGID_00000133490605271841656830000013086124338900571318_);}\r\n\t.st177{fill:url(#SVGID_00000150064402271396726590000007958138024046565504_);}\r\n\t.st178{filter:url(#Adobe_OpacityMaskFilter_00000161593069742446502490000015312366354960543641_);}\r\n\t.st179{filter:url(#Adobe_OpacityMaskFilter_00000181805923609087786920000001258345258194960550_);}\r\n\t\r\n\t\t.st180{mask:url(#SVGID_00000176726413356140243510000009042338078855374755_);fill:url(#SVGID_00000126320630403750543990000002069063546050830465_);}\r\n\t.st181{fill:url(#SVGID_00000062169507096332423770000009265525900352147367_);}\r\n\t.st182{filter:url(#Adobe_OpacityMaskFilter_00000078025483795794077710000004129651778290986888_);}\r\n\t.st183{filter:url(#Adobe_OpacityMaskFilter_00000045610919126087473470000010601372616604922543_);}\r\n\t\r\n\t\t.st184{mask:url(#SVGID_00000072997540550791685190000009990519603117088438_);fill:url(#SVGID_00000179621156312164340570000000703223057213157798_);}\r\n\t.st185{opacity:0.34;fill:url(#SVGID_00000101793476697793003290000017980785293995635852_);}\r\n\t.st186{fill:#D34035;}\r\n\t.st187{opacity:0.6;}\r\n\t.st188{opacity:0.6;fill:#FFFFFF;}\r\n\t.st189{filter:url(#Adobe_OpacityMaskFilter_00000148661763930839558880000017731599380634837377_);}\r\n\t.st190{filter:url(#Adobe_OpacityMaskFilter_00000140008238891046364140000008118246127536388272_);}\r\n\t\r\n\t\t.st191{mask:url(#SVGID_00000003792763671927857790000000873252126248292751_);fill:url(#SVGID_00000021811751244300728990000012486811867388393393_);}\r\n\t.st192{opacity:0.61;fill:url(#SVGID_00000168087469749818909260000002010570424529809319_);}\r\n\t.st193{filter:url(#Adobe_OpacityMaskFilter_00000072257658599209881580000008380310695112474798_);}\r\n\t.st194{filter:url(#Adobe_OpacityMaskFilter_00000045584531772766402140000002358041940378710940_);}\r\n\t\r\n\t\t.st195{mask:url(#SVGID_00000172433555719506947240000007976898395531271334_);fill:url(#SVGID_00000001663648512931636270000002405704948961634187_);}\r\n\t.st196{opacity:0.62;fill:url(#SVGID_00000157275335323173713850000014458701821128762500_);}\r\n\t.st197{filter:url(#Adobe_OpacityMaskFilter_00000105387162091935665640000002545937033146112176_);}\r\n\t.st198{filter:url(#Adobe_OpacityMaskFilter_00000133518846990603576500000009117912436585387400_);}\r\n\t\r\n\t\t.st199{mask:url(#SVGID_00000063623390441051766810000005997331359495399070_);fill:url(#SVGID_00000090258617286859882770000010044238422654154682_);}\r\n\t.st200{opacity:0.33;fill:url(#SVGID_00000178172886590330773410000012013583706028809394_);}\r\n\t.st201{fill:#C13600;}\r\n\t.st202{filter:url(#Adobe_OpacityMaskFilter_00000062188682095665463090000015810919970978973105_);}\r\n\t.st203{filter:url(#Adobe_OpacityMaskFilter_00000011019811843136196480000014701008776434587324_);}\r\n\t\r\n\t\t.st204{mask:url(#SVGID_00000132066243673460287250000006857472760751063986_);fill:url(#SVGID_00000115476477951153426950000017236602230821203378_);}\r\n\t.st205{fill:url(#SVGID_00000090285584734090679260000010743089664752373935_);}\r\n\t.st206{filter:url(#Adobe_OpacityMaskFilter_00000147935284007622554920000008610291484409205689_);}\r\n\t.st207{filter:url(#Adobe_OpacityMaskFilter_00000039821357654133783740000003877838046572898950_);}\r\n\t\r\n\t\t.st208{mask:url(#SVGID_00000136396465320595617180000009548897300780565153_);fill:url(#SVGID_00000034802669682338553050000015669829578443807145_);}\r\n\t.st209{fill:url(#SVGID_00000160191910477881316180000012535717461545248191_);}\r\n\t.st210{filter:url(#Adobe_OpacityMaskFilter_00000067225389397895912750000009719871739641188249_);}\r\n\t.st211{filter:url(#Adobe_OpacityMaskFilter_00000171680385185261309300000014891211204195056280_);}\r\n\t\r\n\t\t.st212{mask:url(#SVGID_00000183226964080501802080000004366653699711283362_);fill:url(#SVGID_00000024713948283772433720000014534857237441254329_);}\r\n\t.st213{fill:url(#SVGID_00000039125616008918672630000017987228262203834776_);}\r\n\t.st214{filter:url(#Adobe_OpacityMaskFilter_00000136404458961486121430000007127452551747320211_);}\r\n\t.st215{filter:url(#Adobe_OpacityMaskFilter_00000034792412665292375340000010256272449742667453_);}\r\n\t\r\n\t\t.st216{mask:url(#SVGID_00000114047664424255099780000008015753091948829620_);fill:url(#SVGID_00000124162833388597839210000010327538231451590575_);}\r\n\t.st217{fill:url(#SVGID_00000021826477044486423540000014307991899623549104_);}\r\n\t.st218{filter:url(#Adobe_OpacityMaskFilter_00000056418521592871423150000003989147228675728555_);}\r\n\t.st219{filter:url(#Adobe_OpacityMaskFilter_00000176020736619058893590000003881261298091038126_);}\r\n\t\r\n\t\t.st220{mask:url(#SVGID_00000023257663593444064570000013055306853898795424_);fill:url(#SVGID_00000134250326909515279300000013804003061537173400_);}\r\n\t.st221{fill:url(#SVGID_00000059281536006042653810000011636475664401937814_);}\r\n\t.st222{filter:url(#Adobe_OpacityMaskFilter_00000141429039205157766080000005053365929991014019_);}\r\n\t.st223{filter:url(#Adobe_OpacityMaskFilter_00000109020016002581378840000003362375963894448049_);}\r\n\t\r\n\t\t.st224{mask:url(#SVGID_00000155115844060966770110000006430837158106580889_);fill:url(#SVGID_00000063597950556020854680000009399237761550662546_);}\r\n\t.st225{fill:url(#SVGID_00000044879186349832032690000010526207258845670319_);}\r\n\t.st226{filter:url(#Adobe_OpacityMaskFilter_00000072974248419148476630000011267158046510839693_);}\r\n\t.st227{filter:url(#Adobe_OpacityMaskFilter_00000025413527772973569890000011186349021693310605_);}\r\n\t\r\n\t\t.st228{mask:url(#SVGID_00000159470337784668616030000006876389144402474881_);fill:url(#SVGID_00000111876715354881294810000006262221059525376128_);}\r\n\t.st229{fill:url(#SVGID_00000145768821263037723840000012785235840654768306_);}\r\n\t.st230{filter:url(#Adobe_OpacityMaskFilter_00000054235811965530417780000013353459649974302339_);}\r\n\t.st231{filter:url(#Adobe_OpacityMaskFilter_00000016039124394694096220000003228995838512880014_);}\r\n\t\r\n\t\t.st232{mask:url(#SVGID_00000013159869311307418130000011280609412808654236_);fill:url(#SVGID_00000091712636455446265190000008137550161429020821_);}\r\n\t.st233{fill:url(#SVGID_00000013168026162126599690000013593033631676151223_);}\r\n\t.st234{filter:url(#Adobe_OpacityMaskFilter_00000125593247222866123040000016361751072002694063_);}\r\n\t.st235{filter:url(#Adobe_OpacityMaskFilter_00000117673844918517169200000016795557686848147362_);}\r\n\t\r\n\t\t.st236{mask:url(#SVGID_00000129205539205956411980000003924239016787052466_);fill:url(#SVGID_00000128450568574613000130000014925339542576525712_);}\r\n\t.st237{fill:url(#SVGID_00000013154713173021209370000001591575939355109024_);}\r\n\t.st238{fill:#BCC9DD;}\r\n\t.st239{fill:#8B9EB9;}\r\n\t.st240{filter:url(#Adobe_OpacityMaskFilter_00000101784018491837535400000008749382147910053012_);}\r\n\t.st241{filter:url(#Adobe_OpacityMaskFilter_00000137122408076398680420000003505629021541902266_);}\r\n\t\r\n\t\t.st242{mask:url(#SVGID_00000018948934325441449050000014951888689954028949_);fill:url(#SVGID_00000040540141746557411000000014724670831623402382_);}\r\n\t.st243{opacity:0.79;fill:url(#SVGID_00000138551836021404976590000001482034459971225770_);}\r\n\t.st244{fill:#BFD0D8;}\r\n\t.st245{filter:url(#Adobe_OpacityMaskFilter_00000183941589315814843400000017356076624192441263_);}\r\n\t.st246{filter:url(#Adobe_OpacityMaskFilter_00000144335810979614945790000005316736326924015772_);}\r\n\t\r\n\t\t.st247{mask:url(#SVGID_00000103255077471145910730000017489760985887045005_);fill:url(#SVGID_00000030473261779627633790000009701035977424918709_);}\r\n\t.st248{fill:url(#SVGID_00000039117633152833696320000013665579955986054300_);}\r\n\t.st249{filter:url(#Adobe_OpacityMaskFilter_00000179632172026874477990000003145555806989196460_);}\r\n\t.st250{filter:url(#Adobe_OpacityMaskFilter_00000010294698999802283320000018399972216578333606_);}\r\n\t\r\n\t\t.st251{mask:url(#SVGID_00000053534600794573490730000013398421989922245797_);fill:url(#SVGID_00000152956733313413634950000006570259462165949329_);}\r\n\t.st252{opacity:0.53;fill:url(#SVGID_00000133492966991780367460000005153744811883072398_);}\r\n\t.st253{filter:url(#Adobe_OpacityMaskFilter_00000177473663423477693060000004394273221231583627_);}\r\n\t.st254{filter:url(#Adobe_OpacityMaskFilter_00000182500846439419893600000001292826550610537125_);}\r\n\t\r\n\t\t.st255{mask:url(#SVGID_00000121269953906709440480000008051513611772816797_);fill:url(#SVGID_00000043431194742118734050000004354448064034050450_);}\r\n\t.st256{opacity:0.7;fill:url(#SVGID_00000023961611935025056910000004886767545684707252_);}\r\n\t.st257{fill:#F3F5F4;}\r\n\t.st258{filter:url(#Adobe_OpacityMaskFilter_00000114064198614698838670000009240216617930601110_);}\r\n\t.st259{filter:url(#Adobe_OpacityMaskFilter_00000134968776383120797520000008362239150701584060_);}\r\n\t\r\n\t\t.st260{mask:url(#SVGID_00000095313533676432587330000017719277742863242684_);fill:url(#SVGID_00000158716500552359246110000002427196433970661817_);}\r\n\t.st261{fill:url(#SVGID_00000133511602215171182210000000221660171599405709_);}\r\n\t.st262{filter:url(#Adobe_OpacityMaskFilter_00000153673257593460733410000005512138018788917645_);}\r\n\t.st263{filter:url(#Adobe_OpacityMaskFilter_00000005232139307299202630000003458797658075824536_);}\r\n\t\r\n\t\t.st264{mask:url(#SVGID_00000138568995801762693390000007514148568022697904_);fill:url(#SVGID_00000051379202849052833210000008028950993208409020_);}\r\n\t.st265{fill:url(#SVGID_00000180331155606931981750000004460967897809358985_);}\r\n\t.st266{filter:url(#Adobe_OpacityMaskFilter_00000123412639811694981770000009516420075939100558_);}\r\n\t.st267{filter:url(#Adobe_OpacityMaskFilter_00000124862239254641648050000007772388531783657373_);}\r\n\t\r\n\t\t.st268{mask:url(#SVGID_00000154422192219251712150000006612784372326338977_);fill:url(#SVGID_00000007405156910288818530000014389151311427611022_);}\r\n\t.st269{fill:url(#SVGID_00000099661951586381491660000007445542550014219909_);}\r\n\t.st270{filter:url(#Adobe_OpacityMaskFilter_00000064337848210033334570000012898415193561138583_);}\r\n\t.st271{filter:url(#Adobe_OpacityMaskFilter_00000173864832471690099120000008577825757769995436_);}\r\n\t\r\n\t\t.st272{mask:url(#SVGID_00000177463674898584151310000012231248350142220987_);fill:url(#SVGID_00000055691140447142886440000003450369395995793333_);}\r\n\t.st273{fill:url(#SVGID_00000026877507207898515160000011960428001601348232_);}\r\n\t.st274{filter:url(#Adobe_OpacityMaskFilter_00000134940790426144436220000017896816736039345560_);}\r\n\t.st275{filter:url(#Adobe_OpacityMaskFilter_00000119112132803108459680000006882524457849865396_);}\r\n\t\r\n\t\t.st276{mask:url(#SVGID_00000061463436450568129130000012434569059099521980_);fill:url(#SVGID_00000055678167437181273300000012436821877436412035_);}\r\n\t.st277{fill:url(#SVGID_00000176002751519859368450000012124533340709546393_);}\r\n\t.st278{filter:url(#Adobe_OpacityMaskFilter_00000118376576575373059320000015825548315787616152_);}\r\n\t.st279{filter:url(#Adobe_OpacityMaskFilter_00000039126060873984207520000002411355319770673310_);}\r\n\t\r\n\t\t.st280{mask:url(#SVGID_00000080887810648140947410000002688871726759256494_);fill:url(#SVGID_00000135666153894584526470000014352272359794591117_);}\r\n\t.st281{fill:url(#SVGID_00000140705395371871778180000016820508285334263735_);}\r\n\t.st282{filter:url(#Adobe_OpacityMaskFilter_00000103260849004994321560000003239501771987950478_);}\r\n\t.st283{filter:url(#Adobe_OpacityMaskFilter_00000031165009340491409330000015010402336360816276_);}\r\n\t\r\n\t\t.st284{mask:url(#SVGID_00000032642384650305623850000015410118964573672328_);fill:url(#SVGID_00000023260298000946071140000004312818234801531032_);}\r\n\t.st285{fill:url(#SVGID_00000102543678672419912490000001529039046481367464_);}\r\n\t.st286{filter:url(#Adobe_OpacityMaskFilter_00000183226935741767786400000017114423510699789195_);}\r\n\t.st287{filter:url(#Adobe_OpacityMaskFilter_00000011733945340101451080000013147688655217595535_);}\r\n\t\r\n\t\t.st288{mask:url(#SVGID_00000142155071601670301750000007003972719536416410_);fill:url(#SVGID_00000040535911873488793890000015455642805591021703_);}\r\n\t.st289{fill:url(#SVGID_00000169550103608093768170000008140619236835993732_);}\r\n\t.st290{filter:url(#Adobe_OpacityMaskFilter_00000064322839709417577470000001876772286804289970_);}\r\n\t.st291{filter:url(#Adobe_OpacityMaskFilter_00000116202680264570807040000007524394759159141776_);}\r\n\t\r\n\t\t.st292{mask:url(#SVGID_00000003786051963591924840000008335230489291556262_);fill:url(#SVGID_00000071528806958222518640000007671678934214723217_);}\r\n\t.st293{fill:url(#SVGID_00000037664799218978957350000003128643152937577889_);}\r\n\t.st294{filter:url(#Adobe_OpacityMaskFilter_00000010310420265768521740000005830506888541295774_);}\r\n\t.st295{filter:url(#Adobe_OpacityMaskFilter_00000026120919293536677030000015231143550289358223_);}\r\n\t\r\n\t\t.st296{mask:url(#SVGID_00000132809206749977826950000011577576451606192523_);fill:url(#SVGID_00000164502423563225825120000012644860580082050963_);}\r\n\t.st297{fill:url(#SVGID_00000013175136649707358850000001044599107511099575_);}\r\n\t.st298{filter:url(#Adobe_OpacityMaskFilter_00000165945991916019685020000012787178240301158535_);}\r\n\t.st299{filter:url(#Adobe_OpacityMaskFilter_00000132772743315760535730000001293325104196721282_);}\r\n\t\r\n\t\t.st300{mask:url(#SVGID_00000016054326211310210320000010245988353823677589_);fill:url(#SVGID_00000168828856661230991250000015495521768897834653_);}\r\n\t.st301{fill:url(#SVGID_00000133519652037769483920000017199620788916699838_);}\r\n\t.st302{filter:url(#Adobe_OpacityMaskFilter_00000094596118497823630710000011914228413216843922_);}\r\n\t.st303{filter:url(#Adobe_OpacityMaskFilter_00000165196907924761638620000011051683410229497729_);}\r\n\t\r\n\t\t.st304{mask:url(#SVGID_00000157305117112572654220000008471745039147535516_);fill:url(#SVGID_00000152955077059787928690000002877081778947483281_);}\r\n\t.st305{fill:url(#SVGID_00000130647384671907338490000001395809095560877192_);}\r\n\t.st306{filter:url(#Adobe_OpacityMaskFilter_00000067948774894696264320000006382111908305966227_);}\r\n\t.st307{filter:url(#Adobe_OpacityMaskFilter_00000006683548448506321460000013546872946670175154_);}\r\n\t\r\n\t\t.st308{mask:url(#SVGID_00000011715148219829458770000003243752530886060461_);fill:url(#SVGID_00000157291947235197065500000014590264455779120514_);}\r\n\t.st309{fill:url(#SVGID_00000017513014679334924610000000952503907554850466_);}\r\n\t.st310{filter:url(#Adobe_OpacityMaskFilter_00000150812218349604136150000007113550631620123045_);}\r\n\t.st311{filter:url(#Adobe_OpacityMaskFilter_00000124871116323754420870000007858200976069004208_);}\r\n\t\r\n\t\t.st312{mask:url(#SVGID_00000024682943113391215200000008315255094081985925_);fill:url(#SVGID_00000082344809313246057340000015693109571407463587_);}\r\n\t.st313{fill:url(#SVGID_00000014603720342444508700000004434494034192641942_);}\r\n\t.st314{filter:url(#Adobe_OpacityMaskFilter_00000062889843076561940560000011229476350454467224_);}\r\n\t.st315{filter:url(#Adobe_OpacityMaskFilter_00000168807013097670668200000006217822063970138029_);}\r\n\t\r\n\t\t.st316{mask:url(#SVGID_00000046300348560718029690000001087918144370974096_);fill:url(#SVGID_00000111174631269985201360000004698657665692515203_);}\r\n\t.st317{fill:url(#SVGID_00000018238315772702651300000015329588095784505731_);}\r\n\t.st318{filter:url(#Adobe_OpacityMaskFilter_00000129168407588332132880000001210484204239264936_);}\r\n\t.st319{filter:url(#Adobe_OpacityMaskFilter_00000091731229525713308540000012676772457808951451_);}\r\n\t\r\n\t\t.st320{mask:url(#SVGID_00000073000940682493842260000008242714673929338802_);fill:url(#SVGID_00000101084738584859075220000010726578282106458799_);}\r\n\t.st321{fill:url(#SVGID_00000085936853290899853990000009521822267406149769_);}\r\n\t.st322{filter:url(#Adobe_OpacityMaskFilter_00000173127048906801085950000005758650299982338972_);}\r\n\t.st323{filter:url(#Adobe_OpacityMaskFilter_00000129889753108361975980000008038093563268938904_);}\r\n\t\r\n\t\t.st324{mask:url(#SVGID_00000140704650227397278200000002225739095994801558_);fill:url(#SVGID_00000139986530878291990200000007125495147388398521_);}\r\n\t.st325{fill:url(#SVGID_00000074415073109793736020000014266815120706395016_);}\r\n\t.st326{filter:url(#Adobe_OpacityMaskFilter_00000062172535956900984750000015152752940083633799_);}\r\n\t.st327{filter:url(#Adobe_OpacityMaskFilter_00000026150467323337057520000007923832568575675802_);}\r\n\t\r\n\t\t.st328{mask:url(#SVGID_00000100349850819165585510000015657504349147708086_);fill:url(#SVGID_00000051364079203131485160000007106667097035937458_);}\r\n\t.st329{fill:url(#SVGID_00000133528376798722671670000008033770787264926901_);}\r\n\t.st330{filter:url(#Adobe_OpacityMaskFilter_00000113349007116428375570000007117319510768092310_);}\r\n\t.st331{filter:url(#Adobe_OpacityMaskFilter_00000023254429531358532320000009145597281281570217_);}\r\n\t\r\n\t\t.st332{mask:url(#SVGID_00000052786157555187801490000007260109998199560352_);fill:url(#SVGID_00000157996060020445376660000016419568930957358251_);}\r\n\t.st333{fill:url(#SVGID_00000147937076512227840550000001003111668046696845_);}\r\n\t.st334{filter:url(#Adobe_OpacityMaskFilter_00000068641099630303552070000013638341238653268670_);}\r\n\t.st335{filter:url(#Adobe_OpacityMaskFilter_00000064349445417999312600000004692258095701748622_);}\r\n\t\r\n\t\t.st336{mask:url(#SVGID_00000048461485950307807590000001813746097868830634_);fill:url(#SVGID_00000002358433597797377680000015863042511104612758_);}\r\n\t.st337{fill:url(#SVGID_00000105423807618148467910000010939738187735797657_);}\r\n\t.st338{filter:url(#Adobe_OpacityMaskFilter_00000080175938398511616930000017194375864013974712_);}\r\n\t.st339{filter:url(#Adobe_OpacityMaskFilter_00000147205566608645707000000013556306995820546985_);}\r\n\t\r\n\t\t.st340{mask:url(#SVGID_00000060025047173900368610000011333506004235754907_);fill:url(#SVGID_00000119819781153752993770000000090519231688828043_);}\r\n\t.st341{fill:url(#SVGID_00000023996183529212443120000005937456628640869305_);}\r\n\t.st342{filter:url(#Adobe_OpacityMaskFilter_00000130616220186448944610000011831465694961693569_);}\r\n\t.st343{filter:url(#Adobe_OpacityMaskFilter_00000165951669743330543200000016817573032106084535_);}\r\n\t\r\n\t\t.st344{mask:url(#SVGID_00000062903526053411745310000006959828396697458581_);fill:url(#SVGID_00000040532763220419260430000011830714231951186341_);}\r\n\t.st345{fill:url(#SVGID_00000118362923628943791520000002275463230565250450_);}\r\n\t.st346{filter:url(#Adobe_OpacityMaskFilter_00000135652419881266272040000017989546779242349978_);}\r\n\t.st347{filter:url(#Adobe_OpacityMaskFilter_00000079483894685098967320000004537751440218672277_);}\r\n\t\r\n\t\t.st348{mask:url(#SVGID_00000018216041389166331690000017671915377255501992_);fill:url(#SVGID_00000045577824315011196180000000334912086038866565_);}\r\n\t.st349{fill:url(#SVGID_00000142174612419655594710000012751878964048679869_);}\r\n\t.st350{filter:url(#Adobe_OpacityMaskFilter_00000004507861888937623120000015602565339242921352_);}\r\n\t.st351{filter:url(#Adobe_OpacityMaskFilter_00000114031355265982349240000007352456253659299456_);}\r\n\t\r\n\t\t.st352{mask:url(#SVGID_00000115516645457138656690000010124713987242107784_);fill:url(#SVGID_00000029005544379003274640000000745376037739129506_);}\r\n\t.st353{fill:url(#SVGID_00000049194688288518604540000013896377129754988959_);}\r\n\t.st354{filter:url(#Adobe_OpacityMaskFilter_00000060728760095385195450000001117022358994341794_);}\r\n\t.st355{filter:url(#Adobe_OpacityMaskFilter_00000011717650667858956940000018375382161130605999_);}\r\n\t\r\n\t\t.st356{mask:url(#SVGID_00000051379664989017659280000011439264309667761571_);fill:url(#SVGID_00000021812022887822596270000002283515047200124833_);}\r\n\t.st357{fill:url(#SVGID_00000169543473488020633470000003395524218741821623_);}\r\n\t.st358{filter:url(#Adobe_OpacityMaskFilter_00000130612595366109415010000007477819017088097720_);}\r\n\t.st359{filter:url(#Adobe_OpacityMaskFilter_00000112632350340133491410000006721717112549762490_);}\r\n\t\r\n\t\t.st360{mask:url(#SVGID_00000067200174296046485790000007526566604281682364_);fill:url(#SVGID_00000113334884806688579610000010183530525190388657_);}\r\n\t.st361{fill:url(#SVGID_00000119829808431913494560000000112200833252212669_);}\r\n\t.st362{filter:url(#Adobe_OpacityMaskFilter_00000173870504905584806520000004042376022611222937_);}\r\n\t.st363{filter:url(#Adobe_OpacityMaskFilter_00000107569952723726238270000003408421731085993642_);}\r\n\t\r\n\t\t.st364{mask:url(#SVGID_00000133496470211873159230000007034287449081469078_);fill:url(#SVGID_00000175302771801787248710000016131879838493129093_);}\r\n\t.st365{opacity:0.7;fill:url(#SVGID_00000061454465695337902840000008104486985143068817_);}\r\n\t.st366{filter:url(#Adobe_OpacityMaskFilter_00000167379163930545752400000012704575338940960395_);}\r\n\t.st367{filter:url(#Adobe_OpacityMaskFilter_00000018918037989461082760000002896344518260273804_);}\r\n\t\r\n\t\t.st368{mask:url(#SVGID_00000042701727869648158680000009742888188489211310_);fill:url(#SVGID_00000153663497151152216470000015621470968180236436_);}\r\n\t.st369{fill:url(#SVGID_00000029019965653000435690000002765977018754046386_);}\r\n\t.st370{filter:url(#Adobe_OpacityMaskFilter_00000157295714701934907550000002798374091596444050_);}\r\n\t.st371{filter:url(#Adobe_OpacityMaskFilter_00000170247493917643596370000016899778119109548684_);}\r\n\t\r\n\t\t.st372{mask:url(#SVGID_00000011747224756218175080000003336296707105545388_);fill:url(#SVGID_00000053531217019687664710000004924430168098925496_);}\r\n\t.st373{fill:url(#SVGID_00000117675454042978805490000004136999623092175782_);}\r\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M315.09,935.87c0,0-72.92-55.87-120.26,18.94c3.79-0.95,16.1-30.3,50.19-14.2c0,0,13.26,22.73-19.89,30.3 c-33.14,7.58-74.81,21.78-61.55,99.43c0,0-6.63-25.57,17.05-40.72c0,0-29.36,75.76,42.61,98.48c0,0-40.72-27.46-17.05-64.39 c0,0-9.47,48.3,34.09,60.61c0,0-9.47-12.31-5.68-23.68c3.79-11.36,75.76,17.05,50.19,46.4c0,0,26.51,6.63,41.67-15.15 c0,0,6.63,15.15-23.67,22.73c0,0,57.76,13.26,77.65-33.14c11.09-25.88,41.67-141.1,41.67-141.1L315.09,935.87z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M380.43,1121.48c9.47-26.52,41.67-141.1,41.67-141.1l-107.01-44.51c0,0-57.02-43.63-102.95-1.99 c-3.61,3.94-7.13,8.45-10.53,13.63c1.27-1.38,2.7-2.81,4.36-4.19c6.9-7.97,20.12-20.01,44.73-8.39c0,0,8.71,14.95-5.68,24.65 c-2.92,4.53-8.75,8.79-19.89,11.34c-14.52,3.32-30.66,7.91-43.12,18.54c-10.04,11.47-16.26,28.61-14.97,54.68 c2.11-4.03,5.16-8.05,9.64-11.67c2.46-3.02,5.57-5.93,9.62-8.53c0,0-22.75,58.95,21.34,88.44c-8.22-11.59-14.24-28.72-1.45-48.66 c0,0-0.77,4.13-0.84,10.19c1.01-5.05,2.98-10.34,6.53-15.88c0,0-7.62,39.5,23.23,56.13c-1.34-4.07-2.06-8.85-0.5-13.52 c0.52-1.56,2.4-2.31,5.05-2.47c0.14-1.07,0.28-2.15,0.63-3.21c3.79-11.36,75.76,17.05,50.19,46.4c0,0,19.17,4.73,34.22-7.24 c0.59-0.73,1.2-1.42,1.76-2.23c0,0,0.04,0.28,0.1,0.67c1.97-1.8,3.86-3.87,5.59-6.36c0,0,2.64,14.31-7.92,20.33 c-0.02,0.04-0.06,0.08-0.08,0.13c15.77-2.81,39.5-8.62,52.91-19.31C378.46,1125.5,379.68,1123.58,380.43,1121.48z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 166.87,
    y: 915.88,
    width: 255.23,
    height: 236.69
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend || (_feBlend = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 166.87,
    y: 915.88,
    width: 255.23,
    height: 236.69,
    id: "SVGID_1_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000114752453023016624040000010368738342579235218_",
    filterUnits: "userSpaceOnUse",
    x: 166.87,
    y: 915.88,
    width: 255.23,
    height: 236.69
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend2 || (_feBlend2 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 166.87,
    y: 915.88,
    width: 255.23,
    height: 236.69,
    id: "SVGID_1_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000114752453023016624040000010368738342579235218_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000020360551622232891520000008776323246288428946_",
    gradientUnits: "userSpaceOnUse",
    x1: 166.8704,
    y1: 1034.2251,
    x2: 465.6583,
    y2: 1034.2251
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2184,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    style: {
      stopColor: "#8B8B8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6147,
    style: {
      stopColor: "#BDBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7781,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9108,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9961,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_1_)",
      fill: "url(#SVGID_00000020360551622232891520000008776323246288428946_)"
    },
    d: "M380.43,1121.48 c9.47-26.52,41.67-141.1,41.67-141.1l-107.01-44.51c0,0-57.02-43.63-102.95-1.99c-3.61,3.94-7.13,8.45-10.53,13.63 c1.27-1.38,2.7-2.81,4.36-4.19c6.9-7.97,20.12-20.01,44.73-8.39c0,0,8.71,14.95-5.68,24.65c-2.92,4.53-8.75,8.79-19.89,11.34 c-14.52,3.32-30.66,7.91-43.12,18.54c-10.04,11.47-16.26,28.61-14.97,54.68c2.11-4.03,5.16-8.05,9.64-11.67 c2.46-3.02,5.57-5.93,9.62-8.53c0,0-22.75,58.95,21.34,88.44c-8.22-11.59-14.24-28.72-1.45-48.66c0,0-0.77,4.13-0.84,10.19 c1.01-5.05,2.98-10.34,6.53-15.88c0,0-7.62,39.5,23.23,56.13c-1.34-4.07-2.06-8.85-0.5-13.52c0.52-1.56,2.4-2.31,5.05-2.47 c0.14-1.07,0.28-2.15,0.63-3.21c3.79-11.36,75.76,17.05,50.19,46.4c0,0,19.17,4.73,34.22-7.24c0.59-0.73,1.2-1.42,1.76-2.23 c0,0,0.04,0.28,0.1,0.67c1.97-1.8,3.86-3.87,5.59-6.36c0,0-2.82,20.12-13.73,26.04c14.68,0.95,29.36,1.42,58.64-24.9 C378.46,1125.5,379.68,1123.58,380.43,1121.48z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034047708756817095550000003521458346110424205_",
    gradientUnits: "userSpaceOnUse",
    x1: 166.8704,
    y1: 1034.2251,
    x2: 465.6583,
    y2: 1034.2251
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2531,
    style: {
      stopColor: "#DEE1E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5702,
    style: {
      stopColor: "#BAC0C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8293,
    style: {
      stopColor: "#A4ACB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9961,
    style: {
      stopColor: "#9CA5B0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000034047708756817095550000003521458346110424205_)"
    },
    d: "M380.43,1121.48 c9.47-26.52,41.67-141.1,41.67-141.1l-107.01-44.51c0,0-57.02-43.63-102.95-1.99c-3.61,3.94-7.13,8.45-10.53,13.63 c1.27-1.38,2.7-2.81,4.36-4.19c6.9-7.97,20.12-20.01,44.73-8.39c0,0,8.71,14.95-5.68,24.65c-2.92,4.53-8.75,8.79-19.89,11.34 c-14.52,3.32-30.66,7.91-43.12,18.54c-10.04,11.47-16.26,28.61-14.97,54.68c2.11-4.03,5.16-8.05,9.64-11.67 c2.46-3.02,5.57-5.93,9.62-8.53c0,0-22.75,58.95,21.34,88.44c-8.22-11.59-14.24-28.72-1.45-48.66c0,0-0.77,4.13-0.84,10.19 c1.01-5.05,2.98-10.34,6.53-15.88c0,0-7.62,39.5,23.23,56.13c-1.34-4.07-2.06-8.85-0.5-13.52c0.52-1.56,2.4-2.31,5.05-2.47 c0.14-1.07,0.28-2.15,0.63-3.21c3.79-11.36,75.76,17.05,50.19,46.4c0,0,19.17,4.73,34.22-7.24c0.59-0.73,1.2-1.42,1.76-2.23 c0,0,0.04,0.28,0.1,0.67c1.97-1.8,3.86-3.87,5.59-6.36c0,0-2.82,20.12-13.73,26.04c14.68,0.95,29.36,1.42,58.64-24.9 C378.46,1125.5,379.68,1123.58,380.43,1121.48z"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M819.89,1170.36c-22.19,21.03-112.73,108.84-122.7,150.35c0,0-93.28-309.08-278.89-322.33 c0,0-35.99,39.77-47.35,90.91c-11.36,51.14-26.51,365.53,344.7,573.86c0,0,45.74-5.62,104.23-32.57v-454.51V1170.36z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000147930575479803288790000010267324086691803298_",
    filterUnits: "userSpaceOnUse",
    x: 383.13,
    y: 1005.02,
    width: 423.44,
    height: 640.77
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend3 || (_feBlend3 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 383.13,
    y: 1005.02,
    width: 423.44,
    height: 640.77,
    id: "SVGID_00000157309983882110668030000016516198685108359816_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000147930575479803288790000010267324086691803298_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000008853942501894733040000006168100151825910194_",
    filterUnits: "userSpaceOnUse",
    x: 383.13,
    y: 1005.02,
    width: 423.44,
    height: 640.77
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend4 || (_feBlend4 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 383.13,
    y: 1005.02,
    width: 423.44,
    height: 640.77,
    id: "SVGID_00000157309983882110668030000016516198685108359816_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000008853942501894733040000006168100151825910194_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150795916520771665990000005418052349221258168_",
    gradientUnits: "userSpaceOnUse",
    x1: 802.3238,
    y1: 1471.3728,
    x2: 453.93,
    y2: 1240.0618
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1275,
    style: {
      stopColor: "#040404"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2524,
    style: {
      stopColor: "#101010"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3764,
    style: {
      stopColor: "#232323"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4998,
    style: {
      stopColor: "#3F3F3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6229,
    style: {
      stopColor: "#636363"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7458,
    style: {
      stopColor: "#8F8F8F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8684,
    style: {
      stopColor: "#C2C2C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9881,
    style: {
      stopColor: "#FDFDFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9922,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000157309983882110668030000016516198685108359816_)",
      fill: "url(#SVGID_00000150795916520771665990000005418052349221258168_)"
    },
    d: " M806.57,1623.37c0,0-81.65,37.88-113.6,15.15c-31.95-22.73-343.44-227.97-306.86-551.14c5.68-50.19,51.26-119.32,104.51-58.71 c53.25,60.61,167.27,184.66,167.27,184.66s-19.95,110.8-19.95,158.14c0,47.35,12.42-35.99,19.52-41.67 c7.1-5.68-15.97,73.86,1.78,54.92c17.75-18.94,8.88-92.8,26.62-83.33c17.75,9.47-23.07,166.67-14.2,214.01 C680.54,1562.77,684.09,1636.63,806.57,1623.37z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096018053903863018790000006823940887918606251_",
    gradientUnits: "userSpaceOnUse",
    x1: 802.3238,
    y1: 1471.3728,
    x2: 453.93,
    y2: 1240.0618
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8C0503"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9803,
    style: {
      stopColor: "#8C0503"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9922,
    style: {
      stopColor: "#8C0503"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "url(#SVGID_00000096018053903863018790000006823940887918606251_)"
    },
    d: "M806.57,1623.37 c0,0-81.65,37.88-113.6,15.15c-31.95-22.73-343.44-227.97-306.86-551.14c5.68-50.19,51.26-119.32,104.51-58.71 c53.25,60.61,167.27,184.66,167.27,184.66s-19.95,110.8-19.95,158.14c0,47.35,12.42-35.99,19.52-41.67 c7.1-5.68-15.97,73.86,1.78,54.92c17.75-18.94,8.88-92.8,26.62-83.33c17.75,9.47-23.07,166.67-14.2,214.01 C680.54,1562.77,684.09,1636.63,806.57,1623.37z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000036209033099472099810000016163911470078227082_",
    filterUnits: "userSpaceOnUse",
    x: 383.13,
    y: 1005.02,
    width: 423.44,
    height: 640.77
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend5 || (_feBlend5 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 383.13,
    y: 1005.02,
    width: 423.44,
    height: 640.77,
    id: "SVGID_00000113341061441645489470000004586930475033891983_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000036209033099472099810000016163911470078227082_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000143579371961985096530000004726415256249242010_",
    filterUnits: "userSpaceOnUse",
    x: 383.13,
    y: 1005.02,
    width: 423.44,
    height: 640.77
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend6 || (_feBlend6 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 383.13,
    y: 1005.02,
    width: 423.44,
    height: 640.77,
    id: "SVGID_00000113341061441645489470000004586930475033891983_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000143579371961985096530000004726415256249242010_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000032611351843952619800000003563715113713432735_",
    gradientUnits: "userSpaceOnUse",
    x1: 486.3278,
    y1: 1470.631,
    x2: 685.1914,
    y2: 1233.8889
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1275,
    style: {
      stopColor: "#040404"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2524,
    style: {
      stopColor: "#101010"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3764,
    style: {
      stopColor: "#232323"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4998,
    style: {
      stopColor: "#3F3F3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6229,
    style: {
      stopColor: "#636363"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7458,
    style: {
      stopColor: "#8F8F8F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8684,
    style: {
      stopColor: "#C2C2C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9881,
    style: {
      stopColor: "#FDFDFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9922,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000113341061441645489470000004586930475033891983_)",
      fill: "url(#SVGID_00000032611351843952619800000003563715113713432735_)"
    },
    d: " M806.57,1623.37c0,0-81.65,37.88-113.6,15.15c-31.95-22.73-343.44-227.97-306.86-551.14c5.68-50.19,51.26-119.32,104.51-58.71 c53.25,60.61,167.27,184.66,167.27,184.66s-19.95,110.8-19.95,158.14c0,47.35,12.42-35.99,19.52-41.67 c7.1-5.68-15.97,73.86,1.78,54.92c17.75-18.94,8.88-92.8,26.62-83.33c17.75,9.47-23.07,166.67-14.2,214.01 C680.54,1562.77,684.09,1636.63,806.57,1623.37z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000028308263211111677530000016267404678485746619_",
    gradientUnits: "userSpaceOnUse",
    x1: 486.3278,
    y1: 1470.631,
    x2: 685.1914,
    y2: 1233.8889
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8C0503"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9803,
    style: {
      stopColor: "#8C0503"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9922,
    style: {
      stopColor: "#8C0503"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "url(#SVGID_00000028308263211111677530000016267404678485746619_)"
    },
    d: "M806.57,1623.37 c0,0-81.65,37.88-113.6,15.15c-31.95-22.73-343.44-227.97-306.86-551.14c5.68-50.19,51.26-119.32,104.51-58.71 c53.25,60.61,167.27,184.66,167.27,184.66s-19.95,110.8-19.95,158.14c0,47.35,12.42-35.99,19.52-41.67 c7.1-5.68-15.97,73.86,1.78,54.92c17.75-18.94,8.88-92.8,26.62-83.33c17.75,9.47-23.07,166.67-14.2,214.01 C680.54,1562.77,684.09,1636.63,806.57,1623.37z"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M291.18,976.12c0,0-4.22,33.15,42.91,45.4c47.13,12.25,80.2-10.81,80.2-10.81l-13.37-4.32L291.18,976.12z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M315.56,951.26c0,0-26.99,0.71-24.15,30.54c2.84,29.83,68.89,49.01,119.32,24.86 C461.16,982.51,315.56,951.26,315.56,951.26z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M303.25,975.65c-1.14-11.94,2.53-19.17,7.31-23.6c-7.65,1.85-21.2,8.16-19.14,29.76 c1.42,14.91,18.64,27.17,41.81,32.67c11.59,2.75,24.66,3.82,37.99,2.69c13.33-1.13,26.91-4.46,39.52-10.5 c2.58-1.24,4.53-2.5,6.13-3.77c-12.39,5.05-25.52,7.67-38.28,8.31c-12.76,0.64-25.16-0.71-36.09-3.58 C320.63,1001.87,304.62,990.01,303.25,975.65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M309.2,952.52c-7.55,2.22-19.73,8.83-17.78,29.29c1.42,14.91,18.64,27.17,41.81,32.67 c11.59,2.75,24.66,3.82,37.99,2.69c13.33-1.13,26.91-4.46,39.52-10.5c2.48-1.19,4.37-2.4,5.94-3.62 c-0.21,0.09-0.41,0.18-0.63,0.28c-12.31,5.17-25.37,7.91-38.12,8.66c-12.9,0.76-25.47-0.51-36.56-3.36 c-22.19-5.69-38.51-17.65-39.89-32.15C300.31,964.19,304.22,956.9,309.2,952.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M307.84,952.99c-7.45,2.59-18.26,9.51-16.42,28.82c1.42,14.91,18.64,27.17,41.81,32.67 c11.59,2.75,24.66,3.82,37.99,2.69c13.33-1.13,26.91-4.46,39.52-10.5c2.38-1.14,4.2-2.3,5.74-3.47c-0.22,0.1-0.4,0.2-0.63,0.3 c-12.41,5.46-25.65,8.4-38.58,9.27c-13.04,0.88-25.78-0.32-37.04-3.13c-22.52-5.63-39.14-17.68-40.53-32.32 C298.5,964.68,302.67,957.32,307.84,952.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M306.48,953.46c-7.35,2.97-16.79,10.19-15.06,28.35c1.42,14.91,18.64,27.17,41.81,32.67 c11.59,2.75,24.66,3.82,37.99,2.69c13.33-1.13,26.91-4.46,39.52-10.5c2.28-1.09,4.04-2.21,5.55-3.33 c-0.22,0.11-0.39,0.21-0.62,0.32c-12.51,5.75-25.92,8.88-39.05,9.89c-13.19,1.01-26.09-0.13-37.51-2.91 c-22.84-5.56-39.76-17.72-41.17-32.5C296.69,965.17,301.11,957.74,306.48,953.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M415.47,1003.82c-12.61,6.04-26.19,9.37-39.52,10.5c-13.33,1.13-26.4,0.07-37.99-2.69 c-23.17-5.5-40.39-17.76-41.81-32.67c-1.27-13.31,3.41-20.8,8.97-25.04c-7.24,3.34-15.32,10.86-13.7,27.88 c1.42,14.91,18.64,27.17,41.81,32.67c11.59,2.75,24.66,3.82,37.99,2.69c13.33-1.13,26.91-4.46,39.52-10.5 c2.19-1.05,3.88-2.11,5.35-3.18C415.86,1003.59,415.7,1003.71,415.47,1003.82z"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000127761841951994137610000003175415603199709836_",
    filterUnits: "userSpaceOnUse",
    x: 308.26,
    y: 951.26,
    width: 113,
    height: 52.52
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend7 || (_feBlend7 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 308.26,
    y: 951.26,
    width: 113,
    height: 52.52,
    id: "SVGID_00000152238344216531778570000007574008733357969571_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000127761841951994137610000003175415603199709836_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000158014316740516811170000006967482364965127563_",
    filterUnits: "userSpaceOnUse",
    x: 308.26,
    y: 951.26,
    width: 113,
    height: 52.52
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend8 || (_feBlend8 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 308.26,
    y: 951.26,
    width: 113,
    height: 52.52,
    id: "SVGID_00000152238344216531778570000007574008733357969571_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000158014316740516811170000006967482364965127563_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116954345984976483010000001356298844045969338_",
    gradientUnits: "userSpaceOnUse",
    x1: 346.1646,
    y1: 1012.0081,
    x2: 360.8426,
    y2: 983.599
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9922,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000152238344216531778570000007574008733357969571_)",
      fill: "url(#SVGID_00000116954345984976483010000001356298844045969338_)"
    },
    d: " M315.56,951.26c0,0-2.12,0.08-5.07,0.8c-1.74,4.09-2.67,9.28-2.03,16.01c2.72,28.57,63.38,47.25,112.8,27.59 C421.37,973.99,315.56,951.26,315.56,951.26z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000138557038255083291800000013789756545896869305_",
    gradientUnits: "userSpaceOnUse",
    x1: 346.1646,
    y1: 1012.0081,
    x2: 360.8426,
    y2: 983.599
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E06D2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9922,
    style: {
      stopColor: "#E06D2B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.55,
      fill: "url(#SVGID_00000138557038255083291800000013789756545896869305_)"
    },
    d: "M315.56,951.26 c0,0-2.12,0.08-5.07,0.8c-1.74,4.09-2.67,9.28-2.03,16.01c2.72,28.57,63.38,47.25,112.8,27.59 C421.37,973.99,315.56,951.26,315.56,951.26z"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M833.08,121.48l-3.31,669.98L380.43,977.54c0,0-40.54,15.09-68.18-15.15c0,0,4.74-38.83,3.31-45.93 c-1.42-7.1-51.14-66.76-45.45-130.68c5.68-63.92,63.92-120.74,58.24-237.22c-5.68-116.48-36.5-143.11-18.47-220.17 c15.62-66.76,76.7-85.23,115.06-130.68s105.11-140.62,250-136.36C819.82,65.61,833.08,121.48,833.08,121.48z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000150791756800898691400000005643387035208607114_",
    filterUnits: "userSpaceOnUse",
    x: 340.44,
    y: 969.86,
    width: 2.98,
    height: 8.79
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend9 || (_feBlend9 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 340.44,
    y: 969.86,
    width: 2.98,
    height: 8.79,
    id: "SVGID_00000080187732176489878650000009270440855424337341_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000150791756800898691400000005643387035208607114_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000137090329453543603290000014401464439245626259_",
    filterUnits: "userSpaceOnUse",
    x: 340.44,
    y: 969.86,
    width: 2.98,
    height: 8.79
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend10 || (_feBlend10 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 340.44,
    y: 969.86,
    width: 2.98,
    height: 8.79,
    id: "SVGID_00000080187732176489878650000009270440855424337341_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000137090329453543603290000014401464439245626259_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096767827419020438300000000133064020265100685_",
    gradientUnits: "userSpaceOnUse",
    x1: 341.1385,
    y1: 896.547,
    x2: 341.8488,
    y2: 969.6945
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1275,
    style: {
      stopColor: "#040404"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2524,
    style: {
      stopColor: "#101010"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3764,
    style: {
      stopColor: "#232323"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4998,
    style: {
      stopColor: "#3F3F3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6229,
    style: {
      stopColor: "#636363"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7458,
    style: {
      stopColor: "#8F8F8F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8684,
    style: {
      stopColor: "#C2C2C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9881,
    style: {
      stopColor: "#FDFDFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9922,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000080187732176489878650000009270440855424337341_)",
      fill: "url(#SVGID_00000096767827419020438300000000133064020265100685_)"
    },
    d: " M341.03,969.86c0.04,2.51-0.11,5.31-0.59,7.91c1.02,0.34,2,0.61,2.98,0.89C342.9,975.59,342.33,972.55,341.03,969.86z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000063592848408525456490000004379381543845931709_",
    gradientUnits: "userSpaceOnUse",
    x1: 341.1385,
    y1: 896.547,
    x2: 341.8488,
    y2: 969.6945
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8C0503"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9803,
    style: {
      stopColor: "#8C0503"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9922,
    style: {
      stopColor: "#8C0503"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.62,
      fill: "url(#SVGID_00000063592848408525456490000004379381543845931709_)"
    },
    d: "M341.03,969.86 c0.04,2.51-0.11,5.31-0.59,7.91c1.02,0.34,2,0.61,2.98,0.89C342.9,975.59,342.33,972.55,341.03,969.86z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000003791505683135975380000007829455712271175327_",
    filterUnits: "userSpaceOnUse",
    x: 318.61,
    y: 913.67,
    width: 9.69,
    height: 56.91
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend11 || (_feBlend11 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 318.61,
    y: 913.67,
    width: 9.69,
    height: 56.91,
    id: "SVGID_00000033336017742144989240000007354171365464661679_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000003791505683135975380000007829455712271175327_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000045602691578601894560000003026594452652552613_",
    filterUnits: "userSpaceOnUse",
    x: 318.61,
    y: 913.67,
    width: 9.69,
    height: 56.91
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend12 || (_feBlend12 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 318.61,
    y: 913.67,
    width: 9.69,
    height: 56.91,
    id: "SVGID_00000033336017742144989240000007354171365464661679_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000045602691578601894560000003026594452652552613_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000087395352253481155000000005076980645673596598_",
    gradientUnits: "userSpaceOnUse",
    x1: 322.9805,
    y1: 896.7174,
    x2: 323.6908,
    y2: 969.8712
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1275,
    style: {
      stopColor: "#040404"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2524,
    style: {
      stopColor: "#101010"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3764,
    style: {
      stopColor: "#232323"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4998,
    style: {
      stopColor: "#3F3F3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6229,
    style: {
      stopColor: "#636363"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7458,
    style: {
      stopColor: "#8F8F8F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8684,
    style: {
      stopColor: "#C2C2C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9881,
    style: {
      stopColor: "#FDFDFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9922,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000033336017742144989240000007354171365464661679_)",
      fill: "url(#SVGID_00000087395352253481155000000005076980645673596598_)"
    },
    d: " M324.64,970.3c-0.21-9.1,0.29-18.23,1.48-27.22c1.17-8.78,4.56-22.6-0.56-29.41c-5.5,4.5-5.32,29.5-6.21,38.37 c-0.49,4.86-0.76,9.86-0.74,14.84c2.06,1.36,4.06,2.57,6.04,3.71C324.65,970.49,324.64,970.4,324.64,970.3z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000131361186635778768380000015460179387826484904_",
    gradientUnits: "userSpaceOnUse",
    x1: 322.9805,
    y1: 896.7174,
    x2: 323.6908,
    y2: 969.8712
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8C0503"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9803,
    style: {
      stopColor: "#8C0503"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9922,
    style: {
      stopColor: "#8C0503"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.62,
      fill: "url(#SVGID_00000131361186635778768380000015460179387826484904_)"
    },
    d: "M324.64,970.3 c-0.21-9.1,0.29-18.23,1.48-27.22c1.17-8.78,4.56-22.6-0.56-29.41c-5.5,4.5-5.32,29.5-6.21,38.37c-0.49,4.86-0.76,9.86-0.74,14.84 c2.06,1.36,4.06,2.57,6.04,3.71C324.65,970.49,324.64,970.4,324.64,970.3z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000173125311688225674850000006096899018306561434_",
    filterUnits: "userSpaceOnUse",
    x: 346.08,
    y: 913.4,
    width: 30.99,
    height: 67.38
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend13 || (_feBlend13 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 346.08,
    y: 913.4,
    width: 30.99,
    height: 67.38,
    id: "SVGID_00000118374409519416030270000009903300107411565488_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000173125311688225674850000006096899018306561434_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000013891504641763365620000009093708289916801459_",
    filterUnits: "userSpaceOnUse",
    x: 346.08,
    y: 913.4,
    width: 30.99,
    height: 67.38
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend14 || (_feBlend14 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 346.08,
    y: 913.4,
    width: 30.99,
    height: 67.38,
    id: "SVGID_00000118374409519416030270000009903300107411565488_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000013891504641763365620000009093708289916801459_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075135544596423148780000013611279907876632232_",
    gradientUnits: "userSpaceOnUse",
    x1: 360.9917,
    y1: 896.3475,
    x2: 361.702,
    y2: 969.502
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1275,
    style: {
      stopColor: "#040404"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2524,
    style: {
      stopColor: "#101010"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3764,
    style: {
      stopColor: "#232323"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4998,
    style: {
      stopColor: "#3F3F3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6229,
    style: {
      stopColor: "#636363"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7458,
    style: {
      stopColor: "#8F8F8F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8684,
    style: {
      stopColor: "#C2C2C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9881,
    style: {
      stopColor: "#FDFDFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9922,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000118374409519416030270000009903300107411565488_)",
      fill: "url(#SVGID_00000075135544596423148780000013611279907876632232_)"
    },
    d: " M374.63,975.53c-1.26-2.69-1.24-5.95-1.85-8.95c-0.61-3-2.37-6.18-4.93-6.2c-1.09-0.01-2.17,0.58-3.25,0.36 c-1.67-0.34-2.65-2.41-3.39-4.25c-3.34-8.33-6.73-16.86-7.58-26.06c-0.54-5.8-0.14-12.06-2.69-17.01 c-5.15,8.67-5.98,20.36-3.58,30.62c2.4,10.26,7.71,19.23,13.91,26.84c2.62,3.22,5.44,6.33,7.66,9.92 c3.47-0.49,6.2-1.24,8.15-1.89C376.12,977.88,375.23,976.82,374.63,975.53z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000032619242110189628540000002549525726092380806_",
    gradientUnits: "userSpaceOnUse",
    x1: 360.9917,
    y1: 896.3475,
    x2: 361.702,
    y2: 969.502
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8C0503"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9803,
    style: {
      stopColor: "#8C0503"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9922,
    style: {
      stopColor: "#8C0503"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.62,
      fill: "url(#SVGID_00000032619242110189628540000002549525726092380806_)"
    },
    d: "M374.63,975.53 c-1.26-2.69-1.24-5.95-1.85-8.95c-0.61-3-2.37-6.18-4.93-6.2c-1.09-0.01-2.17,0.58-3.25,0.36c-1.67-0.34-2.65-2.41-3.39-4.25 c-3.34-8.33-6.73-16.86-7.58-26.06c-0.54-5.8-0.14-12.06-2.69-17.01c-5.15,8.67-5.98,20.36-3.58,30.62 c2.4,10.26,7.71,19.23,13.91,26.84c2.62,3.22,5.44,6.33,7.66,9.92c3.47-0.49,6.2-1.24,8.15-1.89 C376.12,977.88,375.23,976.82,374.63,975.53z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000091718438342363172300000000890442839277254044_",
    filterUnits: "userSpaceOnUse",
    x: 364.23,
    y: 979.44,
    width: 2.35,
    height: 1.78
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend15 || (_feBlend15 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 364.23,
    y: 979.44,
    width: 2.35,
    height: 1.78,
    id: "SVGID_00000021107181483562902060000010000514496865101501_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000091718438342363172300000000890442839277254044_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000157270088637050651340000009122055130657351355_",
    filterUnits: "userSpaceOnUse",
    x: 364.23,
    y: 979.44,
    width: 2.35,
    height: 1.78
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend16 || (_feBlend16 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 364.23,
    y: 979.44,
    width: 2.35,
    height: 1.78,
    id: "SVGID_00000021107181483562902060000010000514496865101501_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000157270088637050651340000009122055130657351355_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000167369973626395824580000002060764929378919083_",
    gradientUnits: "userSpaceOnUse",
    x1: 364.583,
    y1: 896.3286,
    x2: 365.2932,
    y2: 969.4686
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1275,
    style: {
      stopColor: "#040404"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2524,
    style: {
      stopColor: "#101010"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3764,
    style: {
      stopColor: "#232323"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4998,
    style: {
      stopColor: "#3F3F3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6229,
    style: {
      stopColor: "#636363"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7458,
    style: {
      stopColor: "#8F8F8F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8684,
    style: {
      stopColor: "#C2C2C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9881,
    style: {
      stopColor: "#FDFDFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9922,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000021107181483562902060000010000514496865101501_)",
      fill: "url(#SVGID_00000167369973626395824580000002060764929378919083_)"
    },
    d: " M366.58,981.05c-0.6-0.54-1.2-1.07-1.8-1.61c-0.17,0.6-0.38,1.18-0.55,1.78C365.04,981.17,365.83,981.12,366.58,981.05z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008856777060750869770000017648624625976659618_",
    gradientUnits: "userSpaceOnUse",
    x1: 364.583,
    y1: 896.3286,
    x2: 365.2932,
    y2: 969.4686
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8C0503"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9803,
    style: {
      stopColor: "#8C0503"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9922,
    style: {
      stopColor: "#8C0503"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.62,
      fill: "url(#SVGID_00000008856777060750869770000017648624625976659618_)"
    },
    d: "M366.58,981.05 c-0.6-0.54-1.2-1.07-1.8-1.61c-0.17,0.6-0.38,1.18-0.55,1.78C365.04,981.17,365.83,981.12,366.58,981.05z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M828.65,404.5c-8.65-9.99-21.46-17.96-40.75-25.11c-29.95-11.11-60.93-26.39-93.12-29.54 c-43.36-4.25-87.36,17.69-127.02,32.43c-46.72,17.36-92.37,49.86-125.1,87.87c-8.22,9.54-32.17,20.62-27.43,26.58 c-19.48,33.43,30.64,56.33,45.93,81.39c24.69,40.48-19.55,72.48-4.31,113.78c6.59,17.85,30.61,26.7,46.31,34.76 c12.16,6.25,57.57,24.48,69.79,16.83c13.53-8.48,8.18-35.35,12.64-47.83c17.92-50.15,70.9-47.62,113.74-53.82 c44.6-6.45,95.09-25.03,128.59-56.42c0.27-0.25,0.48-0.53,0.74-0.79V404.5z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000109720045033975465780000000209353713879901064_",
    filterUnits: "userSpaceOnUse",
    x: 406.17,
    y: 320.21,
    width: 440.4,
    height: 306.27
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend17 || (_feBlend17 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 406.17,
    y: 320.21,
    width: 440.4,
    height: 306.27,
    id: "SVGID_00000010293257018149290840000004760890787985684626_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000109720045033975465780000000209353713879901064_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000078724795829636050230000009782339148766543785_",
    filterUnits: "userSpaceOnUse",
    x: 406.17,
    y: 320.21,
    width: 440.4,
    height: 306.27
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend18 || (_feBlend18 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 406.17,
    y: 320.21,
    width: 440.4,
    height: 306.27,
    id: "SVGID_00000010293257018149290840000004760890787985684626_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000078724795829636050230000009782339148766543785_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000090997093502418765440000003999065204696655014_",
    gradientUnits: "userSpaceOnUse",
    x1: 727.7059,
    y1: 351.2446,
    x2: 605.5467,
    y2: 560.5247
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    style: {
      stopColor: "#FDFDFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4266,
    style: {
      stopColor: "#F5F5F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5322,
    style: {
      stopColor: "#E8E8E8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6215,
    style: {
      stopColor: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7005,
    style: {
      stopColor: "#BEBEBE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7723,
    style: {
      stopColor: "#A0A0A0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8386,
    style: {
      stopColor: "#7D7D7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9006,
    style: {
      stopColor: "#545454"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9569,
    style: {
      stopColor: "#282828"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000010293257018149290840000004760890787985684626_)",
      fill: "url(#SVGID_00000090997093502418765440000003999065204696655014_)"
    },
    d: " M828.91,512.23c0.29-20.98,0.59-41.33,0.86-55.04c0.69-35.07,5.12-68.65-17.22-95.69c-23.03-27.85-62.26-35.03-98.21-38.64 c-26.72-2.69-53.87-4.41-80.3,0.33c-30.94,5.54-59.64,19.71-86.85,35.43c-36.72,21.21-71.64,45.55-104.24,72.67 c-19.93,16.58-40.8,39.1-36.09,64.59c0.82,4.44,2.96,9.27,7.26,10.62c2.95,0.93,6.12-0.04,9.06-1 c26.47-8.68,25.86-11.65,35.92-16.86c-4.56,2.98,49.06-13.37,48.6-10.02c-0.66,4.69,27.06,10.38,26.28,10.3 c4.08-16.69-17.56-48.98-20.55-45.44c19.98-23.62,46.15-41.96,75.18-52.66c-8.12,19.04-3.32,42.85,11.53,57.26 c14.7-32.27,20.46-43.69,55.88-45.33c35.42-1.64,64.46-7.29,83.33,22.73c20.83,33.14-2.13,70.32-0.11,75.46 c5.32,13.56-5.62,19.99-5.62,19.99s-32.14,12.03-45.88,15.35c-13.73,3.31-36.93,15.62-47.48,15.5 c-10.54-0.13-13.6,7.47-13.6,7.47c9.47,0.24,18.29,6.86,18.29,6.86s34.97-40.95,143.64-47.34c3.36-0.2,6.47-1.66,9.71-1.82 c9.7,5.57,19.43,9.76,23.9,16.02c4.7,6.58,5.24,14.22,5.02,22.18c-1.53,4.59-3.88,9.49-7.39,14.76 c-25.57,38.35-58.24,28.41-99.43,8.52c-41.19-19.89-66.05-1.42-66.05-1.42s54.21,37.41,119.08,48.3 c64.87,10.89,66.29-54.45,72.44-81.91C849.21,528.43,840.22,519.26,828.91,512.23z M460.89,487.72 c4.3-2.08,10.38-4.53,20.39-7.81C470.16,483.97,463.86,486.4,460.89,487.72z M828.36,551.12c0.07-4.48,0.13-9.12,0.2-13.86 C829.5,541.34,829.54,545.96,828.36,551.12z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111179489909665865990000010220197700503867289_",
    gradientUnits: "userSpaceOnUse",
    x1: 727.7059,
    y1: 351.2446,
    x2: 605.5467,
    y2: 560.5247
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E05D2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3032,
    style: {
      stopColor: "#E05F2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4476,
    style: {
      stopColor: "#E16435"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5584,
    style: {
      stopColor: "#E36E42"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6522,
    style: {
      stopColor: "#E67C54"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.735,
    style: {
      stopColor: "#EA8F6C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8103,
    style: {
      stopColor: "#EEA58A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8798,
    style: {
      stopColor: "#F3C0AD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.943,
    style: {
      stopColor: "#F9DED4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.38,
      fill: "url(#SVGID_00000111179489909665865990000010220197700503867289_)"
    },
    d: "M828.91,512.23 c0.29-20.98,0.59-41.33,0.86-55.04c0.69-35.07,5.12-68.65-17.22-95.69c-23.03-27.85-62.26-35.03-98.21-38.64 c-26.72-2.69-53.87-4.41-80.3,0.33c-30.94,5.54-59.64,19.71-86.85,35.43c-36.72,21.21-71.64,45.55-104.24,72.67 c-19.93,16.58-40.8,39.1-36.09,64.59c0.82,4.44,2.96,9.27,7.26,10.62c2.95,0.93,6.12-0.04,9.06-1 c26.47-8.68,25.86-11.65,35.92-16.86c-4.56,2.98,49.06-13.37,48.6-10.02c-0.66,4.69,27.06,10.38,26.28,10.3 c4.08-16.69-17.56-48.98-20.55-45.44c19.98-23.62,46.15-41.96,75.18-52.66c-8.12,19.04-3.32,42.85,11.53,57.26 c14.7-32.27,20.46-43.69,55.88-45.33c35.42-1.64,64.46-7.29,83.33,22.73c20.83,33.14-2.13,70.32-0.11,75.46 c5.32,13.56-5.62,19.99-5.62,19.99s-32.14,12.03-45.88,15.35c-13.73,3.31-36.93,15.62-47.48,15.5c-10.54-0.13-13.6,7.47-13.6,7.47 c9.47,0.24,18.29,6.86,18.29,6.86s34.97-40.95,143.64-47.34c3.36-0.2,6.47-1.66,9.71-1.82c9.7,5.57,19.43,9.76,23.9,16.02 c4.7,6.58,5.24,14.22,5.02,22.18c-1.53,4.59-3.88,9.49-7.39,14.76c-25.57,38.35-58.24,28.41-99.43,8.52 c-41.19-19.89-66.05-1.42-66.05-1.42s54.21,37.41,119.08,48.3c64.87,10.89,66.29-54.45,72.44-81.91 C849.21,528.43,840.22,519.26,828.91,512.23z M460.89,487.72c4.3-2.08,10.38-4.53,20.39-7.81 C470.16,483.97,463.86,486.4,460.89,487.72z M828.36,551.12c0.07-4.48,0.13-9.12,0.2-13.86 C829.5,541.34,829.54,545.96,828.36,551.12z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000136383077009431065190000003731912985104532921_",
    filterUnits: "userSpaceOnUse",
    x: 318.16,
    y: 278.75,
    width: 129.41,
    height: 688.11
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend19 || (_feBlend19 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 318.16,
    y: 278.75,
    width: 129.41,
    height: 688.11,
    id: "SVGID_00000172435829211577109780000007772336916453368705_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000136383077009431065190000003731912985104532921_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000002376655918321632130000014020887534580793754_",
    filterUnits: "userSpaceOnUse",
    x: 318.16,
    y: 278.75,
    width: 129.41,
    height: 688.11
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend20 || (_feBlend20 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 318.16,
    y: 278.75,
    width: 129.41,
    height: 688.11,
    id: "SVGID_00000172435829211577109780000007772336916453368705_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000002376655918321632130000014020887534580793754_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163067296469993353570000010081219183670244791_",
    gradientUnits: "userSpaceOnUse",
    x1: 241.1257,
    y1: 1039.1887,
    x2: 405.8986,
    y2: 445.4391
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1275,
    style: {
      stopColor: "#040404"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2524,
    style: {
      stopColor: "#101010"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3764,
    style: {
      stopColor: "#232323"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4998,
    style: {
      stopColor: "#3F3F3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6229,
    style: {
      stopColor: "#636363"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7458,
    style: {
      stopColor: "#8F8F8F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8684,
    style: {
      stopColor: "#C2C2C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9881,
    style: {
      stopColor: "#FDFDFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9922,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000172435829211577109780000007772336916453368705_)",
      fill: "url(#SVGID_00000163067296469993353570000010081219183670244791_)"
    },
    d: " M326.6,332.33c5.36,82.29,14.08,164.12,26.11,244.91c0.11-41.23-2.07-82.47-6.5-123.19c5.63,21.62,11.26,43.24,16.9,64.86 c1.13-27.34,2.26-54.68,3.39-82.02c2.07,16.27,5.16,32.26,9.2,47.73c2.53-3.33,5.06-6.66,7.6-9.99 c0.1,5.85,2.25,11.54,5.59,14.81c2.71-2.22,5.42-4.45,8.13-6.67c5.21,91.06,1.71,183.17-10.38,272.85 c13.38,17.55,14.54,51.19,2.46,70.6c-4.95-31.78-9.9-63.55-14.84-95.33c-0.81-5.21-4.08-11.92-7-8.67 c-6.46,55.94-12.93,111.88-19.39,167.82c4.8-27.47,12.26-53.96,22.1-78.44c0.74,8.64,1.49,17.29,2.23,25.93 c2.63-1.04,5.06-3.16,6.92-6.06c6.45,37.52,2.12,78.7-11.75,111.71c-4.13,9.82-13.52,19.57-18.91,11.14 c-5.08-7.94,0.84-22.3-3.39-31.23c-5.51,11.19-8.11,25.32-7.19,39.01c3.75,1.22,7.5,2.44,11.25,3.66c2.14,0.7,4.34,1.4,6.51,0.94 c2.06-0.44,3.94-1.89,5.74-3.4c28.79-24.21,47.59-71.61,47.59-119.91c-6.9,6.89-11.83,17.79-13.45,29.71 c-1.69-10.23-1-21.26,1.93-30.88c6.03-19.77,20.55-32.01,26.47-51.86c3.54-11.88,3.62-25.27,5.98-37.75 c3.28-17.38,10.86-32.47,14.57-49.67c4.02-18.64,3.29-38.64,2.51-58.13c-2.62-65.93-5.23-131.85-7.85-197.78 c-1.19-30.02-3.15-62.73-17.37-84.57c-15.63-24.01-42.57-26.86-63.32-13.29c-2.98,1.95-6.23,4.25-9.38,2.95 c-2.95-1.22-4.88-5.29-6.19-9.32c-7.09-21.84-1.55-50.66,12.3-64.03c-14.77,3.35-28.08,18.12-34.18,37.94 c-2.72,8.83-4.02,19.22-1.38,28.1c1.51,5.09,4.19,9.27,5.91,14.22c1.88,5.39,2.56,11.46,3.22,17.42 c2.42,21.85,4.84,43.7,7.26,65.56L326.6,332.33z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119824399424015370480000007310418271317934760_",
    gradientUnits: "userSpaceOnUse",
    x1: 241.1257,
    y1: 1039.1887,
    x2: 405.8986,
    y2: 445.4391
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8C0503"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9803,
    style: {
      stopColor: "#8C0503"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9922,
    style: {
      stopColor: "#8C0503"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.62,
      fill: "url(#SVGID_00000119824399424015370480000007310418271317934760_)"
    },
    d: "M326.6,332.33 c5.36,82.29,14.08,164.12,26.11,244.91c0.11-41.23-2.07-82.47-6.5-123.19c5.63,21.62,11.26,43.24,16.9,64.86 c1.13-27.34,2.26-54.68,3.39-82.02c2.07,16.27,5.16,32.26,9.2,47.73c2.53-3.33,5.06-6.66,7.6-9.99c0.1,5.85,2.25,11.54,5.59,14.81 c2.71-2.22,5.42-4.45,8.13-6.67c5.21,91.06,1.71,183.17-10.38,272.85c13.38,17.55,14.54,51.19,2.46,70.6 c-4.95-31.78-9.9-63.55-14.84-95.33c-0.81-5.21-4.08-11.92-7-8.67c-6.46,55.94-12.93,111.88-19.39,167.82 c4.8-27.47,12.26-53.96,22.1-78.44c0.74,8.64,1.49,17.29,2.23,25.93c2.63-1.04,5.06-3.16,6.92-6.06 c6.45,37.52,2.12,78.7-11.75,111.71c-4.13,9.82-13.52,19.57-18.91,11.14c-5.08-7.94,0.84-22.3-3.39-31.23 c-5.51,11.19-8.11,25.32-7.19,39.01c3.75,1.22,7.5,2.44,11.25,3.66c2.14,0.7,4.34,1.4,6.51,0.94c2.06-0.44,3.94-1.89,5.74-3.4 c28.79-24.21,47.59-71.61,47.59-119.91c-6.9,6.89-11.83,17.79-13.45,29.71c-1.69-10.23-1-21.26,1.93-30.88 c6.03-19.77,20.55-32.01,26.47-51.86c3.54-11.88,3.62-25.27,5.98-37.75c3.28-17.38,10.86-32.47,14.57-49.67 c4.02-18.64,3.29-38.64,2.51-58.13c-2.62-65.93-5.23-131.85-7.85-197.78c-1.19-30.02-3.15-62.73-17.37-84.57 c-15.63-24.01-42.57-26.86-63.32-13.29c-2.98,1.95-6.23,4.25-9.38,2.95c-2.95-1.22-4.88-5.29-6.19-9.32 c-7.09-21.84-1.55-50.66,12.3-64.03c-14.77,3.35-28.08,18.12-34.18,37.94c-2.72,8.83-4.02,19.22-1.38,28.1 c1.51,5.09,4.19,9.27,5.91,14.22c1.88,5.39,2.56,11.46,3.22,17.42c2.42,21.85,4.84,43.7,7.26,65.56L326.6,332.33z"
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M714.33,322.85c-26.72-2.69-53.87-4.41-80.3,0.33c-30.94,5.54-59.64,19.71-86.85,35.43 c-36.72,21.21-71.64,45.55-104.24,72.67c-1.85,1.54-3.7,3.18-5.54,4.81c-11.94,13.57-20.46,29.35-17.29,46.52 c0.82,4.44,2.96,9.27,7.26,10.62c2.95,0.93,6.12-0.04,9.06-1c37.96-12.45,20.16-13.13,58.12-25.58 c-63.33,23.12,23.33,5.13,22.73,9.47c-0.38,2.69,6.57-3.97,15.27-4.26c-3.37-16.14-23.41-37.26-25.69-34.56 c5.32-6.29,8.05-16.57,24.15-28.88c33.29-25.46,43.69-20.85,70.85-30.86c-7.51,17.61-3.86,39.2,8.47,53.77 c4.66-6.25,10-11.94,16.01-16.93c17.33-21.06,43.49-34.97,70.81-36.23c35.42-1.64,63.87,10.39,81.49,41.16 c8.34,14.57,1.34,23.35,7.62,54.44c4.84,23.95,29.14,30.57,42.64,39.92c0.3-21.48,0.6-42.45,0.88-56.47 c0.69-35.07,5.12-68.65-17.22-95.69C789.52,333.65,750.28,326.47,714.33,322.85z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000041254867575794931430000005488203872068665272_",
    filterUnits: "userSpaceOnUse",
    x: 472.82,
    y: 544.08,
    width: 98.79,
    height: 145.31
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend21 || (_feBlend21 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 472.82,
    y: 544.08,
    width: 98.79,
    height: 145.31,
    id: "SVGID_00000169559959433965791510000006865292804453728648_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000041254867575794931430000005488203872068665272_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000040573658624022910150000017812002486139055797_",
    filterUnits: "userSpaceOnUse",
    x: 472.82,
    y: 544.08,
    width: 98.79,
    height: 145.31
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend22 || (_feBlend22 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 472.82,
    y: 544.08,
    width: 98.79,
    height: 145.31,
    id: "SVGID_00000169559959433965791510000006865292804453728648_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000040573658624022910150000017812002486139055797_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000104690066330473733060000012877045612694699904_",
    gradientUnits: "userSpaceOnUse",
    x1: 540.8822,
    y1: 619.5831,
    x2: 468.4834,
    y2: 604.2679
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    style: {
      stopColor: "#FDFDFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4266,
    style: {
      stopColor: "#F5F5F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5322,
    style: {
      stopColor: "#E8E8E8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6215,
    style: {
      stopColor: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7005,
    style: {
      stopColor: "#BEBEBE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7723,
    style: {
      stopColor: "#A0A0A0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8386,
    style: {
      stopColor: "#7D7D7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9006,
    style: {
      stopColor: "#545454"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9569,
    style: {
      stopColor: "#282828"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000169559959433965791510000006865292804453728648_)",
      fill: "url(#SVGID_00000104690066330473733060000012877045612694699904_)"
    },
    d: " M483.51,605.22c-10.41,18.85-13.23,41.62-8.43,62.62c2.19,9.6,7.68,20.3,17.46,21.46c3.88,0.46,7.75-0.74,11.39-2.16 c20.37-7.95,38.93-26.91,36.9-48.69c-1.56-16.71-14.8-32.3-10.52-48.52c3.43-13.03,15.02-24.4,28.15-27.39 c2.67-0.61,6.6-2.34,8.76-4.03c8.81-6.85,2.81-12.4-4.48-14.3c-6.01-1.56-24.57,12-29.79,15.09 C513.38,570.85,494.7,584.96,483.51,605.22z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000131342595729117113080000003704217064423729328_",
    gradientUnits: "userSpaceOnUse",
    x1: 540.8822,
    y1: 619.5831,
    x2: 468.4834,
    y2: 604.2679
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E05D2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3032,
    style: {
      stopColor: "#E05F2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4476,
    style: {
      stopColor: "#E16435"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5584,
    style: {
      stopColor: "#E36E42"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6522,
    style: {
      stopColor: "#E67C54"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.735,
    style: {
      stopColor: "#EA8F6C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8103,
    style: {
      stopColor: "#EEA58A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8798,
    style: {
      stopColor: "#F3C0AD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.943,
    style: {
      stopColor: "#F9DED4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.37,
      fill: "url(#SVGID_00000131342595729117113080000003704217064423729328_)"
    },
    d: "M483.51,605.22 c-10.41,18.85-13.23,41.62-8.43,62.62c2.19,9.6,7.68,20.3,17.46,21.46c3.88,0.46,7.75-0.74,11.39-2.16 c20.37-7.95,38.93-26.91,36.9-48.69c-1.56-16.71-14.8-32.3-10.52-48.52c3.43-13.03,15.02-24.4,28.15-27.39 c2.67-0.61,6.6-2.34,8.76-4.03c8.81-6.85,2.81-12.4-4.48-14.3c-6.01-1.56-24.57,12-29.79,15.09 C513.38,570.85,494.7,584.96,483.51,605.22z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000148633754498578348770000008141070085091454911_",
    filterUnits: "userSpaceOnUse",
    x: 498.38,
    y: 554.2,
    width: 73.71,
    height: 131.55
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend23 || (_feBlend23 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 498.38,
    y: 554.2,
    width: 73.71,
    height: 131.55,
    id: "SVGID_00000157304634404245324230000014086193875947504537_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000148633754498578348770000008141070085091454911_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000119113222758977168990000003314607734704300458_",
    filterUnits: "userSpaceOnUse",
    x: 498.38,
    y: 554.2,
    width: 73.71,
    height: 131.55
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend24 || (_feBlend24 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 498.38,
    y: 554.2,
    width: 73.71,
    height: 131.55,
    id: "SVGID_00000157304634404245324230000014086193875947504537_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000119113222758977168990000003314607734704300458_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047743464289626428900000004332859814231394733_",
    gradientUnits: "userSpaceOnUse",
    x1: 545.6362,
    y1: 622.4935,
    x2: 505.8637,
    y2: 606.1583
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2855,
    style: {
      stopColor: "#FDFDFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4215,
    style: {
      stopColor: "#F5F5F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5259,
    style: {
      stopColor: "#E8E8E8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6142,
    style: {
      stopColor: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6923,
    style: {
      stopColor: "#BEBEBE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7632,
    style: {
      stopColor: "#A0A0A0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8287,
    style: {
      stopColor: "#7D7D7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    style: {
      stopColor: "#545454"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9456,
    style: {
      stopColor: "#282828"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9882,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000157304634404245324230000014086193875947504537_)",
      fill: "url(#SVGID_00000047743464289626428900000004332859814231394733_)"
    },
    d: " M509.08,608.77c-10.41,18.85-13.23,41.62-8.43,62.62c1.14,5,3.2,10.27,6.27,14.36c19.15-8.58,35.84-26.61,33.91-47.3 c-1.56-16.71-14.37-32.19-10.52-48.52c5.89-25.03,42.34-32.59,41.77-35.73c-5.67,3.43-18.03,7.12-20.49,8.57 C532.03,574.32,520.27,588.51,509.08,608.77z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000063606861088497547450000003732020209941846677_",
    gradientUnits: "userSpaceOnUse",
    x1: 545.6362,
    y1: 622.4935,
    x2: 505.8637,
    y2: 606.1583
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E05D2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5874,
    style: {
      stopColor: "#E05F2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8667,
    style: {
      stopColor: "#E16435"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9882,
    style: {
      stopColor: "#E2693B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.59,
      fill: "url(#SVGID_00000063606861088497547450000003732020209941846677_)"
    },
    d: "M509.08,608.77 c-10.41,18.85-13.23,41.62-8.43,62.62c1.14,5,3.2,10.27,6.27,14.36c19.15-8.58,35.84-26.61,33.91-47.3 c-1.56-16.71-14.37-32.19-10.52-48.52c5.89-25.03,42.34-32.59,41.77-35.73c-5.67,3.43-18.03,7.12-20.49,8.57 C532.03,574.32,520.27,588.51,509.08,608.77z"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M368.32,829.2c-0.42,2.48-0.91,4.16-0.91,4.16C368.34,832.57,368.6,831.04,368.32,829.2z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M697.2,1320.71c50.59-85.71,109.09-136.09,138.74-158.07l-2.86-374.49V629.06L406.47,754.53 c0,0,24.15,93.04-17.76,98.72c-41.9,5.68-54.69-16.34-42.61-32.67c9.81-13.27,21.03,0.65,22.22,8.62 c1.47-8.64,2.05-27.56-22.22-24.25c-31.25,4.26-53.98,96.59,31.25,115.06c0,0-22.02,61.08,17.76,82.39 c39.77,21.31,80.26,6.39,77.41,35.51c-2.84,29.12-38.35,24.15-26.99,12.07c11.36-12.07,9.94,4.97,9.94,4.97s5.33-13.85-9.59-12.07 c-14.91,1.78-25.21,35.51,7.46,45.1c32.67,9.59,45.81-8.17,45.81-8.17s-10.65,20.6-38,14.91c0,0,24.5,14.2,41.9,2.13 c0,0-49.01,45.45,29.12,84.52c0,0-38.35-33.38-24.86-53.98c13.49-20.6,25.57-26.99,25.57-26.99s-23.44,41.9,24.86,67.47 c48.3,25.57,59.66,8.52,71.73,44.74c12.07,36.22-16.34,53.27-41.19,47.59c-24.86-5.68-39.77-28.41-19.18-51.14 c0,0-32.67,13.49-14.91,53.98c17.76,40.48,61.08,33.38,61.08,33.38s-24.15,9.94-42.61-2.13 C572.66,1294.3,600.94,1327.42,697.2,1320.71z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000099648311822826939140000001418446077455523731_",
    filterUnits: "userSpaceOnUse",
    x: 317.99,
    y: 629.06,
    width: 517.95,
    height: 692.55
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend25 || (_feBlend25 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 317.99,
    y: 629.06,
    width: 517.95,
    height: 692.55,
    id: "SVGID_00000021820557520857192720000009849842623657858699_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000099648311822826939140000001418446077455523731_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000049915045212878208860000001444766411595453318_",
    filterUnits: "userSpaceOnUse",
    x: 317.99,
    y: 629.06,
    width: 517.95,
    height: 692.55
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend26 || (_feBlend26 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 317.99,
    y: 629.06,
    width: 517.95,
    height: 692.55,
    id: "SVGID_00000021820557520857192720000009849842623657858699_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000049915045212878208860000001444766411595453318_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000066514713552295838220000016742767692636951188_",
    gradientUnits: "userSpaceOnUse",
    x1: 866.215,
    y1: 1412.1416,
    x2: 624.7373,
    y2: 861.0053
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0892,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2219,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3853,
    style: {
      stopColor: "#BDBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    style: {
      stopColor: "#8B8B8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7816,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000021820557520857192720000009849842623657858699_)",
      fill: "url(#SVGID_00000066514713552295838220000016742767692636951188_)"
    },
    d: " M697.2,1320.71c50.59-85.71,109.09-136.09,138.74-158.07l-2.86-374.49V629.06L406.47,754.53c0,0,24.15,93.04-17.76,98.72 c-41.9,5.68-54.69-16.34-42.61-32.67c9.81-13.27,21.03,0.65,22.22,8.62c1.47-8.64,2.05-27.56-22.22-24.25 c-31.25,4.26-53.98,96.59,31.25,115.06c0,0-22.02,61.08,17.76,82.39c39.77,21.31,80.26,6.39,77.41,35.51 c-2.84,29.12-38.35,24.15-26.99,12.07c11.36-12.07,9.94,4.97,9.94,4.97s5.33-13.85-9.59-12.07c-14.91,1.78-25.21,35.51,7.46,45.1 c32.67,9.59,45.81-8.17,45.81-8.17s-10.65,20.6-38,14.91c0,0,24.5,14.2,41.9,2.13c0,0-49.01,45.45,29.12,84.52 c0,0-38.35-33.38-24.86-53.98c13.49-20.6,25.57-26.99,25.57-26.99s-23.44,41.9,24.86,67.47c48.3,25.57,59.66,8.52,71.73,44.74 c12.07,36.22-16.34,53.27-41.19,47.59c-24.86-5.68-39.77-28.41-19.18-51.14c0,0-32.67,13.49-14.91,53.98 c17.76,40.48,61.08,33.38,61.08,33.38s-24.15,9.94-42.61-2.13C572.66,1294.3,600.94,1327.42,697.2,1320.71z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152948424408983059310000016990779324403610015_",
    gradientUnits: "userSpaceOnUse",
    x1: 866.215,
    y1: 1412.1416,
    x2: 624.7373,
    y2: 861.0053
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#9CA5B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    style: {
      stopColor: "#A4ACB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4298,
    style: {
      stopColor: "#BAC0C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    style: {
      stopColor: "#DEE1E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000152948424408983059310000016990779324403610015_)"
    },
    d: "M697.2,1320.71 c50.59-85.71,109.09-136.09,138.74-158.07l-2.86-374.49V629.06L406.47,754.53c0,0,24.15,93.04-17.76,98.72 c-41.9,5.68-54.69-16.34-42.61-32.67c9.81-13.27,21.03,0.65,22.22,8.62c1.47-8.64,2.05-27.56-22.22-24.25 c-31.25,4.26-53.98,96.59,31.25,115.06c0,0-22.02,61.08,17.76,82.39c39.77,21.31,80.26,6.39,77.41,35.51 c-2.84,29.12-38.35,24.15-26.99,12.07c11.36-12.07,9.94,4.97,9.94,4.97s5.33-13.85-9.59-12.07c-14.91,1.78-25.21,35.51,7.46,45.1 c32.67,9.59,45.81-8.17,45.81-8.17s-10.65,20.6-38,14.91c0,0,24.5,14.2,41.9,2.13c0,0-49.01,45.45,29.12,84.52 c0,0-38.35-33.38-24.86-53.98c13.49-20.6,25.57-26.99,25.57-26.99s-23.44,41.9,24.86,67.47c48.3,25.57,59.66,8.52,71.73,44.74 c12.07,36.22-16.34,53.27-41.19,47.59c-24.86-5.68-39.77-28.41-19.18-51.14c0,0-32.67,13.49-14.91,53.98 c17.76,40.48,61.08,33.38,61.08,33.38s-24.15,9.94-42.61-2.13C572.66,1294.3,600.94,1327.42,697.2,1320.71z"
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M454.87,1048.27c0.92,2.75,0.61,6.68,0.61,6.68s1.54-4.26,0.44-7.75c-0.31,0.3-0.59,0.54-0.91,0.89 C454.94,1048.15,454.93,1048.21,454.87,1048.27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M472.52,1037.91c-1.05,10.75-6.55,16.83-12.5,19.64c8.12,0.57,20.35-4.93,21.97-21.54 c2.84-29.12-37.64-14.2-77.41-35.51c-39.77-21.31-17.76-82.39-17.76-82.39c-79.97-17.33-64.89-99.67-36.91-113.29 c-1.27,0.05-2.36-0.07-3.81,0.12c-31.25,4.26-53.98,96.59,31.25,115.06c0,0-22.02,61.08,17.76,82.39 C434.88,1023.71,475.36,1008.79,472.52,1037.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M508.63,1077.92c0,0-4.88,6.37-15.79,9.4c-2.64,2.37-6.21,4.65-10.77,6.28 C500.89,1092.45,508.63,1077.92,508.63,1077.92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M484.96,1088.68c-6.09,0.5-13.36-0.02-22.15-2.6c-28.81-8.46-24.19-35.67-12.47-43.2 c-1.24-0.18-2.68-0.22-4.45-0.01c-14.91,1.78-25.21,35.51,7.46,45.1C467.39,1092.1,477.63,1091.08,484.96,1088.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M358.3,815.92c5.21,2.15,9.33,8.65,10.02,13.28c0.68-4.01,1.06-10.21-1.04-15.4 C364.47,812.81,361.38,813.28,358.3,815.92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M393.77,851.8c1.46-0.14,2.88-0.23,4.42-0.44c41.9-5.68,17.76-98.72,17.76-98.72l417.14-122.69v-0.89 L406.47,754.53C406.47,754.53,428.37,839.29,393.77,851.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M615.28,1296.43c0,0-1.86,0.73-4.79,1.55c8.28-0.99,14.26-3.44,14.26-3.44s-43.32,7.1-61.08-33.38 c-5.7-12.99-6.17-23.17-4.23-31.05c0.21-6.65,3.16-13.84,9.68-21.04c0,0-32.67,13.49-14.91,53.98 C571.95,1303.54,615.28,1296.43,615.28,1296.43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M497.34,1099.7c-8.64,0.34-16.88-2.39-21.87-4.54c-4.19,0.6-8.83,0.71-14.31-0.43 C461.16,1094.73,480.75,1105.95,497.34,1099.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M592.01,1300.11c-6.35-0.3-13.15-1.75-19.35-5.81c0,0,28.28,33.12,124.53,26.41c0.3-0.51,0.61-0.98,0.91-1.49 C638.14,1322.03,606.33,1309.02,592.01,1300.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M514.16,1161.32c-36.77-33.73-1.62-66.36-1.62-66.36c-3.71,2.57-7.75,3.78-11.8,4.35 c-8.74,9.92-35.96,48.35,31.45,82.06C532.18,1181.38,522.16,1172.62,514.16,1161.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M629.48,1212.63c8.43,25.29-2.89,41.2-18.95,46.58c20.57-1.62,38.44-18.42,28.42-48.48 c-12.07-36.22-23.44-19.18-71.73-44.74c-48.3-25.57-24.86-67.47-24.86-67.47s-5.43,2.97-13.01,10.98c-4,13.74-6,40.17,28.4,58.38 C606.05,1193.45,617.41,1176.4,629.48,1212.63z"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000000209593229022531900000007135188816404936103_",
    filterUnits: "userSpaceOnUse",
    x: 600.97,
    y: 397.66,
    width: 106.86,
    height: 119.13
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend27 || (_feBlend27 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 600.97,
    y: 397.66,
    width: 106.86,
    height: 119.13,
    id: "SVGID_00000003790235959312210130000016803695236475890067_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000000209593229022531900000007135188816404936103_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000034806983779008387160000006591852919881353088_",
    filterUnits: "userSpaceOnUse",
    x: 600.97,
    y: 397.66,
    width: 106.86,
    height: 119.13
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend28 || (_feBlend28 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 600.97,
    y: 397.66,
    width: 106.86,
    height: 119.13,
    id: "SVGID_00000003790235959312210130000016803695236475890067_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000034806983779008387160000006591852919881353088_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129197017123337639820000017315545609892098750_",
    gradientUnits: "userSpaceOnUse",
    x1: 609.2334,
    y1: 445.0952,
    x2: 710.5594,
    y2: 466.8755
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    style: {
      stopColor: "#FDFDFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4266,
    style: {
      stopColor: "#F5F5F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5322,
    style: {
      stopColor: "#E8E8E8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6215,
    style: {
      stopColor: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7005,
    style: {
      stopColor: "#BEBEBE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7723,
    style: {
      stopColor: "#A0A0A0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8386,
    style: {
      stopColor: "#7D7D7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9006,
    style: {
      stopColor: "#545454"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9569,
    style: {
      stopColor: "#282828"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000003790235959312210130000016803695236475890067_)",
      fill: "url(#SVGID_00000129197017123337639820000017315545609892098750_)"
    },
    d: " M605.81,471.86c-4.99-11.04-6.9-33.85-1.93-44.89c3.07-6.83,9.12-11.9,15.61-15.63c16.62-9.54,36.38-11.49,55.46-13.23 c10.4-0.95,22.66-1.14,29.12,7.07c5.98,7.61,3.8,18.66,0.54,27.78c-3.26,9.12-7.36,18.95-4.31,28.14 c1.06,3.17,2.93,6.07,3.58,9.35c1.86,9.35-6.45,17.38-14.16,22.97c-14.65,10.62-30.59,26.17-48.87,22.94 C624.75,513.53,611.98,485.49,605.81,471.86z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181805955724313001560000008190472936018186925_",
    gradientUnits: "userSpaceOnUse",
    x1: 609.2334,
    y1: 445.0952,
    x2: 710.5594,
    y2: 466.8755
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E05D2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3032,
    style: {
      stopColor: "#E05F2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4476,
    style: {
      stopColor: "#E16435"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5584,
    style: {
      stopColor: "#E36E42"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6522,
    style: {
      stopColor: "#E67C54"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.735,
    style: {
      stopColor: "#EA8F6C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8103,
    style: {
      stopColor: "#EEA58A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8798,
    style: {
      stopColor: "#F3C0AD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.943,
    style: {
      stopColor: "#F9DED4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.37,
      fill: "url(#SVGID_00000181805955724313001560000008190472936018186925_)"
    },
    d: "M605.81,471.86 c-4.99-11.04-6.9-33.85-1.93-44.89c3.07-6.83,9.12-11.9,15.61-15.63c16.62-9.54,36.38-11.49,55.46-13.23 c10.4-0.95,22.66-1.14,29.12,7.07c5.98,7.61,3.8,18.66,0.54,27.78c-3.26,9.12-7.36,18.95-4.31,28.14c1.06,3.17,2.93,6.07,3.58,9.35 c1.86,9.35-6.45,17.38-14.16,22.97c-14.65,10.62-30.59,26.17-48.87,22.94C624.75,513.53,611.98,485.49,605.81,471.86z"
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M817.93,371.48c-14.5-11.94-38.38-27.7-60.28-41.44c-14.15-3.66-28.98-5.75-43.32-7.19 c-1.3-0.13-2.61-0.21-3.91-0.34l6.18,43.29c0,0,60.61,13.26,75.76,49.24c14.24,33.81,5.08,66.77,36.91,72.21 c0.17-11.5,0.34-21.96,0.5-30.07c0.59-29.78,3.71-58.44-9-82.98C819.82,373.3,818.89,372.27,817.93,371.48z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000050658038120445893760000010572234454219554742_",
    filterUnits: "userSpaceOnUse",
    x: 600.97,
    y: 397.69,
    width: 95.7,
    height: 118.81
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend29 || (_feBlend29 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 600.97,
    y: 397.69,
    width: 95.7,
    height: 118.81,
    id: "SVGID_00000069380943163912597180000012828562745219918483_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000050658038120445893760000010572234454219554742_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000145757380582550038810000007416268906297981096_",
    filterUnits: "userSpaceOnUse",
    x: 600.97,
    y: 397.69,
    width: 95.7,
    height: 118.81
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend30 || (_feBlend30 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 600.97,
    y: 397.69,
    width: 95.7,
    height: 118.81,
    id: "SVGID_00000069380943163912597180000012828562745219918483_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000145757380582550038810000007416268906297981096_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000144336670018427749370000016227017980009461917_",
    gradientUnits: "userSpaceOnUse",
    x1: 593.9333,
    y1: 433.5329,
    x2: 671.5853,
    y2: 459.1013
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    style: {
      stopColor: "#FDFDFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4266,
    style: {
      stopColor: "#F5F5F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5322,
    style: {
      stopColor: "#E8E8E8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6215,
    style: {
      stopColor: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7005,
    style: {
      stopColor: "#BEBEBE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7723,
    style: {
      stopColor: "#A0A0A0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8386,
    style: {
      stopColor: "#7D7D7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9006,
    style: {
      stopColor: "#545454"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9569,
    style: {
      stopColor: "#282828"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000069380943163912597180000012828562745219918483_)",
      fill: "url(#SVGID_00000144336670018427749370000016227017980009461917_)"
    },
    d: " M629.96,491.04c-4.99-11.04-6.9-33.85-1.93-44.89c3.07-6.83,10.4-17.35,16.37-21.87c23.72-17.94,37.62-22.42,52.27-24.42 c-6.45-2.62-14.51-2.39-21.72-1.74c-19.09,1.74-38.85,3.68-55.46,13.23c-6.49,3.73-12.54,8.8-15.61,15.63 c-4.97,11.05-3.06,33.86,1.93,44.89c6.17,13.64,18.94,41.67,35.04,44.51c0.81,0.14,1.59,0.06,2.4,0.13 C637.52,507.63,632.95,497.65,629.96,491.04z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000175303297893162555900000004943132278418480044_",
    gradientUnits: "userSpaceOnUse",
    x1: 593.9333,
    y1: 433.5329,
    x2: 671.5853,
    y2: 459.1013
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E05D2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3032,
    style: {
      stopColor: "#E05F2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4476,
    style: {
      stopColor: "#E16435"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5584,
    style: {
      stopColor: "#E36E42"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6522,
    style: {
      stopColor: "#E67C54"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.735,
    style: {
      stopColor: "#EA8F6C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8103,
    style: {
      stopColor: "#EEA58A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8798,
    style: {
      stopColor: "#F3C0AD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.943,
    style: {
      stopColor: "#F9DED4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.43,
      fill: "url(#SVGID_00000175303297893162555900000004943132278418480044_)"
    },
    d: "M629.96,491.04 c-4.99-11.04-6.9-33.85-1.93-44.89c3.07-6.83,10.4-17.35,16.37-21.87c23.72-17.94,37.62-22.42,52.27-24.42 c-6.45-2.62-14.51-2.39-21.72-1.74c-19.09,1.74-38.85,3.68-55.46,13.23c-6.49,3.73-12.54,8.8-15.61,15.63 c-4.97,11.05-3.06,33.86,1.93,44.89c6.17,13.64,18.94,41.67,35.04,44.51c0.81,0.14,1.59,0.06,2.4,0.13 C637.52,507.63,632.95,497.65,629.96,491.04z"
  }), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st72"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M410.02,768.02c4.97,46.16,3.57,81.85-21.31,85.23c-20.9,2.83-34.55-1.22-41.49-8.03 c5.61,10.25,25.85,34.4,83.39,4.48c71.02-36.93,159.09-73.86,167.61-25.57c8.52,48.3-42.61,34.09-42.61,34.09 s136.36,53.98,171.87-154.83c3.16-18.56,2.67-32.65-0.72-43.07l-229.84,67.6C466.16,748.7,434.53,749.51,410.02,768.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M366.48,824.13c0.9,1.75,1.61,3.52,1.84,5.07c0.33-1.92,0.56-4.38,0.54-6.96 C368.05,822.89,367.26,823.51,366.48,824.13z"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000170241712552382156080000001604166943708314037_",
    filterUnits: "userSpaceOnUse",
    x: 351.07,
    y: 791.22,
    width: 260.94,
    height: 84.11
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend31 || (_feBlend31 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 351.07,
    y: 791.22,
    width: 260.94,
    height: 84.11,
    id: "SVGID_00000107555977193450105190000012827794743393271743_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000170241712552382156080000001604166943708314037_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000134220993052155043940000005099586888313627804_",
    filterUnits: "userSpaceOnUse",
    x: 351.07,
    y: 791.22,
    width: 260.94,
    height: 84.11
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend32 || (_feBlend32 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 351.07,
    y: 791.22,
    width: 260.94,
    height: 84.11,
    id: "SVGID_00000107555977193450105190000012827794743393271743_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000134220993052155043940000005099586888313627804_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000084488115070375363420000006297684787493285260_",
    gradientUnits: "userSpaceOnUse",
    x1: 498.2729,
    y1: 755.5844,
    x2: 469.3968,
    y2: 905.0609
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0892,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2219,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3853,
    style: {
      stopColor: "#BDBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    style: {
      stopColor: "#8B8B8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7816,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000107555977193450105190000012827794743393271743_)",
      fill: "url(#SVGID_00000084488115070375363420000006297684787493285260_)"
    },
    d: " M351.07,851.12c0,0,29.36,36.46,90.91,19.89c68.55-18.46,68.79-62.86,121.69-56.82c49.72,5.68,26.04,59.66-8.05,44.03 c0,0,65.16,16.03,55.4-39.77c-9.94-56.82-113.95-9.23-137.07,4.26C456.9,832.65,402.21,883.79,351.07,851.12z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000076598622384772318130000014693008053962695059_",
    gradientUnits: "userSpaceOnUse",
    x1: 498.2729,
    y1: 755.5844,
    x2: 469.3968,
    y2: 905.0609
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#9CA5B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    style: {
      stopColor: "#A4ACB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4298,
    style: {
      stopColor: "#BAC0C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    style: {
      stopColor: "#DEE1E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000076598622384772318130000014693008053962695059_)"
    },
    d: "M351.07,851.12 c0,0,29.36,36.46,90.91,19.89c68.55-18.46,68.79-62.86,121.69-56.82c49.72,5.68,26.04,59.66-8.05,44.03c0,0,65.16,16.03,55.4-39.77 c-9.94-56.82-113.95-9.23-137.07,4.26C456.9,832.65,402.21,883.79,351.07,851.12z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000180348062497751819830000005849997689880106383_",
    filterUnits: "userSpaceOnUse",
    x: 435.6,
    y: 480.41,
    width: 132.66,
    height: 67.98
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend33 || (_feBlend33 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 435.6,
    y: 480.41,
    width: 132.66,
    height: 67.98,
    id: "SVGID_00000032646813844065967440000001616156288373489339_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000180348062497751819830000005849997689880106383_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000174560423780850287950000003469125323175139234_",
    filterUnits: "userSpaceOnUse",
    x: 435.6,
    y: 480.41,
    width: 132.66,
    height: 67.98
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend34 || (_feBlend34 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 435.6,
    y: 480.41,
    width: 132.66,
    height: 67.98,
    id: "SVGID_00000032646813844065967440000001616156288373489339_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000174560423780850287950000003469125323175139234_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016054237157056229700000001546339383027679626_",
    gradientUnits: "userSpaceOnUse",
    x1: 515.3364,
    y1: 487.1821,
    x2: 489.7682,
    y2: 562.9401
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    style: {
      stopColor: "#FDFDFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4266,
    style: {
      stopColor: "#F5F5F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5322,
    style: {
      stopColor: "#E8E8E8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6215,
    style: {
      stopColor: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7005,
    style: {
      stopColor: "#BEBEBE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7723,
    style: {
      stopColor: "#A0A0A0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8386,
    style: {
      stopColor: "#7D7D7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9006,
    style: {
      stopColor: "#545454"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9569,
    style: {
      stopColor: "#282828"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000032646813844065967440000001616156288373489339_)",
      fill: "url(#SVGID_00000016054237157056229700000001546339383027679626_)"
    },
    d: " M564.47,548.39c4.65-4.59,4.64-12.31,2.1-18.34c-2.53-6.02-0.05-11.21-3.85-16.53c-6.11-8.54-17.64-18.28-25.94-24.7 c-5.69-4.4-12.72-6.73-19.79-8.07c-18.9-3.58-107.8,20.73-73.65,44.75c12.07,8.49,40.85,1.99,54.68,3.28 C504.5,529.39,565.4,547.47,564.47,548.39z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000073690357947264092760000005192217963325901978_",
    gradientUnits: "userSpaceOnUse",
    x1: 515.3364,
    y1: 487.1821,
    x2: 489.7682,
    y2: 562.9401
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E05D2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3032,
    style: {
      stopColor: "#E05F2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4476,
    style: {
      stopColor: "#E16435"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5584,
    style: {
      stopColor: "#E36E42"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6522,
    style: {
      stopColor: "#E67C54"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.735,
    style: {
      stopColor: "#EA8F6C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8103,
    style: {
      stopColor: "#EEA58A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8798,
    style: {
      stopColor: "#F3C0AD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.943,
    style: {
      stopColor: "#F9DED4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.42,
      fill: "url(#SVGID_00000073690357947264092760000005192217963325901978_)"
    },
    d: "M564.47,548.39 c4.65-4.59,4.64-12.31,2.1-18.34c-2.53-6.02-0.05-11.21-3.85-16.53c-6.11-8.54-17.64-18.28-25.94-24.7 c-5.69-4.4-12.72-6.73-19.79-8.07c-18.9-3.58-107.8,20.73-73.65,44.75c12.07,8.49,40.85,1.99,54.68,3.28 C504.5,529.39,565.4,547.47,564.47,548.39z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000173137549042755237660000010301654035297558188_",
    filterUnits: "userSpaceOnUse",
    x: 435.67,
    y: 480.41,
    width: 132.35,
    height: 55.53
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend35 || (_feBlend35 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 435.67,
    y: 480.41,
    width: 132.35,
    height: 55.53,
    id: "SVGID_00000152237199045084958520000002834037382955230629_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000173137549042755237660000010301654035297558188_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000043418203276967278980000017512847433611859599_",
    filterUnits: "userSpaceOnUse",
    x: 435.67,
    y: 480.41,
    width: 132.35,
    height: 55.53
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend36 || (_feBlend36 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 435.67,
    y: 480.41,
    width: 132.35,
    height: 55.53,
    id: "SVGID_00000152237199045084958520000002834037382955230629_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000043418203276967278980000017512847433611859599_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047762679648690885900000007123878171271946918_",
    gradientUnits: "userSpaceOnUse",
    x1: 507.1505,
    y1: 468.6089,
    x2: 502.4156,
    y2: 518.799
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    style: {
      stopColor: "#FDFDFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4266,
    style: {
      stopColor: "#F5F5F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5322,
    style: {
      stopColor: "#E8E8E8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6215,
    style: {
      stopColor: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7005,
    style: {
      stopColor: "#BEBEBE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7723,
    style: {
      stopColor: "#A0A0A0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8386,
    style: {
      stopColor: "#7D7D7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9006,
    style: {
      stopColor: "#545454"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9569,
    style: {
      stopColor: "#282828"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000152237199045084958520000002834037382955230629_)",
      fill: "url(#SVGID_00000047762679648690885900000007123878171271946918_)"
    },
    d: " M518.91,498.92c7.04,1.47,19.59,6.76,25.82,10.35c13.97,8.05,17.1,17.98,23.2,26.51c0.04,0.06,0.05,0.1,0.09,0.16 c-0.24-2.03-0.67-4.04-1.45-5.88c-2.53-6.02-0.05-11.21-3.85-16.53c-6.11-8.54-15.67-15.54-23.97-21.96 c-5.69-4.4-14.69-9.47-21.76-10.81c-17.9-3.39-98.53,18.24-78,40.94C450.2,505.58,491.84,493.26,518.91,498.92z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000172399737891320693180000002801059908080472235_",
    gradientUnits: "userSpaceOnUse",
    x1: 507.1505,
    y1: 468.6089,
    x2: 502.4156,
    y2: 518.799
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E05D2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3032,
    style: {
      stopColor: "#E05F2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4476,
    style: {
      stopColor: "#E16435"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5584,
    style: {
      stopColor: "#E36E42"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6522,
    style: {
      stopColor: "#E67C54"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.735,
    style: {
      stopColor: "#EA8F6C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8103,
    style: {
      stopColor: "#EEA58A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8798,
    style: {
      stopColor: "#F3C0AD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.943,
    style: {
      stopColor: "#F9DED4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.68,
      fill: "url(#SVGID_00000172399737891320693180000002801059908080472235_)"
    },
    d: "M518.91,498.92 c7.04,1.47,19.59,6.76,25.82,10.35c13.97,8.05,17.1,17.98,23.2,26.51c0.04,0.06,0.05,0.1,0.09,0.16c-0.24-2.03-0.67-4.04-1.45-5.88 c-2.53-6.02-0.05-11.21-3.85-16.53c-6.11-8.54-15.67-15.54-23.97-21.96c-5.69-4.4-14.69-9.47-21.76-10.81 c-17.9-3.39-98.53,18.24-78,40.94C450.2,505.58,491.84,493.26,518.91,498.92z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000025410277567235859050000009944580568798971041_",
    filterUnits: "userSpaceOnUse",
    x: 555.62,
    y: 699.21,
    width: 262.78,
    height: 167.86
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend37 || (_feBlend37 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 555.62,
    y: 699.21,
    width: 262.78,
    height: 167.86,
    id: "SVGID_00000147201883760210058810000004700126637376352940_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000025410277567235859050000009944580568798971041_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000044170087784374018380000005452089710020571047_",
    filterUnits: "userSpaceOnUse",
    x: 555.62,
    y: 699.21,
    width: 262.78,
    height: 167.86
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend38 || (_feBlend38 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 555.62,
    y: 699.21,
    width: 262.78,
    height: 167.86,
    id: "SVGID_00000147201883760210058810000004700126637376352940_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000044170087784374018380000005452089710020571047_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132049428875557796930000009744443665523865496_",
    gradientUnits: "userSpaceOnUse",
    x1: 724.6113,
    y1: 619.5519,
    x2: 677.3228,
    y2: 864.3398
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0892,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2219,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3853,
    style: {
      stopColor: "#BDBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    style: {
      stopColor: "#8B8B8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7816,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000147201883760210058810000004700126637376352940_)",
      fill: "url(#SVGID_00000132049428875557796930000009744443665523865496_)"
    },
    d: " M555.62,858.22c0,0,41.19,19.89,93.75,0c52.56-19.89,80.97-79.55,83.81-133.52c0,0,69.6,28.41,53.98,106.53 c0,0,28.41-34.09,17.05-72.44c-11.36-38.35,14.2,11.36,14.2,11.36s-75.55-92.64-114.48-66.2 C664.99,730.38,669.26,889.47,555.62,858.22z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000156580872505471284100000006765072303659014559_",
    gradientUnits: "userSpaceOnUse",
    x1: 724.6113,
    y1: 619.5519,
    x2: 677.3228,
    y2: 864.3398
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#9CA5B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    style: {
      stopColor: "#A4ACB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4298,
    style: {
      stopColor: "#BAC0C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    style: {
      stopColor: "#DEE1E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000156580872505471284100000006765072303659014559_)"
    },
    d: "M555.62,858.22c0,0,41.19,19.89,93.75,0 c52.56-19.89,80.97-79.55,83.81-133.52c0,0,69.6,28.41,53.98,106.53c0,0,28.41-34.09,17.05-72.44 c-11.36-38.35,14.2,11.36,14.2,11.36s-75.55-92.64-114.48-66.2C664.99,730.38,669.26,889.47,555.62,858.22z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008838473472914187500000004430796973703308694_",
    gradientUnits: "userSpaceOnUse",
    x1: 650.5845,
    y1: 683.2755,
    x2: 676.8629,
    y2: 786.2585
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E05D2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3841,
    style: {
      stopColor: "#E15F2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567,
    style: {
      stopColor: "#E36734"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7072,
    style: {
      stopColor: "#E77441"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8259,
    style: {
      stopColor: "#ED8653"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9297,
    style: {
      stopColor: "#F49E69"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9922,
    style: {
      stopColor: "#FAB07B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000008838473472914187500000004430796973703308694_)"
    },
    d: "M593.97,758.79 c0,0,12.07,12.78,14.91,22.73c2.84,9.94,12.07,22.02,31.96,23.44c19.89,1.42,80.26-8.52,86.65-101.56 c6.39-93.04-122.87-29.12-122.87-29.12L593.97,758.79z"
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st90",
    d: "M713.23,661.25c4.42,7.76,6.69,18.63,5.76,33.62c-5.76,93.04-60.14,102.98-78.06,101.56 c-17.91-1.42-26.23-13.49-28.79-23.44c-2.56-9.94-13.44-22.73-13.44-22.73l8.78-77.35c-1.82,0.84-2.86,1.35-2.86,1.35l-10.65,84.52 c0,0,12.07,12.78,14.91,22.73c2.84,9.94,12.07,22.02,31.96,23.44c19.89,1.42,80.26-8.52,86.65-101.56 C728.98,681.76,723.08,668.69,713.23,661.25z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "M699.54,654.83c15.41,5.24,25.94,18.98,24.06,47.86c-6.07,93.04-63.39,102.98-82.28,101.56 c-18.88-1.42-27.65-13.49-30.35-23.44c-2.7-9.94-14.16-22.73-14.16-22.73l10.12-84.52c0,0,4.12-2.14,10.77-5.06 c-8.01,3.27-13.08,5.77-13.08,5.77l-10.65,84.52c0,0,12.07,12.78,14.91,22.73c2.84,9.94,12.07,22.02,31.96,23.44 c19.89,1.42,80.26-8.52,86.65-101.56C729.58,673.01,717.16,659.42,699.54,654.83z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st92",
    d: "M605.33,736.99c0,0,9,9.53,11.11,16.93c2.12,7.41,9,16.41,23.81,17.46c14.82,1.06,59.8-6.35,64.56-75.68 c4.76-69.33-91.55-21.7-91.55-21.7L605.33,736.99z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "M701.55,710.92c-0.44-0.36-0.72-0.82-1.23-1.14c-22.42-14.01-42.13,12.1-44.85,15.92s-8.83,3.82-8.83,3.82 c-22.81,0.95-27.84,17.48-28.93,25.83c0.04,0.12,0.11,0.25,0.15,0.37c2.02,6.64,8.61,14.71,22.78,15.66 C654.23,772.3,694.21,766.1,701.55,710.92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st94",
    d: "M698.51,715.07c-0.4-0.33-0.66-0.75-1.13-1.04c-20.62-12.88-38.73,11.12-41.23,14.64 c-2.5,3.51-8.12,3.51-8.12,3.51c-20.97,0.87-25.6,16.07-26.6,23.74c0.04,0.11,0.11,0.23,0.14,0.34 c1.86,6.11,7.91,13.52,20.95,14.4C655,771.49,691.76,765.79,698.51,715.07z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st95",
    d: "M695.47,719.21c-0.37-0.3-0.6-0.69-1.03-0.95c-18.81-11.75-35.33,10.15-37.61,13.35 c-2.28,3.2-7.41,3.2-7.41,3.2c-19.13,0.8-23.35,14.66-24.26,21.66c0.03,0.1,0.1,0.21,0.13,0.31c1.7,5.57,7.22,12.34,19.11,13.13 C655.78,770.68,689.31,765.48,695.47,719.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st96",
    d: "M692.43,723.35c-0.33-0.28-0.55-0.62-0.93-0.86c-17-10.62-31.93,9.17-33.99,12.07c-2.06,2.9-6.7,2.9-6.7,2.9 c-17.29,0.72-21.1,13.25-21.93,19.58c0.03,0.09,0.09,0.19,0.11,0.28c1.53,5.04,6.52,11.15,17.27,11.87 C656.56,769.87,686.86,765.17,692.43,723.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M689.38,727.49c-0.3-0.25-0.49-0.55-0.83-0.77c-15.19-9.49-28.53,8.2-30.38,10.78 c-1.84,2.59-5.98,2.59-5.98,2.59c-15.45,0.64-18.86,11.84-19.59,17.49c0.03,0.08,0.08,0.17,0.1,0.25 c1.37,4.5,5.83,9.96,15.43,10.61C657.33,769.06,684.41,764.86,689.38,727.49z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062153243446293746130000001181115586612934586_",
    gradientUnits: "userSpaceOnUse",
    x1: 597.334,
    y1: 694.6653,
    x2: 686.1472,
    y2: 694.6653
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E05D2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3841,
    style: {
      stopColor: "#E15F2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567,
    style: {
      stopColor: "#E36734"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7072,
    style: {
      stopColor: "#E77441"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8259,
    style: {
      stopColor: "#ED8653"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9297,
    style: {
      stopColor: "#F49E69"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9922,
    style: {
      stopColor: "#FAB07B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000062153243446293746130000001181115586612934586_)"
    },
    d: "M599.65,727.54 c0,0,24.86,19.18,73.86-32.67c49.01-51.85-59.66-36.93-70.31-24.86C592.55,682.09,599.65,727.54,599.65,727.54z"
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M612.25,730.05c0,0,27.17-0.61,45.74-19.55c14.65-14.95,4.99-39.15-10.04-18.94 c-5.72,7.7-25.58,16.34-36.78,17.21C602.94,709.41,612.25,730.05,612.25,730.05z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M365.8,503.13c0.15-1.63,0.38-3.29,0.74-4.99C366.54,498.14,366.19,500.07,365.8,503.13z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M351.07,553.3c0,0-2.21-2.68-5.52-6.84C347.02,549.14,348.81,551.52,351.07,553.3z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "M684.53,450.55c0,0-35.78-1.2-47.23,15.98c-9.94,14.91-1.78,47.94,7.46,49.01 C656.06,516.84,684.53,450.55,684.53,450.55z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "M527.33,517.79c0,0-35.78-1.26-47.23,16.8c-9.94,15.67-1.78,50.38,7.46,51.5 C498.87,587.46,527.33,517.79,527.33,517.79z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M666.89,454.34c0,0-24.08,9.06-26.52,38.35c-2.54,30.66,6.63,23.67,17.99,19.89 c11.36-3.79,76.23-28.88,71.97-39.77C726.07,461.92,689.14,442.03,666.89,454.34z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st101",
    d: "M646.11,495.98c1.38-28.56,25.79-37.31,25.79-37.31c18.28-10.11,46.66,2.1,57.56,12.53 c-6.89-11.1-41.36-28.59-62.57-16.86c0,0-24.08,9.06-26.52,38.35c-1.72,20.68,1.91,24.21,7.93,23.17 C646.43,512.94,645.57,507.03,646.11,495.98z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st102",
    d: "M703.92,703.95c0,0,113.06,32.11,87.49,105.98c0,0,19.89-46.88-12.78-76.7c0,0,90.44,48.3,27.94,147.73 c-62.5,99.43,30.3,264.2,30.3,264.2s-51.55-123.46-44.03-188.92c9.94-86.65,135.42-166.67,20.36-301.61 S613.59,671.84,703.92,703.95z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M507.8,521.58c0,0-25.1,9-26.52,38.35c-1.42,29.36,8.26,32.29,17.05,24.15 c27.58-25.55,78.59-35.89,72.92-44.03C563.67,529.15,534.31,509.27,507.8,521.58z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st101",
    d: "M488.38,562.96c1.38-28.17,25.82-36.8,25.82-36.8c19.25-8.81,40.03-0.44,52.42,8.72 c-11.43-10.8-36.14-23.83-58.82-13.3c0,0-25.1,9-26.52,38.35c-1.11,22.99,4.59,29.64,11.33,27.6 C489.58,584.07,487.72,576.5,488.38,562.96z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M668.38,453.67c-1.55,3.54-2.44,7.44-2.44,11.56c0,15.95,12.93,28.88,28.88,28.88s28.88-12.93,28.88-28.88 c0-0.04-0.01-0.07-0.01-0.1C711.48,455.26,685.95,445.27,668.38,453.67z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M723.7,465.13c-7.55-6.1-20.19-12.22-32.89-14.04c-7.72-0.99-15.44-0.44-22.05,2.6 c-1.43,3.15-2.22,6.6-2.35,10.23c2.69-0.39,6.02-1.86,8.42-1.58c4.34,0.49,8.34,2.39,12.37,4c4.03,1.62,8.37,3.01,12.69,2.41 c4.17-0.57,8.15-2.97,12.31-2.29c4.54,0.75,7.39,4.79,9.62,8.77c1.16-3.12,1.88-6.46,1.88-9.99 C723.71,465.2,723.7,465.16,723.7,465.13z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "M432.04,537.91c0,0,0.61,3.98,1.32,10.45c10.74,10.36,22.75,20.23,28.98,30.45 c22.07,36.18-10.82,65.61-7.19,100.94c4.36-19.92,14.46-51.84,21.63-77.92C484.6,573.42,432.04,537.91,432.04,537.91z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M695.36,493.05c-15.95,0-28.88-12.93-28.88-28.88c0-3.75,0.82-7.28,2.12-10.56 c-0.07,0.03-0.14,0.04-0.21,0.07c-1.55,3.54-2.44,7.44-2.44,11.56c0,15.95,12.93,28.88,28.88,28.88c12.04,0,22.34-7.37,26.67-17.84 C716.91,486.16,706.97,493.05,695.36,493.05z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M512.37,519.91c-1.39,3.17-2.18,6.65-2.18,10.33c0,14.26,11.56,25.82,25.82,25.82 c14.26,0,25.82-11.56,25.82-25.82c0-0.03-0.01-0.06-0.01-0.09C550.89,521.33,528.07,512.4,512.37,519.91z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M679.91,465.23c0,8.24,6.68,14.91,14.91,14.91s14.91-6.68,14.91-14.91c0-4-1.62-7.6-4.19-10.28 c-4.61-1.77-9.52-3.15-14.45-3.89C684.72,452.75,679.91,458.31,679.91,465.23z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000088105229279623442990000008508664669209343915_",
    filterUnits: "userSpaceOnUse",
    x: 635.16,
    y: 541.47,
    width: 209.87,
    height: 96.7
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend39 || (_feBlend39 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 635.16,
    y: 541.47,
    width: 209.87,
    height: 96.7,
    id: "SVGID_00000016062713003753945730000014244201974926276247_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000088105229279623442990000008508664669209343915_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000124161883941848618880000004663492054658674870_",
    filterUnits: "userSpaceOnUse",
    x: 635.16,
    y: 541.47,
    width: 209.87,
    height: 96.7
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend40 || (_feBlend40 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 635.16,
    y: 541.47,
    width: 209.87,
    height: 96.7,
    id: "SVGID_00000016062713003753945730000014244201974926276247_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000124161883941848618880000004663492054658674870_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000053547766683786986680000008888369794711369139_",
    gradientUnits: "userSpaceOnUse",
    x1: 725.4003,
    y1: 617.0779,
    x2: 753.8094,
    y2: 553.1575
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    style: {
      stopColor: "#FDFDFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4266,
    style: {
      stopColor: "#F5F5F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5322,
    style: {
      stopColor: "#E8E8E8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6215,
    style: {
      stopColor: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7005,
    style: {
      stopColor: "#BEBEBE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7723,
    style: {
      stopColor: "#A0A0A0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8386,
    style: {
      stopColor: "#7D7D7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9006,
    style: {
      stopColor: "#545454"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9569,
    style: {
      stopColor: "#282828"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000016062713003753945730000014244201974926276247_)",
      fill: "url(#SVGID_00000053547766683786986680000008888369794711369139_)"
    },
    d: " M635.16,561.35c0,0,48.3-38.35,100.85-8.52c52.56,29.83,69.6,38.35,86.65,4.26c17.05-34.09,48.3,85.23-18.47,80.97 c-66.76-4.26-149.86-61.08-149.86-61.08S656.47,568.45,635.16,561.35z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000042719834479483060580000011574940879627298696_",
    gradientUnits: "userSpaceOnUse",
    x1: 725.4003,
    y1: 617.0779,
    x2: 753.8094,
    y2: 553.1575
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E05D2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4372,
    style: {
      stopColor: "#E05F2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6454,
    style: {
      stopColor: "#E16435"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8051,
    style: {
      stopColor: "#E36E42"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9393,
    style: {
      stopColor: "#E67C54"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E8855F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "url(#SVGID_00000042719834479483060580000011574940879627298696_)"
    },
    d: "M635.16,561.35 c0,0,48.3-38.35,100.85-8.52c52.56,29.83,69.6,38.35,86.65,4.26c17.05-34.09,48.3,85.23-18.47,80.97 c-66.76-4.26-149.86-61.08-149.86-61.08S656.47,568.45,635.16,561.35z"
  }), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M673.87,469.37c0,1.86-1.51,3.37-3.37,3.37c-1.86,0-3.37-1.51-3.37-3.37c0-1.86,1.51-3.37,3.37-3.37 C672.36,466,673.87,467.51,673.87,469.37z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M690.33,474.7c0,3.92-3.18,7.1-7.1,7.1c-3.92,0-7.1-3.18-7.1-7.1c0-3.92,3.18-7.1,7.1-7.1 C687.15,467.6,690.33,470.78,690.33,474.7z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M561.81,530.15c-10.92-8.83-33.74-17.76-49.44-10.24c-1.27,2.9-1.97,6.09-2.09,9.44 c2.39-0.36,5.34-1.71,7.47-1.46c3.85,0.45,7.4,2.2,10.97,3.69c3.58,1.49,7.42,2.77,11.26,2.22c3.7-0.53,7.23-2.74,10.92-2.11 c4.23,0.72,6.83,4.82,8.86,8.66c1.32-3.11,2.06-6.52,2.06-10.11C561.82,530.21,561.81,530.18,561.81,530.15z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M536.48,555.11c-14.26,0-25.82-11.56-25.82-25.82c0-3.35,0.73-6.51,1.9-9.44c-0.06,0.03-0.13,0.04-0.19,0.06 c-1.39,3.17-2.18,6.65-2.18,10.33c0,14.26,11.56,25.82,25.82,25.82c10.76,0,19.96-6.59,23.84-15.94 C555.74,548.95,546.85,555.11,536.48,555.11z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M522.67,530.24c0,7.36,5.97,13.33,13.33,13.33c7.36,0,13.33-5.97,13.33-13.33c0-3.58-1.45-6.79-3.74-9.19 c-4.12-1.59-8.51-2.81-12.91-3.47C526.97,519.09,522.67,524.06,522.67,530.24z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M517.27,533.95c0,1.67-1.35,3.02-3.02,3.02c-1.66,0-3.01-1.35-3.01-3.02c0-1.66,1.35-3.01,3.01-3.01 C515.92,530.93,517.27,532.28,517.27,533.95z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st111",
    d: "M456.27,592.37l8.99,17.77c2.81,5.56,9.28,8.22,15.19,6.24l91.47-30.62c6.37-2.13,9.94-8.91,8.08-15.37 l-5.8-20.19c-1.99-6.93-9.4-10.76-16.2-8.39l-94.66,33.04C456.16,577.35,452.84,585.6,456.27,592.37z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st112",
    points: "499.51,561.58 491.17,611.72 502.83,607.99 513.24,556.85  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st112",
    points: "519.4,554.01 508.51,607.04 516.08,605.15 526.5,552.12  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st113",
    d: "M456.39,592.31c0,0,2.27,4.39,6.25,12.08c2.06,3.65,3.81,9.4,9.59,11.24c5.59,2.29,11.89-1.84,18.93-3.91 c13.9-5.21,30.5-10.14,48.14-15.89c8.83-2.84,17.95-5.77,27.22-8.74c4.59-1.53,9.6-2.86,11.77-7.34c1.15-2.04,1.64-4.43,1.46-6.76 c-0.23-2.27-1.19-4.65-1.83-7.02l-4.32-14.18c-1.03-4.7-4.53-8.21-8.91-9.14c-4.27-1.16-8.62,1.39-13.24,2.81 c-4.5,1.58-8.95,3.15-13.32,4.68c-17.52,6.08-33.75,12.1-47.94,16.49c-7.06,2.29-13.53,4.39-19.26,6.25 c-5.69,1.93-11.08,2.99-13.4,6.79c-2.5,3.45-2.61,7.11-2.2,9.29C455.76,591.22,456.39,592.31,456.39,592.31z M456.14,592.44 c0,0-0.69-1.08-1.2-3.38c-0.51-2.24-0.55-6.05,1.97-9.81c2.39-4.17,8.14-5.52,13.6-7.6c5.65-2.11,12.02-4.49,18.97-7.09 c13.83-5.39,30.29-10.78,47.78-16.92c4.38-1.52,8.83-3.06,13.34-4.62l6.8-2.36c2.46-0.85,5.28-1.12,7.86-0.41 c5.25,1.16,9.42,5.98,10.28,11l3.86,14.31c0.58,2.4,1.5,4.68,1.73,7.35c0.15,2.6-0.46,5.24-1.78,7.46 c-1.3,2.24-3.24,4.06-5.57,5.18c-2.34,1.06-4.66,1.59-6.98,2.4c-9.19,3.2-18.24,6.36-27,9.41c-17.54,6.03-33.76,12.08-48,16.29 c-3.54,1.11-6.93,2.17-10.16,3.19c-3.26,1.22-6.96,1.19-9.85-0.05c-6.32-2.45-7.59-8.63-9.63-12.15 C458.33,596.87,456.14,592.44,456.14,592.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M457.96,590.82c0,0-4.62-8.17,5.68-14.2l12.07-4.26C475.72,572.36,457.61,581.94,457.96,590.82z"
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M531.98,538.71c0,3.51-2.84,6.35-6.35,6.35c-3.51,0-6.35-2.84-6.35-6.35c0-3.51,2.84-6.35,6.35-6.35 C529.14,532.36,531.98,535.2,531.98,538.71z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M787.86,544.3c0,0-14.2-12.78-0.71-19.89c17.26-9.08,50.43,23.44,22.73,64.63 c-27.7,41.19-75.99,4.26-75.99,4.26s-33.38-32.67-93.75-12.07c-60.37,20.6-50.43,147.02,99.43,128.55c0,0-47.59,0-61.08-27.7 c0,0,34.8,34.8,116.48,14.2c81.68-20.6,78.12-112.22,78.12-112.22s-2.13,48.3-33.38,61.08c0,0,34.8-24.15,22.02-80.97 c0,0,0,19.18-2.84,29.83c0,0,12.78-34.09-28.41-60.37c0,0-26.35-28.11-49.01-11.36C773.3,528.32,773.3,542.88,787.86,544.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000036209652662937904820000014077777401898967482_",
    filterUnits: "userSpaceOnUse",
    x: 777.58,
    y: 518.24,
    width: 32.61,
    height: 20.85
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend41 || (_feBlend41 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 777.58,
    y: 518.24,
    width: 32.61,
    height: 20.85,
    id: "SVGID_00000111164305485851628760000000953362165144940940_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000036209652662937904820000014077777401898967482_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000047050942234375676040000009271239329432098485_",
    filterUnits: "userSpaceOnUse",
    x: 777.58,
    y: 518.24,
    width: 32.61,
    height: 20.85
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend42 || (_feBlend42 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 777.58,
    y: 518.24,
    width: 32.61,
    height: 20.85,
    id: "SVGID_00000111164305485851628760000000953362165144940940_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000047050942234375676040000009271239329432098485_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000097458282144977074330000016348384631045362564_",
    gradientUnits: "userSpaceOnUse",
    x1: 819.9171,
    y1: 548.8983,
    x2: 947.7597,
    y2: 634.1268
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0892,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2219,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3853,
    style: {
      stopColor: "#BDBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    style: {
      stopColor: "#8B8B8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7816,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000111164305485851628760000000953362165144940940_)",
      fill: "url(#SVGID_00000097458282144977074330000016348384631045362564_)"
    },
    d: " M783.58,539.1c-2.71-4.35-4.38-10.49,3.57-14.68c6.79-3.57,16-0.64,23.04,6.66c-5.54-8.25-13.66-13.04-20.83-12.82 c-2.65,0.85-5.29,2.12-7.89,4.04c-1.68,1.24-2.92,2.9-3.85,4.68C777.13,532.22,782.02,537.54,783.58,539.1z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065752644803040244520000001919352990685261458_",
    gradientUnits: "userSpaceOnUse",
    x1: 819.9171,
    y1: 548.8983,
    x2: 947.7597,
    y2: 634.1268
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#9CA5B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    style: {
      stopColor: "#A4ACB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4298,
    style: {
      stopColor: "#BAC0C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    style: {
      stopColor: "#DEE1E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000065752644803040244520000001919352990685261458_)"
    },
    d: "M783.58,539.1 c-2.71-4.35-4.38-10.49,3.57-14.68c6.79-3.57,16-0.64,23.04,6.66c-5.54-8.25-13.66-13.04-20.83-12.82 c-2.65,0.85-5.29,2.12-7.89,4.04c-1.68,1.24-2.92,2.9-3.85,4.68C777.13,532.22,782.02,537.54,783.58,539.1z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000162329213344211882230000006847596034310181799_",
    filterUnits: "userSpaceOnUse",
    x: 835.92,
    y: 564.19,
    width: 28.62,
    height: 76.23
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend43 || (_feBlend43 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 835.92,
    y: 564.19,
    width: 28.62,
    height: 76.23,
    id: "SVGID_00000134214052735678045180000003238186098526859454_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000162329213344211882230000006847596034310181799_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000129912709997607638670000013240233284518499227_",
    filterUnits: "userSpaceOnUse",
    x: 835.92,
    y: 564.19,
    width: 28.62,
    height: 76.23
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend44 || (_feBlend44 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 835.92,
    y: 564.19,
    width: 28.62,
    height: 76.23,
    id: "SVGID_00000134214052735678045180000003238186098526859454_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000129912709997607638670000013240233284518499227_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029742730693380683580000001089940278454864275_",
    gradientUnits: "userSpaceOnUse",
    x1: 804.1622,
    y1: 572.5294,
    x2: 932.0035,
    y2: 657.757
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0892,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2219,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3853,
    style: {
      stopColor: "#BDBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    style: {
      stopColor: "#8B8B8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7816,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000134214052735678045180000003238186098526859454_)",
      fill: "url(#SVGID_00000029742730693380683580000001089940278454864275_)"
    },
    d: " M860.25,574.74c4.03,45.83-24.33,65.68-24.33,65.68c11.43-4.67,18.93-14.11,23.89-24.18c4.61-12.73,6.91-29.87,1.92-52.05 c0,0-0.02,9.65-1.04,19.07C860.8,580.73,860.7,577.88,860.25,574.74z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000156585046585905610950000000557722229062987138_",
    gradientUnits: "userSpaceOnUse",
    x1: 804.1622,
    y1: 572.5294,
    x2: 932.0035,
    y2: 657.757
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#9CA5B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    style: {
      stopColor: "#A4ACB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4298,
    style: {
      stopColor: "#BAC0C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    style: {
      stopColor: "#DEE1E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000156585046585905610950000000557722229062987138_)"
    },
    d: "M860.25,574.74 c4.03,45.83-24.33,65.68-24.33,65.68c11.43-4.67,18.93-14.11,23.89-24.18c4.61-12.73,6.91-29.87,1.92-52.05 c0,0-0.02,9.65-1.04,19.07C860.8,580.73,860.7,577.88,860.25,574.74z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000183244286962574004930000004995008485701916051_",
    filterUnits: "userSpaceOnUse",
    x: 776.83,
    y: 537,
    width: 11.03,
    height: 7.3
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend45 || (_feBlend45 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 776.83,
    y: 537,
    width: 11.03,
    height: 7.3,
    id: "SVGID_00000142874299435021620100000013650280808826996400_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000183244286962574004930000004995008485701916051_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000122681961659210565110000006133708165387110309_",
    filterUnits: "userSpaceOnUse",
    x: 776.83,
    y: 537,
    width: 11.03,
    height: 7.3
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend46 || (_feBlend46 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 776.83,
    y: 537,
    width: 11.03,
    height: 7.3,
    id: "SVGID_00000142874299435021620100000013650280808826996400_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000122681961659210565110000006133708165387110309_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134948197572405902510000003552272890815135410_",
    gradientUnits: "userSpaceOnUse",
    x1: 812.1125,
    y1: 560.6024,
    x2: 939.9501,
    y2: 645.8275
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0892,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2219,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3853,
    style: {
      stopColor: "#BDBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    style: {
      stopColor: "#8B8B8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7816,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000142874299435021620100000013650280808826996400_)",
      fill: "url(#SVGID_00000134948197572405902510000003552272890815135410_)"
    },
    d: " M787.86,544.3c0,0-2.17-1.97-4.01-4.79c-2.97-0.33-5.22-1.27-7.01-2.51C778.26,540.68,781.68,543.7,787.86,544.3z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067943808845697954900000017027637955135219874_",
    gradientUnits: "userSpaceOnUse",
    x1: 812.1125,
    y1: 560.6024,
    x2: 939.9501,
    y2: 645.8275
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#9CA5B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    style: {
      stopColor: "#A4ACB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4298,
    style: {
      stopColor: "#BAC0C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    style: {
      stopColor: "#DEE1E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000067943808845697954900000017027637955135219874_)"
    },
    d: "M787.86,544.3c0,0-2.17-1.97-4.01-4.79 c-2.97-0.33-5.22-1.27-7.01-2.51C778.26,540.68,781.68,543.7,787.86,544.3z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000004515860444997938640000012650813405232789896_",
    filterUnits: "userSpaceOnUse",
    x: 674.7,
    y: 584.08,
    width: 198.41,
    height: 118.73
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend47 || (_feBlend47 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 674.7,
    y: 584.08,
    width: 198.41,
    height: 118.73,
    id: "SVGID_00000183220979542189705370000017605099023036864148_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000004515860444997938640000012650813405232789896_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000049913281531081650030000012808059658257081762_",
    filterUnits: "userSpaceOnUse",
    x: 674.7,
    y: 584.08,
    width: 198.41,
    height: 118.73
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend48 || (_feBlend48 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 674.7,
    y: 584.08,
    width: 198.41,
    height: 118.73,
    id: "SVGID_00000183220979542189705370000017605099023036864148_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000049913281531081650030000012808059658257081762_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111912007553724858720000004044317007971309992_",
    gradientUnits: "userSpaceOnUse",
    x1: 766.9189,
    y1: 628.3945,
    x2: 894.7601,
    y2: 713.6221
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0892,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2219,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3853,
    style: {
      stopColor: "#BDBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    style: {
      stopColor: "#8B8B8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7816,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000183220979542189705370000017605099023036864148_)",
      fill: "url(#SVGID_00000111912007553724858720000004044317007971309992_)"
    },
    d: " M873.09,584.08c0,0-1,21.46-10.9,39.57c-8.69,26.51-27.95,57.06-71.01,67.91c-81.68,20.6-116.48-14.2-116.48-14.2 c1.62,3.33,3.76,6.24,6.22,8.81c-0.88-1.3-1.73-2.63-2.43-4.08c0,0,34.8,34.8,116.48,14.2 C876.64,675.69,873.09,584.08,873.09,584.08z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000087377340420862656290000001754894478186027920_",
    gradientUnits: "userSpaceOnUse",
    x1: 766.9189,
    y1: 628.3945,
    x2: 894.7601,
    y2: 713.6221
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#9CA5B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    style: {
      stopColor: "#A4ACB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4298,
    style: {
      stopColor: "#BAC0C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    style: {
      stopColor: "#DEE1E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000087377340420862656290000001754894478186027920_)"
    },
    d: "M873.09,584.08c0,0-1,21.46-10.9,39.57 c-8.69,26.51-27.95,57.06-71.01,67.91c-81.68,20.6-116.48-14.2-116.48-14.2c1.62,3.33,3.76,6.24,6.22,8.81 c-0.88-1.3-1.73-2.63-2.43-4.08c0,0,34.8,34.8,116.48,14.2C876.64,675.69,873.09,584.08,873.09,584.08z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000173850356963159117880000003596497618987331202_",
    filterUnits: "userSpaceOnUse",
    x: 847.24,
    y: 547.75,
    width: 10.58,
    height: 30.77
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend49 || (_feBlend49 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 847.24,
    y: 547.75,
    width: 10.58,
    height: 30.77,
    id: "SVGID_00000043449575776982026120000005257218695360414368_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000173850356963159117880000003596497618987331202_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000062873556044650737390000007447984090375478442_",
    filterUnits: "userSpaceOnUse",
    x: 847.24,
    y: 547.75,
    width: 10.58,
    height: 30.77
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend50 || (_feBlend50 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 847.24,
    y: 547.75,
    width: 10.58,
    height: 30.77,
    id: "SVGID_00000043449575776982026120000005257218695360414368_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000062873556044650737390000007447984090375478442_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018196739568898871840000000683340153963449771_",
    gradientUnits: "userSpaceOnUse",
    x1: 823.2389,
    y1: 543.9133,
    x2: 951.0833,
    y2: 629.1429
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0892,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2219,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3853,
    style: {
      stopColor: "#BDBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    style: {
      stopColor: "#8B8B8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7816,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000043449575776982026120000005257218695360414368_)",
      fill: "url(#SVGID_00000018196739568898871840000000683340153963449771_)"
    },
    d: " M857.82,565.07c-2.02-5.54-5.37-11.44-10.58-17.32c8.38,11.64,9.99,22.9,9.66,30.78C857.43,573.6,857.7,568.71,857.82,565.07z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000046315979937979773270000009990063479970723712_",
    gradientUnits: "userSpaceOnUse",
    x1: 823.2389,
    y1: 543.9133,
    x2: 951.0833,
    y2: 629.1429
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#9CA5B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    style: {
      stopColor: "#A4ACB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4298,
    style: {
      stopColor: "#BAC0C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    style: {
      stopColor: "#DEE1E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000046315979937979773270000009990063479970723712_)"
    },
    d: "M857.82,565.07 c-2.02-5.54-5.37-11.44-10.58-17.32c8.38,11.64,9.99,22.9,9.66,30.78C857.43,573.6,857.7,568.71,857.82,565.07z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000166646068259577610180000007442074770159117722_",
    filterUnits: "userSpaceOnUse",
    x: 619.17,
    y: 674.19,
    width: 120.4,
    height: 37.43
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend51 || (_feBlend51 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 619.17,
    y: 674.19,
    width: 120.4,
    height: 37.43,
    id: "SVGID_00000101822809303777537310000010434044737230417561_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000166646068259577610180000007442074770159117722_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000061474118811069964870000012231259957509209996_",
    filterUnits: "userSpaceOnUse",
    x: 619.17,
    y: 674.19,
    width: 120.4,
    height: 37.43
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend52 || (_feBlend52 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 619.17,
    y: 674.19,
    width: 120.4,
    height: 37.43,
    id: "SVGID_00000101822809303777537310000010434044737230417561_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000061474118811069964870000012231259957509209996_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132051343096472536510000018153497859829707164_",
    gradientUnits: "userSpaceOnUse",
    x1: 709.3508,
    y1: 714.7466,
    x2: 837.191,
    y2: 799.9735
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0892,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2219,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3853,
    style: {
      stopColor: "#BDBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    style: {
      stopColor: "#8B8B8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7816,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000101822809303777537310000010434044737230417561_)",
      fill: "url(#SVGID_00000132051343096472536510000018153497859829707164_)"
    },
    d: " M619.17,674.19c18.53,25.17,56.84,43.42,120.4,35.59c0,0-11.13-0.03-24.13-3.15C667.67,708.47,636.55,694.13,619.17,674.19z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000147191357869715330270000001308670294360711815_",
    gradientUnits: "userSpaceOnUse",
    x1: 709.3508,
    y1: 714.7466,
    x2: 837.191,
    y2: 799.9735
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#9CA5B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    style: {
      stopColor: "#A4ACB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4298,
    style: {
      stopColor: "#BAC0C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    style: {
      stopColor: "#DEE1E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000147191357869715330270000001308670294360711815_)"
    },
    d: "M619.17,674.19 c18.53,25.17,56.84,43.42,120.4,35.59c0,0-11.13-0.03-24.13-3.15C667.67,708.47,636.55,694.13,619.17,674.19z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "M529.34,464.05c0,0,58.71,20.48,45.93,92.57c0,0-4.74-54.92-47.35-71.26 C485.31,469.02,529.34,464.05,529.34,464.05z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "M735.35,486.61l3.86,14.31l84.87-91.08c0,0-0.93-9.35-4.5-10.89C816.01,397.4,735.35,486.61,735.35,486.61z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "M591.84,562.41c0,0-7.81-4.97-25.92-1.42l8.88-6.04C574.8,554.96,584.21,553.89,591.84,562.41z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st138",
    d: "M785.26,441.12c-3.2,5.1-6.95,9.85-11.18,14.14c14.81-15.38,29.25-31.11,43.3-47.18 c-3.09,2.62-6.59,4.76-10.34,6.29c4.34-4.32,8-9.33,10.8-14.77c-21.51,20.88-42,42.81-61.39,65.67 c-4.13,4.87-8.72,9.12-13.37,13.49c-2.24,2.11-5.98,5.25-7.57,7.88c-1.6,2.63-0.42,5.64,1.06,8.34c0.39-0.94,1.97-0.2,2.06,0.82 c0.08,1.01-0.59,1.92-0.84,2.9c-0.29,1.12,0.28,1.94,1.19,2.04c-0.17-2.87,7.16-9.23,2.24-10.57c-2.63-0.72-6.86-3.7-5.07-2.68 c3.25,1.84,6.57-3.53,8.33-5.37C757.8,468.2,771.41,454.53,785.26,441.12z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000051365114535387489240000006588151090876515749_",
    filterUnits: "userSpaceOnUse",
    x: 605.33,
    y: 585.5,
    width: 234.38,
    height: 116.48
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend53 || (_feBlend53 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 605.33,
    y: 585.5,
    width: 234.38,
    height: 116.48,
    id: "SVGID_00000146474255645343086530000002171735287843742894_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000051365114535387489240000006588151090876515749_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000119806472680547323570000018100072468064723131_",
    filterUnits: "userSpaceOnUse",
    x: 605.33,
    y: 585.5,
    width: 234.38,
    height: 116.48
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend54 || (_feBlend54 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 605.33,
    y: 585.5,
    width: 234.38,
    height: 116.48,
    id: "SVGID_00000146474255645343086530000002171735287843742894_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000119806472680547323570000018100072468064723131_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000045588494169950822160000001881751198580191649_",
    gradientUnits: "userSpaceOnUse",
    x1: 643.1846,
    y1: 546.8365,
    x2: 757.8117,
    y2: 645.4352
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0892,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2219,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3853,
    style: {
      stopColor: "#BDBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    style: {
      stopColor: "#8B8B8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7816,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000146474255645343086530000002171735287843742894_)",
      fill: "url(#SVGID_00000045588494169950822160000001881751198580191649_)"
    },
    d: " M605.33,615.8c0,0,27.46,73.86,79.07,86.17c0,0-44.51-16.1-54.92-62.03c0,0,8.52,30.78,42.14,41.19c0,0-37.88-25.1-39.3-59.66 c0,0,42.14,69.13,152.46,34.56c0,0-42.61,13.73-89.02-2.84c0,0,107.95,36.93,143.94-67.71c0,0-17.99,67.71-90.44,63.92 c-72.44-3.79-105.11-44.03-113.64-55.87c0,0,21.78,48.3,85.23,58.71c63.45,10.42,0.95-1.42-0.47-1.89 c-1.42-0.47-69.13-3.31-92.8-53.98L605.33,615.8z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000042712895756511394160000012698805708411189405_",
    gradientUnits: "userSpaceOnUse",
    x1: 643.1846,
    y1: 546.8365,
    x2: 757.8117,
    y2: 645.4352
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#9CA5B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    style: {
      stopColor: "#A4ACB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4298,
    style: {
      stopColor: "#BAC0C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    style: {
      stopColor: "#DEE1E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000042712895756511394160000012698805708411189405_)"
    },
    d: "M605.33,615.8 c0,0,27.46,73.86,79.07,86.17c0,0-44.51-16.1-54.92-62.03c0,0,8.52,30.78,42.14,41.19c0,0-37.88-25.1-39.3-59.66 c0,0,42.14,69.13,152.46,34.56c0,0-42.61,13.73-89.02-2.84c0,0,107.95,36.93,143.94-67.71c0,0-17.99,67.71-90.44,63.92 c-72.44-3.79-105.11-44.03-113.64-55.87c0,0,21.78,48.3,85.23,58.71c63.45,10.42,0.95-1.42-0.47-1.89 c-1.42-0.47-69.13-3.31-92.8-53.98L605.33,615.8z"
  }), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M555.25,576.24c1.53,2.04,0.5,5.4-2.31,7.5c-2.8,2.1-6.32,2.16-7.85,0.12c-1.53-2.04-0.5-5.4,2.31-7.5 C550.21,574.25,553.72,574.2,555.25,576.24z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st113",
    d: "M735.25,486.51c13.47-15.58,27.51-30.62,41.61-45.6c14.17-14.91,29.07-29.14,42.93-44.35l0.44-0.48 l0.39,0.54l6.87,9.5l0.32,0.44l-0.38,0.42c-14.36,15.97-28.66,32-43.25,47.76c-14.57,15.78-29.54,31.18-44.47,46.62l-0.85,0.88 l-0.27-1.16l-3.38-14.51L735.25,486.51z M735.51,486.65l4.34,14.09l-1.12-0.28c14.31-16.02,28.57-32.09,43.24-47.77 c14.64-15.71,29.58-31.14,44.45-46.64l-0.06,0.85l-6.63-9.67l0.82,0.06c-14.41,14.69-27.79,30.35-41.89,45.33 C764.52,457.52,750.29,472.35,735.51,486.65z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000180340381607490223890000014591321564708600230_",
    filterUnits: "userSpaceOnUse",
    x: 473.64,
    y: 72.9,
    width: 359.45,
    height: 220.05
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend55 || (_feBlend55 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 473.64,
    y: 72.9,
    width: 359.45,
    height: 220.05,
    id: "SVGID_00000158714120200438296150000002838321927065544069_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000180340381607490223890000014591321564708600230_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000108280064587337255340000003152794093919206313_",
    filterUnits: "userSpaceOnUse",
    x: 473.64,
    y: 72.9,
    width: 359.45,
    height: 220.05
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend56 || (_feBlend56 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 473.64,
    y: 72.9,
    width: 359.45,
    height: 220.05,
    id: "SVGID_00000158714120200438296150000002838321927065544069_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000108280064587337255340000003152794093919206313_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067946515270691745050000007152710401029833626_",
    gradientUnits: "userSpaceOnUse",
    x1: 473.636,
    y1: 182.9288,
    x2: 833.0815,
    y2: 182.9288
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1275,
    style: {
      stopColor: "#040404"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2524,
    style: {
      stopColor: "#101010"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3764,
    style: {
      stopColor: "#232323"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4998,
    style: {
      stopColor: "#3F3F3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6229,
    style: {
      stopColor: "#636363"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7458,
    style: {
      stopColor: "#8F8F8F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8684,
    style: {
      stopColor: "#C2C2C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9881,
    style: {
      stopColor: "#FDFDFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9922,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000158714120200438296150000002838321927065544069_)",
      fill: "url(#SVGID_00000067946515270691745050000007152710401029833626_)"
    },
    d: " M833.08,121.48c0,0-7.4-31-71.05-48.58c16.58,14.15,34.56,27.73,45.09,46.81c10.54,19.1,11.17,45.86-5.14,60.35 c-16.31,14.49-49.24,4.08-48.37-17.72c-25.27,16.68-54.63,27.12-84.76,30.14c-42.64,4.27-89.58-5.43-126.87,20.92 c-22.84,16.13-57.02,53.72-68.34,79.56c80.92-4.91,148.56-59.39,235.75-45.29c34.27,5.54,67.15,19.95,101.85,20.74 c7.04,0.16,14.42-0.47,21.12-2.56L833.08,121.48z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119101779269979899410000013748731233848677814_",
    gradientUnits: "userSpaceOnUse",
    x1: 473.636,
    y1: 182.9288,
    x2: 833.0815,
    y2: 182.9288
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8C0503"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9803,
    style: {
      stopColor: "#8C0503"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9922,
    style: {
      stopColor: "#8C0503"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.62,
      fill: "url(#SVGID_00000119101779269979899410000013748731233848677814_)"
    },
    d: "M833.08,121.48 c0,0-7.4-31-71.05-48.58c16.58,14.15,34.56,27.73,45.09,46.81c10.54,19.1,11.17,45.86-5.14,60.35 c-16.31,14.49-49.24,4.08-48.37-17.72c-25.27,16.68-54.63,27.12-84.76,30.14c-42.64,4.27-89.58-5.43-126.87,20.92 c-22.84,16.13-57.02,53.72-68.34,79.56c80.92-4.91,148.56-59.39,235.75-45.29c34.27,5.54,67.15,19.95,101.85,20.74 c7.04,0.16,14.42-0.47,21.12-2.56L833.08,121.48z"
  }), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st147",
    d: "M428.49,523c-4.82-14.35-11.85-20.86-4.3-33.97c7.92-13.76,19.18-27.16,34.69-30.58 c5.59-1.23,11.54-1.11,16.79-3.38c14.52-6.29,16.04-26.07,14.33-41.8c-0.73-6.68-3.19-14.99-9.87-15.76 c-4.07-0.47-7.73,2.29-10.9,4.9c-43.22,35.62-95.06,63.84-105.27,120.8c-3.85,21.49-7.94,27.37,18.84,38.89 c23.17,9.97,52.29,6.59,76.81,13.62C445.9,561.65,435.21,543.02,428.49,523z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "M824.8,248.85c-32.67-28.41-77.41-19.18-77.41-19.18c18.47-7.81,42.61-2.84,42.61-2.84 c-41.68-16.14-81.34-15.86-104.96-13.47c17.61-6.05,24.71-17.78,24.71-17.78c-19.89,21.31-64.63,12.07-81.68,11.36 c-17.05-0.71-36.93,7.1-51.85,21.31c-14.91,14.2-51.14,34.09-51.14,34.09c6.39-12.78,46.16-39.06,46.16-39.06 c-19.89,7.1-37.64,19.89-70.31,41.9c-32.67,22.02-44.74,20.6-88.78,26.99c-44.03,6.39-56.82,36.93-56.82,36.93 c13.49-21.31,59.66-24.86,59.66-24.86c-99.43,42.61-100.85,93.04-100.85,93.04c4.97-14.2,19.89-25.57,19.89-25.57 c-31.96,79.55-68.18,54.69-68.18,54.69c17.76,20.6,42.61-1.42,42.61-1.42c-23.44,24.86-4.74,56.34-4.74,56.34 c0-7.57,2.84-21.78,2.84-21.78s5.68,19.89,4.74,32.2c-0.73,9.48,23.19,40.78,34.26,54.71c-5.22-9.57-5.94-23.25-5.94-29.92 c0.77,9.22,8.44,20.46,17.16,29.97c-10.66-17.73-16.95-52.22,15.69-81.75c0,0-2.42,8.11-5.48,17.39 c7.85-8.82,20.43-18.24,40.35-24.49c45.26-14.2,69-42.61,94.97-66.05c0,0,5.19,7.81,0.74,19.89c0,0,34.87-35.51,65.29-44.74 c30.42-9.23,59.36-36.22,102.39-37.64c0,0-22.26,4.26-40.81,16.34c0,0,74.2-26.99,123.91,16.34c0,0-22.26-12.07-51.94-12.07 c0,0,123.88,21.71,130.96,69.74l8.97-71.16C841.84,348.28,857.47,277.26,824.8,248.85z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000132779118275598131760000008379294608748341139_",
    filterUnits: "userSpaceOnUse",
    x: 265.85,
    y: 195.58,
    width: 579.73,
    height: 350.93
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend57 || (_feBlend57 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 265.85,
    y: 195.58,
    width: 579.73,
    height: 350.93,
    id: "SVGID_00000153683929385904371500000013415500924675176889_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000132779118275598131760000008379294608748341139_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000089556413913397611320000004396346304504387258_",
    filterUnits: "userSpaceOnUse",
    x: 265.85,
    y: 195.58,
    width: 579.73,
    height: 350.93
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend58 || (_feBlend58 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 265.85,
    y: 195.58,
    width: 579.73,
    height: 350.93,
    id: "SVGID_00000153683929385904371500000013415500924675176889_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000089556413913397611320000004396346304504387258_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000117638195702356908830000016229648539538479773_",
    gradientUnits: "userSpaceOnUse",
    x1: 377.5884,
    y1: 371.0459,
    x2: 850.1804,
    y2: 371.0459
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0886,
    style: {
      stopColor: "#070707"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2156,
    style: {
      stopColor: "#1A1A1A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3659,
    style: {
      stopColor: "#393939"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5339,
    style: {
      stopColor: "#646464"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7167,
    style: {
      stopColor: "#9C9C9C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.909,
    style: {
      stopColor: "#DEDEDE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9961,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000153683929385904371500000013415500924675176889_)",
      fill: "url(#SVGID_00000117638195702356908830000016229648539538479773_)"
    },
    d: " M824.8,248.85c-32.67-28.41-77.41-19.18-77.41-19.18c18.47-7.81,42.61-2.84,42.61-2.84c-41.68-16.14-81.34-15.86-104.96-13.47 c17.61-6.05,24.71-17.78,24.71-17.78c-19.89,21.31-64.63,12.07-81.68,11.36c-17.05-0.71-36.93,7.1-51.85,21.31 c-14.91,14.2-51.14,34.09-51.14,34.09c6.39-12.78,46.16-39.06,46.16-39.06c-19.89,7.1-37.64,19.89-70.31,41.9 c-32.67,22.02-44.74,20.6-88.78,26.99c-44.03,6.39-56.82,36.93-56.82,36.93c13.49-21.31,59.66-24.86,59.66-24.86 c-99.43,42.61-100.85,93.04-100.85,93.04c4.97-14.2,19.89-25.57,19.89-25.57c-31.96,79.55-68.18,54.69-68.18,54.69 c17.76,20.6,42.61-1.42,42.61-1.42c-23.44,24.86-4.74,56.34-4.74,56.34c0-7.57,2.84-21.78,2.84-21.78s5.68,19.89,4.74,32.2 c-0.73,9.48,23.19,40.78,34.26,54.71c-5.22-9.57-5.94-23.25-5.94-29.92c0.77,9.22,8.44,20.46,17.16,29.97 c-10.66-17.73-16.95-52.22,15.69-81.75c0,0-2.42,8.11-5.48,17.39c7.85-8.82,20.43-18.24,40.35-24.49 c45.26-14.2,69-42.61,94.97-66.05c0,0,5.19,7.81,0.74,19.89c0,0,34.87-35.51,65.29-44.74c30.42-9.23,59.36-36.22,102.39-37.64 c0,0-22.26,4.26-40.81,16.34c0,0,74.2-26.99,123.91,16.34c0,0-22.26-12.07-51.94-12.07c0,0,123.88,21.71,130.96,69.74l8.97-71.16 C841.84,348.28,857.47,277.26,824.8,248.85z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000032620094433126371760000015757716109795428266_",
    gradientUnits: "userSpaceOnUse",
    x1: 377.5884,
    y1: 371.0459,
    x2: 850.1804,
    y2: 371.0459
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1664,
    style: {
      stopColor: "#F8F9FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4048,
    style: {
      stopColor: "#E5E8EB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6866,
    style: {
      stopColor: "#C6CBD2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9961,
    style: {
      stopColor: "#9CA5B0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.65,
      fill: "url(#SVGID_00000032620094433126371760000015757716109795428266_)"
    },
    d: "M824.8,248.85 c-32.67-28.41-77.41-19.18-77.41-19.18c18.47-7.81,42.61-2.84,42.61-2.84c-41.68-16.14-81.34-15.86-104.96-13.47 c17.61-6.05,24.71-17.78,24.71-17.78c-19.89,21.31-64.63,12.07-81.68,11.36c-17.05-0.71-36.93,7.1-51.85,21.31 c-14.91,14.2-51.14,34.09-51.14,34.09c6.39-12.78,46.16-39.06,46.16-39.06c-19.89,7.1-37.64,19.89-70.31,41.9 c-32.67,22.02-44.74,20.6-88.78,26.99c-44.03,6.39-56.82,36.93-56.82,36.93c13.49-21.31,59.66-24.86,59.66-24.86 c-99.43,42.61-100.85,93.04-100.85,93.04c4.97-14.2,19.89-25.57,19.89-25.57c-31.96,79.55-68.18,54.69-68.18,54.69 c17.76,20.6,42.61-1.42,42.61-1.42c-23.44,24.86-4.74,56.34-4.74,56.34c0-7.57,2.84-21.78,2.84-21.78s5.68,19.89,4.74,32.2 c-0.73,9.48,23.19,40.78,34.26,54.71c-5.22-9.57-5.94-23.25-5.94-29.92c0.77,9.22,8.44,20.46,17.16,29.97 c-10.66-17.73-16.95-52.22,15.69-81.75c0,0-2.42,8.11-5.48,17.39c7.85-8.82,20.43-18.24,40.35-24.49 c45.26-14.2,69-42.61,94.97-66.05c0,0,5.19,7.81,0.74,19.89c0,0,34.87-35.51,65.29-44.74c30.42-9.23,59.36-36.22,102.39-37.64 c0,0-22.26,4.26-40.81,16.34c0,0,74.2-26.99,123.91,16.34c0,0-22.26-12.07-51.94-12.07c0,0,123.88,21.71,130.96,69.74l8.97-71.16 C841.84,348.28,857.47,277.26,824.8,248.85z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000096749888621869742010000004106060393441641356_",
    filterUnits: "userSpaceOnUse",
    x: 406.47,
    y: 690.54,
    width: 218.03,
    height: 111.9
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend59 || (_feBlend59 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 406.47,
    y: 690.54,
    width: 218.03,
    height: 111.9,
    id: "SVGID_00000070089409386254964500000016729331832246122123_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000096749888621869742010000004106060393441641356_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000120561155969777054270000012666614402298383237_",
    filterUnits: "userSpaceOnUse",
    x: 406.47,
    y: 690.54,
    width: 218.03,
    height: 111.9
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend60 || (_feBlend60 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 406.47,
    y: 690.54,
    width: 218.03,
    height: 111.9,
    id: "SVGID_00000070089409386254964500000016729331832246122123_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000120561155969777054270000012666614402298383237_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005239044739359299200000004117382709769857468_",
    gradientUnits: "userSpaceOnUse",
    x1: 504.7814,
    y1: 762.4323,
    x2: 426.183,
    y2: 804.0989
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0892,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2219,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3853,
    style: {
      stopColor: "#BDBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    style: {
      stopColor: "#8B8B8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7816,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000070089409386254964500000016729331832246122123_)",
      fill: "url(#SVGID_00000005239044739359299200000004117382709769857468_)"
    },
    d: " M411.28,779.8c3.23,0.45,6.32,0.99,9.87,1.24c0,0,30.54,34.8,84.52,15.62c0,0,72.44,7.1,103.69-40.48 c13.24-20.16,16.48-43.99,14.69-65.65l-217.58,63.99C406.47,754.53,409.25,765.38,411.28,779.8z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116924040257760686340000003345865392231622591_",
    gradientUnits: "userSpaceOnUse",
    x1: 504.7814,
    y1: 762.4323,
    x2: 426.183,
    y2: 804.0989
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#9CA5B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    style: {
      stopColor: "#A4ACB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4298,
    style: {
      stopColor: "#BAC0C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    style: {
      stopColor: "#DEE1E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116924040257760686340000003345865392231622591_)"
    },
    d: "M411.28,779.8 c3.23,0.45,6.32,0.99,9.87,1.24c0,0,30.54,34.8,84.52,15.62c0,0,72.44,7.1,103.69-40.48c13.24-20.16,16.48-43.99,14.69-65.65 l-217.58,63.99C406.47,754.53,409.25,765.38,411.28,779.8z"
  }), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M486.74,429.25c0,0,11.87-4.74,11.87-17.99c0,0-29.68,40.01-63.81,52.08c-34.13,12.07-40.07,76.7-40.07,76.7 s-13.36-12.07-17.81-30.54c0,0-3.71,19.89,8.16,34.8c0,0-24.49-17.76-18.55-46.16c0,0-8.9,48.3,12.61,53.98 c21.52,5.68,27.45-2.13,27.45-2.13s-28.19,16.34-41.55,6.39c-13.36-9.94-33.39-54.69,7.42-91.62c0,0-17.81,59.67-17.81,40.48 c0-2.84,7.42-33.38,52.68-47.59c45.26-14.2,69-42.61,94.97-66.05c0,0,5.19,7.81,0.74,19.89c0,0,34.87-35.51,65.29-44.74 c30.42-9.23,59.36-36.22,102.39-37.64c0,0-22.26,4.26-40.81,16.34c0,0,74.2-26.99,123.91,16.34c0,0-22.26-12.07-51.94-12.07 c0,0,129.85,22.73,131.33,73.15l1.86,15.27c0,0-3.71-29.83-22.63-39.77c-18.92-9.94,7.79,10.3,7.79,10.3s-40.07-7.81-51.94-26.99 c-11.87-19.18-100.54-25.21-127.62-14.91c-27.08,10.3-25.6-8.17-88.67,23.79c0,0,15.21-13.49,28.94-17.05 c0,0-38.95,9.59-55.65,29.47C508.62,422.85,486.74,429.25,486.74,429.25z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st157",
    d: "M540.47,621.95c0,0-15.62-7.1-34.09,21.31c-18.47,28.41-42.61,60.37-77.41,62.5 c-34.8,2.13-49.72-44.74-21.31-54.69c28.41-9.94,19.18,24.15,19.18,24.15s14.91-27.7-13.49-31.96 c-28.41-4.26-39.77,25.57-39.77,25.57s-29.83,42.61,15.62,78.84c0,0-34.8-12.07-37.64-58.24c0,0-16.34,78.12,75.28,84.52 c0,0,30.54,34.8,84.52,15.62c0,0,72.44,7.1,103.69-40.48s7.1-115.77-8.52-127.13C590.89,610.59,540.47,621.95,540.47,621.95z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M540.47,621.95c0,0-15.62-7.1-34.09,21.31c-18.47,28.41-42.61,60.37-77.41,62.5 c-34.8,2.13-49.72-44.74-21.31-54.69c28.41-9.94,19.18,24.15,19.18,24.15s14.91-27.7-13.49-31.96 c-28.41-4.26-39.77,25.57-39.77,25.57s-29.83,42.61,15.62,78.84c0,0-34.8-12.07-37.64-58.24c0,0-16.34,78.12,75.28,84.52 c0,0,30.54,34.8,84.52,15.62c0,0,72.44,7.1,103.69-40.48s7.1-115.77-8.52-127.13C590.89,610.59,540.47,621.95,540.47,621.95z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M422.57,773.23c-4.68-0.33-8.9-0.96-13.04-1.64c4.08,0.82,8.57,1.38,13.22,1.84 C422.69,773.36,422.57,773.23,422.57,773.23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M536.21,621.24c0,0,0.18-0.04,0.25-0.06c-0.14-0.01-0.28-0.01-0.42-0.01 C536.14,621.22,536.21,621.24,536.21,621.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M407.66,651.07c3.55-1.24,6.51-1.8,8.97-1.82c-3.08-1.06-7.3-0.97-13.23,1.11 c-26.88,9.41-14.95,51.82,15.89,54.56C391.69,698.85,382.06,660.03,407.66,651.07z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M606.52,621.95c-3.3-2.4-8.21-3.75-13.81-4.44c3.79,0.8,7.12,1.96,9.55,3.73 c15.62,11.36,39.77,79.55,8.52,127.13s-103.69,40.48-103.69,40.48c-16.21,5.76-30.26,6.6-42.05,5.02 c12.61,2.41,28.09,2.16,46.31-4.31c0,0,72.44,7.1,103.69-40.48S622.14,633.32,606.52,621.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M425.25,653.03c5.6,7.18,1.58,22.19,1.58,22.19s14.91-27.7-13.49-31.96c-0.56-0.08-1.08-0.07-1.63-0.13 C419.52,644.9,423.51,648.66,425.25,653.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M384.93,746.95c-1.47-1.17-2.65-2.36-3.97-3.55c-10.48-6.69-27.46-22.31-29.41-53.98c0,0-1.51,7.36-1.01,17.7 C359.82,738.13,384.93,746.95,384.93,746.95z"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000092454888368537048960000009872311742723124614_",
    filterUnits: "userSpaceOnUse",
    x: 493.12,
    y: 625.27,
    width: 120.89,
    height: 157.14
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend61 || (_feBlend61 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 493.12,
    y: 625.27,
    width: 120.89,
    height: 157.14,
    id: "SVGID_00000163069514671142263910000017178570171836908466_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000092454888368537048960000009872311742723124614_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000165943286903003692290000014526494609812617400_",
    filterUnits: "userSpaceOnUse",
    x: 493.12,
    y: 625.27,
    width: 120.89,
    height: 157.14
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend62 || (_feBlend62 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 493.12,
    y: 625.27,
    width: 120.89,
    height: 157.14,
    id: "SVGID_00000163069514671142263910000017178570171836908466_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000165943286903003692290000014526494609812617400_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170986923877406866980000018378314658096188574_",
    gradientUnits: "userSpaceOnUse",
    x1: 615.655,
    y1: 617.2663,
    x2: 543.6856,
    y2: 765.9401
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0892,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2219,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3853,
    style: {
      stopColor: "#BDBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    style: {
      stopColor: "#8B8B8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7816,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000163069514671142263910000017178570171836908466_)",
      fill: "url(#SVGID_00000170986923877406866980000018378314658096188574_)"
    },
    d: " M576.45,639c0,0,24.62,90.91-60.61,128.79c0,0,60.61-13.26,71.97-79.55c0,0-3.79,104.17-94.7,92.8c0,0,86.65,15.39,113.64-57.05 c19.94-53.52-7.58-94.46-7.58-94.46s18.94,41.9-3.79,78.12c0,0,18.47-36.93-7.81-82.39c0,0,9.23,34.09-2.13,51.85 C585.45,677.12,587.34,659.83,576.45,639z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129168750334713013680000004085378814404257946_",
    gradientUnits: "userSpaceOnUse",
    x1: 615.655,
    y1: 617.2663,
    x2: 543.6856,
    y2: 765.9401
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#9CA5B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    style: {
      stopColor: "#A4ACB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4298,
    style: {
      stopColor: "#BAC0C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    style: {
      stopColor: "#DEE1E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000129168750334713013680000004085378814404257946_)"
    },
    d: "M576.45,639c0,0,24.62,90.91-60.61,128.79 c0,0,60.61-13.26,71.97-79.55c0,0-3.79,104.17-94.7,92.8c0,0,86.65,15.39,113.64-57.05c19.94-53.52-7.58-94.46-7.58-94.46 s18.94,41.9-3.79,78.12c0,0,18.47-36.93-7.81-82.39c0,0,9.23,34.09-2.13,51.85C585.45,677.12,587.34,659.83,576.45,639z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000133493975600223099530000014931359216243990181_",
    filterUnits: "userSpaceOnUse",
    x: 375.7,
    y: 654.15,
    width: 96.59,
    height: 80.72
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend63 || (_feBlend63 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 375.7,
    y: 654.15,
    width: 96.59,
    height: 80.72,
    id: "SVGID_00000004548394983747850520000015630393049360938160_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000133493975600223099530000014931359216243990181_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000132776606060288709010000007406660529857054641_",
    filterUnits: "userSpaceOnUse",
    x: 375.7,
    y: 654.15,
    width: 96.59,
    height: 80.72
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend64 || (_feBlend64 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 375.7,
    y: 654.15,
    width: 96.59,
    height: 80.72,
    id: "SVGID_00000004548394983747850520000015630393049360938160_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000132776606060288709010000007406660529857054641_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000060027439702244209180000012559410005436772534_",
    gradientUnits: "userSpaceOnUse",
    x1: 463.5268,
    y1: 690.8725,
    x2: 312.0121,
    y2: 701.2891
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0892,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2219,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3853,
    style: {
      stopColor: "#BDBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    style: {
      stopColor: "#8B8B8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7816,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000004548394983747850520000015630393049360938160_)",
      fill: "url(#SVGID_00000060027439702244209180000012559410005436772534_)"
    },
    d: " M472.29,705.29c0,0-28.41,25.57-61.55,10.42c-33.14-15.15-27.46-47.35-9.47-61.55c0,0-49.24,50.19,30.3,73.86 c0,0-39.77,17.05-55.87-25.57C375.7,702.45,405.05,773.47,472.29,705.29z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116235294343409234550000003734637397397674665_",
    gradientUnits: "userSpaceOnUse",
    x1: 463.5268,
    y1: 690.8725,
    x2: 312.0121,
    y2: 701.2891
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#9CA5B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    style: {
      stopColor: "#A4ACB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4298,
    style: {
      stopColor: "#BAC0C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    style: {
      stopColor: "#DEE1E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116235294343409234550000003734637397397674665_)"
    },
    d: "M472.29,705.29 c0,0-28.41,25.57-61.55,10.42c-33.14-15.15-27.46-47.35-9.47-61.55c0,0-49.24,50.19,30.3,73.86c0,0-39.77,17.05-55.87-25.57 C375.7,702.45,405.05,773.47,472.29,705.29z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000039101324164630564200000000701005157288555935_",
    filterUnits: "userSpaceOnUse",
    x: 378.54,
    y: 621.95,
    width: 175.15,
    height: 152.05
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend65 || (_feBlend65 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 378.54,
    y: 621.95,
    width: 175.15,
    height: 152.05,
    id: "SVGID_00000057126376721998234380000002155088156962226054_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000039101324164630564200000000701005157288555935_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000075130913317474081310000004050225155960582278_",
    filterUnits: "userSpaceOnUse",
    x: 378.54,
    y: 621.95,
    width: 175.15,
    height: 152.05
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend66 || (_feBlend66 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 378.54,
    y: 621.95,
    width: 175.15,
    height: 152.05,
    id: "SVGID_00000057126376721998234380000002155088156962226054_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000075130913317474081310000004050225155960582278_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021839368120185281430000008278788484852077975_",
    gradientUnits: "userSpaceOnUse",
    x1: 535.6789,
    y1: 595.007,
    x2: 450.4517,
    y2: 742.7343
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0892,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2219,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3853,
    style: {
      stopColor: "#BDBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    style: {
      stopColor: "#8B8B8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7816,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000057126376721998234380000002155088156962226054_)",
      fill: "url(#SVGID_00000021839368120185281430000008278788484852077975_)"
    },
    d: " M537.63,627.64c-0.63-2.93,16.1,94.7-100.38,121.21c0,0,61.55-7.58,82.39-40.72c0,0-78.6,94.7-141.1,50.19 c0,0,52.08,48.3,129.73-24.62c77.65-72.92,32.2-111.74,32.2-111.74s19.89,40.72-6.63,73.86 C533.84,695.82,548.04,675.93,537.63,627.64z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000076602525108954093950000003305010137634488495_",
    gradientUnits: "userSpaceOnUse",
    x1: 535.6789,
    y1: 595.007,
    x2: 450.4517,
    y2: 742.7343
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#9CA5B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    style: {
      stopColor: "#A4ACB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4298,
    style: {
      stopColor: "#BAC0C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    style: {
      stopColor: "#DEE1E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000076602525108954093950000003305010137634488495_)"
    },
    d: "M537.63,627.64 c-0.63-2.93,16.1,94.7-100.38,121.21c0,0,61.55-7.58,82.39-40.72c0,0-78.6,94.7-141.1,50.19c0,0,52.08,48.3,129.73-24.62 c77.65-72.92,32.2-111.74,32.2-111.74s19.89,40.72-6.63,73.86C533.84,695.82,548.04,675.93,537.63,627.64z"
  }), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M511.63,657.37c-7.48,13.63-16.82,26.24-27.67,37.37c9.05-7.44,17.21-15.95,24.25-25.31 c-8.38,28.15-29.45,52.26-56.23,64.33c15.48-10.8,30.82-21.8,46.01-33c4.62-3.41,9.81-8.71,7.54-13.99 c-8.95,14.59-12.16,33.49-25.84,43.78c12.2-11.95,23.24-25.07,32.94-39.12c-1.07,2.33-2.95,4.27-5.23,5.43 c6.85-11.39,11.6-24.03,13.93-37.12c-1.75,7.37-4.65,14.47-8.58,20.95c4.02-11.63,8.04-23.26,12.06-34.89 c-0.23,15.06-2.69,30.09-7.26,44.44c0.05-5.88,3.59-11.06,6.37-16.24c6.63-12.35,9.44-26.71,7.94-40.65 c-0.04,4.88-0.82,9.76-2.3,14.41c-0.6-6.49-1.2-12.98-1.81-19.47c-2.56,6.52-5.11,13.03-7.67,19.55 c-0.63-5.08-0.12-10.29,1.49-15.15c-0.94,6.1-2.28,12.35-4.68,18.02c-0.5-2.72-1.3-5.33-1.1-8.23 c-3.45,15.93-13.38,26.91-25.81,37.32C497.12,672.25,504.41,664.84,511.63,657.37z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M557.51,634.27c0,0,12.31,97.54-96.59,139.2c0,0,57.76-11.36,80.49-52.08c0,0-11.36,43.56-87.12,62.5 C454.29,783.89,588.76,769.68,557.51,634.27z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000046332547686163980070000004668133656120353467_",
    filterUnits: "userSpaceOnUse",
    x: 646.53,
    y: 587.22,
    width: 165.72,
    height: 67.65
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend67 || (_feBlend67 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 646.53,
    y: 587.22,
    width: 165.72,
    height: 67.65,
    id: "SVGID_00000077316581436566032900000008921078316130387102_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000046332547686163980070000004668133656120353467_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000156547195072518370230000009675501775627805597_",
    filterUnits: "userSpaceOnUse",
    x: 646.53,
    y: 587.22,
    width: 165.72,
    height: 67.65
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend68 || (_feBlend68 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 646.53,
    y: 587.22,
    width: 165.72,
    height: 67.65,
    id: "SVGID_00000077316581436566032900000008921078316130387102_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000156547195072518370230000009675501775627805597_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000131369829999864947340000005348084461763887745_",
    gradientUnits: "userSpaceOnUse",
    x1: 607.1368,
    y1: 556.2169,
    x2: 758.1785,
    y2: 643.8114
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0892,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2219,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3853,
    style: {
      stopColor: "#BDBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    style: {
      stopColor: "#8B8B8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7816,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000077316581436566032900000008921078316130387102_)",
      fill: "url(#SVGID_00000131369829999864947340000005348084461763887745_)"
    },
    d: " M664.88,597.81c0,0,23.08-13.14,64.27,27.34c41.19,40.48,83.1,22.37,83.1,22.37s-36.58,23.79-85.23-14.2 c-11.84-9.25-28.41-24.86-52.56-29.12c0,0,8.52,30.54,63.92,42.61c0,0-88.66-19.41-91.86-57.05c0,0,39.3-11.48,70.55,14.44 C717.08,604.2,686.54,589.99,664.88,597.81z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029046308100517392150000002050361875546602405_",
    gradientUnits: "userSpaceOnUse",
    x1: 607.1368,
    y1: 556.2169,
    x2: 758.1785,
    y2: 643.8114
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#9CA5B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    style: {
      stopColor: "#A4ACB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4298,
    style: {
      stopColor: "#BAC0C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    style: {
      stopColor: "#DEE1E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000029046308100517392150000002050361875546602405_)"
    },
    d: "M664.88,597.81 c0,0,23.08-13.14,64.27,27.34c41.19,40.48,83.1,22.37,83.1,22.37s-36.58,23.79-85.23-14.2c-11.84-9.25-28.41-24.86-52.56-29.12 c0,0,8.52,30.54,63.92,42.61c0,0-88.66-19.41-91.86-57.05c0,0,39.3-11.48,70.55,14.44C717.08,604.2,686.54,589.99,664.88,597.81z"
  }), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M592.55,559.93c0,0-41.19-9.94-59.66,24.15c-18.47,34.09,29.05,65.18,64.24,45.02 c0,0,17.79-16.26,22.05-24.07c4.26-7.81,7.1-8.17,12.07-7.46c4.97,0.71,18.11,1.78,21.31-7.81c3.2-9.59,2.84-24.15-25.92-30.54 C597.88,552.83,592.55,559.93,592.55,559.93z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000159460201033269926580000006288220247283475076_",
    filterUnits: "userSpaceOnUse",
    x: 528.77,
    y: 558.68,
    width: 125.14,
    height: 78.93
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend69 || (_feBlend69 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 528.77,
    y: 558.68,
    width: 125.14,
    height: 78.93,
    id: "SVGID_00000129173554274445562140000000353702544458335158_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000159460201033269926580000006288220247283475076_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000152232400090360279120000014666848041626080687_",
    filterUnits: "userSpaceOnUse",
    x: 528.77,
    y: 558.68,
    width: 125.14,
    height: 78.93
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend70 || (_feBlend70 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 528.77,
    y: 558.68,
    width: 125.14,
    height: 78.93,
    id: "SVGID_00000129173554274445562140000000353702544458335158_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000152232400090360279120000014666848041626080687_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000073002121283658022810000014590561681718540957_",
    gradientUnits: "userSpaceOnUse",
    x1: 601.0425,
    y1: 638.8123,
    x2: 583.2867,
    y2: 555.7152
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0856,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2188,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3828,
    style: {
      stopColor: "#BDBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5714,
    style: {
      stopColor: "#8B8B8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7807,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000129173554274445562140000000353702544458335158_)",
      fill: "url(#SVGID_00000073002121283658022810000014590561681718540957_)"
    },
    d: " M592.55,562.06c0,0-41.19-9.94-59.66,24.15c-18.47,34.09,29.05,65.18,64.24,45.02c0,0,17.79-16.26,22.05-24.07 c4.26-7.81,7.1-8.17,12.07-7.46c4.97,0.71,18.11,1.78,21.31-7.81c3.2-9.59,2.84-24.15-25.92-30.54 C597.88,554.96,592.55,562.06,592.55,562.06z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129174819651690334650000004331092480699031957_",
    gradientUnits: "userSpaceOnUse",
    x1: 601.0425,
    y1: 638.8123,
    x2: 583.2867,
    y2: 555.7152
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E05D2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0976,
    style: {
      stopColor: "#E16333"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2493,
    style: {
      stopColor: "#E47449"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4361,
    style: {
      stopColor: "#EA8F6D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6509,
    style: {
      stopColor: "#F1B59F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8861,
    style: {
      stopColor: "#FAE6DE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000129174819651690334650000004331092480699031957_)"
    },
    d: "M592.55,562.06 c0,0-41.19-9.94-59.66,24.15c-18.47,34.09,29.05,65.18,64.24,45.02c0,0,17.79-16.26,22.05-24.07c4.26-7.81,7.1-8.17,12.07-7.46 c4.97,0.71,18.11,1.78,21.31-7.81c3.2-9.59,2.84-24.15-25.92-30.54C597.88,554.96,592.55,562.06,592.55,562.06z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000159463603878165463170000016407530229049800850_",
    filterUnits: "userSpaceOnUse",
    x: 350.45,
    y: 650.38,
    width: 47.03,
    height: 100.37
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend71 || (_feBlend71 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 350.45,
    y: 650.38,
    width: 47.03,
    height: 100.37,
    id: "SVGID_00000148637918009211987210000001393825901502185900_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000159463603878165463170000016407530229049800850_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000058548226901430735730000003694457784980080789_",
    filterUnits: "userSpaceOnUse",
    x: 350.45,
    y: 650.38,
    width: 47.03,
    height: 100.37
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend72 || (_feBlend72 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 350.45,
    y: 650.38,
    width: 47.03,
    height: 100.37,
    id: "SVGID_00000148637918009211987210000001393825901502185900_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000058548226901430735730000003694457784980080789_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000148660887323680946000000009973772398594283163_",
    gradientUnits: "userSpaceOnUse",
    x1: 463.8533,
    y1: 695.6418,
    x2: 312.3399,
    y2: 706.0584
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0892,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2219,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3853,
    style: {
      stopColor: "#BDBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    style: {
      stopColor: "#8B8B8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7816,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000148637918009211987210000001393825901502185900_)",
      fill: "url(#SVGID_00000148660887323680946000000009973772398594283163_)"
    },
    d: " M387.19,650.38c-9.47,7.67-13.62,18.45-13.62,18.45s-29.83,42.61,15.62,78.84c0,0-34.8-12.07-37.64-58.24 c0,0-3.17,15.41,1.26,33.09c8.08,14.08,21.67,28.23,44.67,28.23C397.47,750.74,342.35,710.73,387.19,650.38z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181792568941449482370000005804658365313445505_",
    gradientUnits: "userSpaceOnUse",
    x1: 463.8533,
    y1: 695.6418,
    x2: 312.3399,
    y2: 706.0584
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#9CA5B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    style: {
      stopColor: "#A4ACB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4298,
    style: {
      stopColor: "#BAC0C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    style: {
      stopColor: "#DEE1E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000181792568941449482370000005804658365313445505_)"
    },
    d: "M387.19,650.38 c-9.47,7.67-13.62,18.45-13.62,18.45s-29.83,42.61,15.62,78.84c0,0-34.8-12.07-37.64-58.24c0,0-3.17,15.41,1.26,33.09 c8.08,14.08,21.67,28.23,44.67,28.23C397.47,750.74,342.35,710.73,387.19,650.38z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000168805409945314365510000012253621714069918898_",
    filterUnits: "userSpaceOnUse",
    x: 568.55,
    y: 378.46,
    width: 58.09,
    height: 213.54
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend73 || (_feBlend73 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 568.55,
    y: 378.46,
    width: 58.09,
    height: 213.54,
    id: "SVGID_00000175315769608609094820000015638126258150134419_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000168805409945314365510000012253621714069918898_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000093158312641668805630000004016172937390661252_",
    filterUnits: "userSpaceOnUse",
    x: 568.55,
    y: 378.46,
    width: 58.09,
    height: 213.54
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend74 || (_feBlend74 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 568.55,
    y: 378.46,
    width: 58.09,
    height: 213.54,
    id: "SVGID_00000175315769608609094820000015638126258150134419_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000093158312641668805630000004016172937390661252_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000071518624689325877880000009686375621122482602_",
    gradientUnits: "userSpaceOnUse",
    x1: 542.6971,
    y1: 482.3294,
    x2: 616.0757,
    y2: 486.1413
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    style: {
      stopColor: "#FDFDFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4266,
    style: {
      stopColor: "#F5F5F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5322,
    style: {
      stopColor: "#E8E8E8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6215,
    style: {
      stopColor: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7005,
    style: {
      stopColor: "#BEBEBE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7723,
    style: {
      stopColor: "#A0A0A0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8386,
    style: {
      stopColor: "#7D7D7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9006,
    style: {
      stopColor: "#545454"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9569,
    style: {
      stopColor: "#282828"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000175315769608609094820000015638126258150134419_)",
      fill: "url(#SVGID_00000071518624689325877880000009686375621122482602_)"
    },
    d: " M591.6,557.19c0,0,16.1-46.93-21.78-145.77c0,0-10.42-27.96,28.41-32.95l7.81,58.04c0,0-9.71,83.25,20.6,120.94 c0,0-17.05-11.23-24.62,21.72C594.45,612.1,604.86,573.16,591.6,557.19z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034803511268838979080000015101943749955121808_",
    gradientUnits: "userSpaceOnUse",
    x1: 542.6971,
    y1: 482.3294,
    x2: 616.0757,
    y2: 486.1413
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E05D2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3032,
    style: {
      stopColor: "#E05F2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4476,
    style: {
      stopColor: "#E16435"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5584,
    style: {
      stopColor: "#E36E42"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6522,
    style: {
      stopColor: "#E67C54"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.735,
    style: {
      stopColor: "#EA8F6C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8103,
    style: {
      stopColor: "#EEA58A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8798,
    style: {
      stopColor: "#F3C0AD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.943,
    style: {
      stopColor: "#F9DED4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.34,
      fill: "url(#SVGID_00000034803511268838979080000015101943749955121808_)"
    },
    d: "M591.6,557.19 c0,0,16.1-46.93-21.78-145.77c0,0-10.42-27.96,28.41-32.95l7.81,58.04c0,0-9.71,83.25,20.6,120.94c0,0-17.05-11.23-24.62,21.72 C594.45,612.1,604.86,573.16,591.6,557.19z"
  }), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M647.24,360.35c0,0-51.14,19.18-49.72,55.04c0,0-8.52-12.78,2.13-29.12c0,0-28.41,29.48,0,57.88 c0,0,2.49,3.91,6.39,0.35c3.91-3.55,36.22-58.24,133.52-40.84c0,0,6.75,2.13,6.39-1.78c-0.35-3.91-14.91-71.73-104.76-31.6 C641.2,370.3,634.1,372.78,647.24,360.35z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st186",
    d: "M686.82,731.84c-4.84,9.4-13.3,16.31-20.43,24.12c-1.13,1.24-2.28,3.12-1.25,4.45 c0.92,1.19,2.78,0.84,4.16,0.25c7.06-3,13.9-9.01,18.18-15.37c4.01-5.96,6.91-10.74,8.52-17.76c0.51-2.23,1.58-5.8,0.94-7.99 c-1.54-5.33-5.13-2.77-6.42,0.07C688.83,723.35,688.82,727.94,686.82,731.84z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "M625.45,559.03c0,0-20.12-0.53-15.38,7.05c4.73,7.57,38.82-3.79,42.14,22.25 C652.21,588.34,663.56,566.19,625.45,559.03z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "M688.94,758.05c-0.43,3.17-3.34,5.3-5.79,7.36c-2.45,2.06-4.86,5.12-3.85,8.16 c2.56,1.06,5.27-1.03,7.16-3.05c2.61-2.78,5.01-5.76,7.19-8.88c0.84-1.2,1.66-2.73,1.02-4.03c-0.71-1.44-2.88-1.55-4.2-0.62 c-1.31,0.92-1.98,2.5-2.58,3.99L688.94,758.05z"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st111",
    d: "M616.07,527.74l8.99,17.77c2.81,5.56,9.28,8.22,15.19,6.24l91.47-30.62c6.37-2.13,9.94-8.91,8.08-15.37 l-5.8-20.19c-1.99-6.93-9.4-10.76-16.2-8.39l-94.66,33.04C615.97,512.72,612.64,520.97,616.07,527.74z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st112",
    points: "659.31,496.95 650.97,547.09 662.63,543.36 673.04,492.22  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st112",
    points: "679.2,489.38 668.31,542.41 675.88,540.52 686.3,487.48  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st113",
    d: "M616.2,527.68c0,0,2.27,4.39,6.25,12.08c2.06,3.65,3.81,9.4,9.59,11.24c5.59,2.29,11.89-1.84,18.93-3.91 c13.9-5.21,30.5-10.14,48.14-15.89c8.83-2.84,17.95-5.77,27.22-8.74c4.59-1.53,9.6-2.86,11.77-7.34c1.15-2.04,1.64-4.43,1.46-6.76 c-0.23-2.27-1.19-4.65-1.83-7.02l-4.32-14.18c-1.03-4.7-4.53-8.21-8.91-9.14c-4.27-1.16-8.62,1.39-13.24,2.81 c-4.5,1.58-8.95,3.15-13.32,4.68c-17.52,6.08-33.75,12.1-47.94,16.49c-7.06,2.29-13.53,4.39-19.26,6.25 c-5.69,1.93-11.08,2.99-13.4,6.79c-2.5,3.45-2.61,7.11-2.2,9.29C615.56,526.59,616.2,527.68,616.2,527.68z M615.94,527.8 c0,0-0.69-1.08-1.2-3.38c-0.51-2.24-0.55-6.05,1.97-9.81c2.39-4.17,8.14-5.52,13.6-7.6c5.65-2.11,12.02-4.49,18.97-7.09 c13.83-5.39,30.29-10.78,47.78-16.92c4.38-1.52,8.83-3.06,13.34-4.62l6.8-2.36c2.46-0.85,5.28-1.12,7.86-0.41 c5.25,1.16,9.42,5.98,10.28,11l3.86,14.31c0.58,2.4,1.5,4.68,1.73,7.35c0.15,2.6-0.46,5.24-1.78,7.46 c-1.3,2.24-3.24,4.06-5.57,5.18c-2.34,1.06-4.66,1.59-6.98,2.4c-9.19,3.2-18.24,6.36-27,9.41c-17.54,6.03-33.76,12.08-48,16.29 c-3.54,1.11-6.93,2.17-10.16,3.19c-3.26,1.22-6.96,1.19-9.85-0.05c-6.32-2.45-7.59-8.63-9.63-12.15 C618.13,532.24,615.94,527.8,615.94,527.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M617.76,526.19c0,0-4.62-8.17,5.68-14.2l12.07-4.26C635.52,507.73,617.41,517.31,617.76,526.19z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M359.7,449.34c8.45-9.4,16.9-18.8,25.35-28.2C375.25,429.21,366.75,438.79,359.7,449.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M417.69,425.99c-12.74,9.72-25.48,19.44-38.22,29.16c6.23-10.56,15.02-19.6,25.41-26.11 c-16.16,6.35-31.8,14.02-46.76,22.82c-9.83,15.44-16.6,32.84-19.3,50.95c-1.91-25.89,2.5-52.22,12.74-76.08 c-7.34,18.19-14.68,36.37-22.02,54.56c-0.84-23.64,4.15-47.46,14.4-68.77c-15.99,21.13-25.09,47.4-25.58,73.9 c-0.95-21.75,0.53-43.61,4.39-65.04c-3.38,4.69-6.75,9.38-10.13,14.07c4.24-13.49,11.81-25.91,21.85-35.86 c-1.89,3.66-3.79,7.33-5.68,10.99c13.58-17.33,25.53-35.94,35.65-55.5c-9.64,8.94-19.27,17.89-28.91,26.83 c7-12.86,15.67-24.8,25.74-35.42c-10.58,6.85-21.59,13.68-31.44,21.16c1.54-0.01,3.07,0.03,4.61,0.13 c-3.85,3.17-8.26,5.34-12.71,7.85c-7.22,13.03-7.58,21.65-7.58,21.65c4.97-14.2,19.89-25.57,19.89-25.57 c-31.96,79.55-68.18,54.69-68.18,54.69c17.76,20.6,42.61-1.42,42.61-1.42c-23.44,24.86-4.74,56.34-4.74,56.34 c0-7.57,2.84-21.78,2.84-21.78s5.68,19.89,4.74,32.2c-0.73,9.48,23.19,40.78,34.26,54.71c-5.22-9.57-5.94-23.25-5.94-29.92 c0.77,9.22,8.44,20.46,17.16,29.97c-10.66-17.73-16.95-52.22,15.69-81.75c0,0-0.33,1.1-0.89,2.92c4.05-4.99,8.93-9.02,15.1-11.14 c2.62-0.9,5.33-1.34,8.07-1.68C400.61,443.97,408.4,434.13,417.69,425.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M356.78,452.59c0.44-0.26,0.9-0.47,1.34-0.72c0.53-0.84,1.03-1.7,1.59-2.53 C358.72,450.42,357.75,451.51,356.78,452.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M396.21,454.67c-0.48,0.05-0.96,0.13-1.45,0.19c-0.1,0.19-0.22,0.36-0.32,0.54 C395.05,455.21,395.61,454.88,396.21,454.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M435.87,423.54c-5.84,8.09-12.91,15.25-20.75,21.43C423.32,439.21,430.53,432.03,435.87,423.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M367.1,482.04c0.35-0.97,0.73-1.93,0.94-2.94c-0.03,0.04-0.05,0.08-0.08,0.11 c-0.31,0.96-0.63,1.94-0.96,2.94C367.03,482.11,367.07,482.07,367.1,482.04z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M443.29,430.48c-9.25,6.49-19.29,11.85-29.82,15.94c0.58-0.44,1.07-1,1.64-1.45 c-5.83,4.09-12.16,7.41-18.9,9.71c3.93-0.41,7.91-0.6,11.81-1.21C422.3,451.22,435.47,442.64,443.29,430.48z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "st187"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M495.87,396.46c-5.29,5.06-10.82,9.85-16.72,14.18C485.47,406.88,490.99,401.95,495.87,396.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M589.75,357.82c8.49-4.21,17.16-8.94,26.32-13.4C606.93,348.16,598.16,352.66,589.75,357.82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M629.94,345.44c0,0,6.84-2.46,17.65-4.7c0.86-1.63,1.43-3.37,1.91-5.15 C643.24,338.04,636.38,341.24,629.94,345.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M453.97,372.81c2.15-2.65,4.3-5.31,6.44-7.96C457.91,367.2,455.64,369.79,453.97,372.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M685.07,207.86c-12.45,2.42-26.25,1.78-37.85,0.78c-11.91,4.35-24,8.21-36.38,10.98 c-8.9,1.99-17.19,0.95-25.72,1.42c-3.09,2.2-6.1,4.56-8.9,7.22c-14.91,14.2-51.14,34.09-51.14,34.09 c5.53-11.05,35.95-32.16,44.11-37.68c-0.41,0.18-0.81,0.28-1.23,0.48c0.17-0.22,0.27-0.5,0.44-0.73 c-18.77,7.29-36.37,19.82-67.46,40.77c-26.68,17.98-39.64,20.33-67.47,24.07c-7.57,10.35-13.01,20.86-15.28,30.87 c14.46-2.07,27.54-14.32,40.08-22.48c-15.75,15.24-32.22,29.81-47.78,45.24c21.18-12.73,41.89-26.36,62.76-39.61 c-29.01,25.58-53.26,56.54-71.13,90.85c15.46-21.43,35.36-39.63,58.07-53.14c-10.32,8.21-20.63,16.41-30.95,24.62 c13.64-7.61,26.51-16.58,38.37-26.74c-6.99,11.28-15.48,21.62-25.17,30.68c11.07-7.84,22.14-15.68,33.22-23.53 c-5.08,6.28-10.16,12.56-15.24,18.84c5.46-5.14,12.47-8.66,19.94-9.41c-5.55,15.23-14.82,29.09-26.77,40.03 c19.77-11.19,37.61-25.8,52.48-42.98c-8.2,24.34-26.13,45.24-48.93,57.05c20.93-8.21,39.7-21.88,53.94-39.27 c-3.04,9.73-8.42,18.57-15.19,26.19c7.48-7.15,14.39-14.91,20.43-23.31c-3.97,8.02-7.94,16.04-11.91,24.06 c0.27,1.32,0.41,2.9,0.42,4.62c0.99,0.23,1.85,0.78,2.28,1.86c0.48,1.22,0.51,2.43,0.29,3.63c2.29-2.16,5.39-5,9.14-8.24 c8.67-9.86,18.74-18.5,29.97-25.31c-3.57,3-6.86,6.29-10.02,9.72c10.06-7.03,21.24-13.5,31.9-16.74 c6.39-1.94,12.72-4.75,19.12-7.86c7.18-5.58,13.55-12.21,18.69-19.71c-19.49,12.27-38.97,24.53-58.46,36.8 c26.59-31.14,63.82-53.02,103.97-61.09c-19.62,3.42-38.66,9.75-56.67,18.25c1.87-1.75,3.7-3.55,5.31-5.53 c-20.53,8.04-39.71,19.51-56.5,33.79c8.42-6.66,15.09-15.52,19.15-25.46c-8.7,4.85-17.4,9.71-26.1,14.56 c29.11-24.78,64.39-42.28,101.73-50.47c-20.82-0.76-41.81,3.89-60.37,13.36c7.23-5.96,14.46-11.93,21.7-17.9 c-17.73,9.12-34.67,19.77-50.56,31.8c30.33-26.4,61.91-51.38,94.58-74.82c-15,6.31-29.34,14.21-42.69,23.52 c6.95-5.09,13.04-11.36,17.91-18.46c-18.83,13.61-37.66,27.22-56.49,40.84c2.93-3.21,5.87-6.41,8.8-9.62 c-18.37,13.83-35.76,28.96-52.01,45.24c6.51-8.29,13.01-16.58,19.52-24.87c-11.41,6.58-21.97,14.62-31.36,23.85 c7.41-10.59,14.82-21.18,22.23-31.77c-6.5,3.62-13,7.24-19.49,10.86c28.65-22.99,58.67-44.27,89.84-63.71 c-16.14,8.14-31.54,17.74-45.95,28.65c16.46-11.01,31.5-24.15,44.62-38.99c-11.81,4.34-23.01,10.33-33.17,17.75 c5.75-4.74,11.5-9.48,17.25-14.22c19.54-10.88,40.86-18.57,62.88-22.5c-3.44-0.92-6.87-1.83-10.31-2.75 C652.27,221.02,670.43,217.15,685.07,207.86z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M737.02,326.62c-2.47-0.86-4.95-1.73-7.42-2.6c-17.79-10.86-40.01-14.44-60.23-9.23 c20,3.5,40,6.99,60.01,10.49c1.47,0.61,2.99,1.09,4.48,1.65c-0.54-0.38-1.06-0.78-1.61-1.15 C733.84,326.06,735.43,326.34,737.02,326.62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M746.67,279.59c-3.79-0.59-7.6-0.99-11.43-1.13C739.06,278.69,742.85,279.25,746.67,279.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M727.83,335.55c-1.89-0.19-3.77-0.46-5.66-0.55C723.98,335.68,725.91,335.74,727.83,335.55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M794.39,312.6c-1.64-1.35-3.34-2.61-5.11-3.78C790.26,310.81,792.24,312.1,794.39,312.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M785.07,327.82c5.24,3.68,10.49,7.36,15.73,11.04C796.67,333.84,791.22,329.91,785.07,327.82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M821.25,337.32c1.75,2.48,3.51,4.96,5.26,7.44c3.16,2.92,6.45,5.68,10,8.1 C831.42,347.68,826.34,342.5,821.25,337.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M762.14,357.5c6.66,2.02,13.33,4.04,19.99,6.05c0.1,0.01,0.2,0.01,0.3,0.02 C775.67,361.55,768.9,359.52,762.14,357.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M835.35,399.72c-0.44-0.46-0.94-0.87-1.38-1.32c-1.7-6.5-9.43-10.64-16.18-13.18 c-1.13-0.42-2.28-0.79-3.41-1.21c7.08,6.88,13.77,14.13,20.22,21.61L835.35,399.72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M682.9,250.04c-1.47,0.17-2.95,0.28-4.42,0.47C679.97,250.69,681.46,250.48,682.9,250.04z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M845.55,308.61c-0.01-0.51-0.04-1.05-0.05-1.56c-1.94-1.89-4.14-3.42-6.52-4.7 C841.08,304.53,843.28,306.6,845.55,308.61z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M845.48,315.68c-2.74-4.76-5.63-9.45-8.09-14.37c0.57,0.26,1.03,0.73,1.58,1.03 c-7.16-7.42-13.4-15.73-18.29-24.81c2.16,0.5,4.21,1.33,6.24,2.23c-5.07-3.25-9.91-6.84-14.19-11.08 c6.83,4.5,13.66,8.99,20.49,13.49c-2.69-5.37-3.57-11.63-2.45-17.54c2.55,1.27,5.11,2.54,7.66,3.81 c-3.15-7.52-7.55-14.3-13.64-19.6c-32.67-28.41-77.41-19.18-77.41-19.18c18.47-7.81,42.61-2.84,42.61-2.84 c-22.77-8.81-44.83-12.64-64.11-13.99c-13.35,5.3-27.62,12.12-41.46,12.46c12.26-0.3,24.44-3.41,35.34-9.03 c-17.57,9.6-36.2,17.25-55.44,22.77c3.66-0.29,7.33-0.59,10.99-0.88c-5.02,1.38-9.93,3.19-14.45,5.79 c10.08-0.76,20.17-1.52,30.25-2.28c-0.96,4-4.31,7.18-8.22,8.37c13.04-1.52,26.15-2.43,39.27-2.75 c15.24-6.45,32.73-7.45,48.54-2.54c-11.07-5.67-23.76-8.12-36.15-6.97c2.99,0.55,5.99,1.1,8.98,1.65 c-10.3-0.97-20.6-1.95-30.89-2.92c27.75-1.92,57.18-3.5,81.74,9.55c3.66,1.94,7.56,6.61,4.66,9.57 c-22.78,7.09-46.52,11.07-70.36,11.8c5.67-0.01,11.33-0.02,17-0.03c-7.62,0.67-15.19,1.98-22.59,3.94 c25.05,0.75,49.95,6.05,73.12,15.57c-16.33-3.57-32.91-5.83-49.56-7.31c10.44,1.63,20.62,4.9,30.01,9.74 c-23.81-0.79-47.63-1.57-71.44-2.36c32.18,5.36,63.86,13.75,94.49,25c-1.6,0.94-3.52,1.04-5.32,0.62 c11.32,9.33,19.29,22.72,21.93,37.16c-5.18-3.63-10.35-7.27-15.53-10.9c0.7,0.85,1.44,1.65,2.05,2.56 c-16.94-7.96-33.89-15.91-50.83-23.87c5.68,6.19,11.35,12.37,17.03,18.56c-12.03-1.7-23.83-4.86-35.19-9.17 c1.3,0.92,2.65,1.77,3.88,2.78c-2.11,3.41-5.94,5.43-9.91,5.84c25.53,2.61,50.1,14.08,68.25,32.23c-4.65-1.41-9.3-2.82-13.95-4.23 c-9.5-0.65-18.99-1.29-28.49-1.94c0.07,0.06,0.14,0.1,0.21,0.16c0,0-0.26-0.13-0.33-0.17c-1.57-0.11-3.14-0.21-4.71-0.32 c10.07,3.09,20.76,6.82,31.05,11.2c11.63,3.49,23.15,7.32,34.54,11.53c-0.28-0.27-0.54-0.56-0.82-0.84 c7.65,2.41,15.3,4.82,22.96,7.23l0.37-2.91c-11.4-8.16-22.81-16.33-34.21-24.49c12.39,2.53,24.42,6.76,35.73,12.42l0.07-0.53 c-5.2-3.81-9.54-8.79-12.44-14.55c4.51,1.96,9.02,3.91,13.53,5.87l0.32-2.52c-4.46-6.31-8.93-12.62-13.39-18.93 c-5.82-5.38-11-11.47-15.15-18.22c11.37,4.06,21.92,10.38,30.85,18.5c-12.67-17.45-27.03-33.67-42.81-48.37 c16.09,8.9,31.21,19.46,45.35,31.22C845.08,324.12,845.35,320.05,845.48,315.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M826.92,279.76c2.66,1.71,5.3,3.48,8.13,4.88C832.6,282.61,829.82,281.06,826.92,279.76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M732.68,247.1c-3.09-0.6-6.22-0.55-9.28,0.15C726.5,247.19,729.59,247.11,732.68,247.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M746.52,255.2c-2.23-2.91-5.33-4.94-8.67-6.43c-8.67,1.58-17.17,4.06-25.29,7.47 C723.88,255.89,735.2,255.54,746.52,255.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M723.4,247.26c-0.41,0.01-0.82,0.02-1.23,0.03c-0.38,0.16-0.79,0.23-1.17,0.4 C721.77,247.41,722.61,247.44,723.4,247.26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M747.98,247.32c-5.1-0.18-10.2-0.22-15.29-0.22c1.8,0.35,3.49,0.91,5.17,1.66 C741.21,248.15,744.58,247.65,747.98,247.32z"
  }))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M438.36,299.36c-32.84,12.9-58.96,41.81-68.47,75.79c11.43-13.13,24.68-24.69,39.25-34.22 c-22.92,23.95-41.51,52.04-54.59,82.51c12.61-20.65,29.71-38.54,49.77-52.07c-15.14,15.79-38.56,44.44-46.6,64.78 c18.25-19.14,39.92-35.01,63.69-46.6c-12.78,11.85-25.11,24.18-36.95,36.97c18.32-10.19,36.64-20.38,54.96-30.57 c-10.27,10.15-20.55,20.3-30.82,30.46c13.12-5.29,26.25-10.58,39.37-15.86c-2.5,7.54-7.16,14.34-13.3,19.38 c19.39-7.77,37.19-19.49,51.99-34.23c-4.31,4.66-8.62,9.32-12.93,13.98c30.74-19.57,56.31-47.17,73.49-79.3 c-24.73,4.16-32.25,42.98-57.21,45.48c8.53-13.87,17.05-27.74,25.58-41.61c-26.26,16.96-51.42,35.62-75.26,55.83 c19.67-19.85,39.34-39.7,59.01-59.55c-17.96,8.7-34.71,19.92-49.58,33.22c11.4-15.92,22.8-31.84,34.21-47.75 c-12.53,8.24-25.05,16.47-37.58,24.71c12.26-14.2,24.52-28.41,36.77-42.61c-11.61,6.13-23.21,12.27-34.81,18.4 c5.11-4.99,10.21-9.98,15.32-14.97c-6.23-0.1-12.48,1.54-17.85,4.69c5.81-2.49,10.24-7.99,11.42-14.2 c-8.47,2.38-16.41,6.64-23.08,12.38C441.51,300.54,431.02,303.18,438.36,299.36z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st188",
    d: "M731.48,306.67c-29.93-8.39-59.86-16.77-89.79-25.16c33.76-0.51,67.84-0.98,100.91,6.6 c-22.08,0.13-44.17,0.26-66.25,0.4c41.38-22.76,92.05-10,135.61-27.02c-32.91-1.39-65.85-1.71-98.77-0.99 c23.51,0.08,47.03-1.63,70.33-5.12c-31.37-1.39-62.74-2.78-94.11-4.18c11.96-1.88,23.91-3.77,35.87-5.65 c-23.48-2.57-47.26-1.68-70.53,2.64c10.3-5.25,18.86-14.6,23.76-25.95c-11.41,7.1-22.16,15.5-32.03,25.02 c4.81-10.46,9.62-20.93,14.43-31.39c-9.92,4.67-18.67,12.33-25.07,21.95c2.46-4.59,5.76-8.63,9.64-11.79 c-10.61,13.22-21.94,25.73-33.89,37.46c5.79-6.71,11.57-13.41,17.36-20.12c-13.75,10.39-28.45,19.23-43.8,26.34 c12.62-1.78,24.23-10.78,30.08-23.32c-24.2,19.65-45.96,42.98-64.49,69.15c19.69-25.65,45.63-45.33,74.31-56.37 c-11.47,10.14-22.94,20.27-34.41,30.41c21.37-8.04,42.74-16.08,64.11-24.12c-16.35,24.98-57.49,16.8-71.32,43.59 c12.18,4.04,25.8,2.35,36.88-4.56c-17.17,4.27-33.2,14.08-45.62,27.92c27.49-0.42,54.9-7.08,80.03-19.46 c-19.55,22.31-53.58,28.08-65.9,56.04c11.55-13.6,37.99-22.23,56.24-34.98c17.45-12.18,37.81-23.08,58.87-19.79 c-20.36,5.78-45.98-3.38-63.34,11.48c17.22,6.07,44.5,3.47,60.6-5.62c-15.14-8.08-34.79-9.69-51.83-11.01 C676.3,302.61,704.43,299.09,731.48,306.67z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M395.7,544.92c-6.08-5.3-12.16-10.61-18.24-15.91c13.76,15.91,29.34,29.6,46.18,40.6 c-13.14-8.56-26.27-17.12-39.41-25.68c-11.16-7.27-24.19-20.75-18.55-34.26c2.34,6.55,3.27,13.81,2.66,20.89 c-9.78-17.42-13.72-39.29-10.78-59.91c2.42,5.75,3.11,12.49,1.92,18.75c0.79-16.88,4.91-33.52,11.92-48.25 c-1.96,16.27-2.96,32.71-2.98,49.14c0.03-18.67,4.64-37.83,14.47-52.35c-0.71,11.01-0.35,18.07-5.4,28.06 c0.92-10.85,6.64-19.4,12.22-26.3c10.69,17.76,10.2,59.78-0.61,77.37c-10.25-12.12-12.25-32.77-9.41-49.61 C372.55,495.01,384.21,521.56,395.7,544.92z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M478.92,406.48c-25.91,11.7-41.83,42.2-36.63,70.15c-2.35-14.04-0.55-28.75,5.11-41.82 c-15.05,14.62-18.27,23.68-15.36,44.46c-1.46-14.76,0.25-29.82,4.98-43.88c-18.51,12.47-19.13,39.01-17.78,61.29 c-6.4-20.55-5.16-43.38,3.41-63.12c-9.02,12.94-15.23,27.84-18.09,43.35c-2.14-28.98,15.8-58.36,42.55-69.69 c-9.34,8.21-17.34,17.95-23.55,28.72c14.16-12.94,28.32-25.88,42.49-38.82c0.97,7.56-4.37,15.42-11.76,17.3 c6.54-5.43,13.09-10.86,19.63-16.3c-2.19,3.66-4.38,7.32-6.57,10.98C475.53,403.23,472.04,413.82,478.92,406.48z"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "M679.76,374.86c2.12-1.11,4.2-2.28,6.38-3.25C683.87,372.38,681.76,373.54,679.76,374.86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "M606.05,444.52c3.91-3.55,36.22-58.24,133.52-40.84c0,0,4.35,1.34,5.86-0.19 c-3.71-2.59-7.58-4.96-11.6-7.03c1.89-2.16,4.9-3.27,7.74-2.86c-10-3.68-20.8-5.21-31.43-4.44c4.54-0.83,9.07-1.67,13.61-2.5 c-15.35-5.25-32.77-4.13-47.32,3.04c4.81-5.36,10.77-9.69,17.35-12.63c-6.92,3.93-14.74,6.28-22.68,6.82 c2.12-3.65,5.17-6.68,8.69-9.01c-11.73,6.14-22.44,14.22-31.35,24.02c4.04-6.07,8.07-12.13,12.11-18.2 c-8.69,6.08-16.57,13.33-23.33,21.5c2.65-5.23,5.3-10.45,7.94-15.68c-7.55,6.95-13.85,15.23-18.54,24.36 c2.83-6.08,5.67-12.15,8.5-18.23c-7.43,6.35-13.41,14.39-17.34,23.34c1.52-14.11,7-27.77,15.66-39.01 c-13.25,8.43-21.95,23.23-23.71,38.79c0.02-2.96,0.04-5.92,0.06-8.89c-2.85,6.58-6.28,12.91-10.26,18.88 c0.08-3.87,0.16-7.74,0.25-11.61c-3.03,6.17-2.11,14.07,2.25,19.39c-8.59-8.26-12.65-19.77-12.16-31.19 c-4.29,11.14-5.41,26.62,9.81,41.84C599.65,444.16,602.14,448.07,606.05,444.52z"
  }))), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M634,396.36c4.6-3.1,9.21-6.19,13.81-9.29c-6.86,7.23-12.69,15.44-17.27,24.29 c11.13-14.85,26.16-26.75,43.17-34.18c-7.32,2.6-13.82,7.45-18.4,13.72c8.99-5.71,19.51-8.98,30.15-9.36 c-3.93,3.24-7.87,6.47-11.8,9.71c8.7-5.39,18.95-8.24,29.19-8.12c-5.03-0.27-10.06-0.54-15.09-0.82 c11.49-2.39,23.23-3.56,34.97-3.47c-9.8-5-21.27-6.65-32.09-4.62c6.58-0.84,13.17-1.68,19.75-2.52c-2.25-1.26-4.5-2.52-6.75-3.78 c6.19,2.2,12.06,5.29,17.38,9.15c5.79,4.2,10.51,9.37,13.04,16.14c-0.43-11.74-9.15-21.02-20.06-24.36 c1.41,0.41,3.44,0.8,5.15,1.59c-30.63-15.66-48.74-10.35-74.27,12.28c7.37-6.29,16.44-10.79,26.04-12.27 C656.08,376.95,646.88,387.7,634,396.36z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000063615090796307011870000003976679778610496957_",
    filterUnits: "userSpaceOnUse",
    x: 530.22,
    y: 557.36,
    width: 66.92,
    height: 78.73
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend75 || (_feBlend75 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 530.22,
    y: 557.36,
    width: 66.92,
    height: 78.73,
    id: "SVGID_00000129164269630619711360000007009201987079921027_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000063615090796307011870000003976679778610496957_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000038377927603682636200000017654286462378045881_",
    filterUnits: "userSpaceOnUse",
    x: 530.22,
    y: 557.36,
    width: 66.92,
    height: 78.73
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend76 || (_feBlend76 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 530.22,
    y: 557.36,
    width: 66.92,
    height: 78.73,
    id: "SVGID_00000129164269630619711360000007009201987079921027_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000038377927603682636200000017654286462378045881_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124140308812800879630000013634281199449967534_",
    gradientUnits: "userSpaceOnUse",
    x1: 528.4726,
    y1: 620.0782,
    x2: 568.7188,
    y2: 598.7714
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    style: {
      stopColor: "#FDFDFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4266,
    style: {
      stopColor: "#F5F5F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5322,
    style: {
      stopColor: "#E8E8E8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6215,
    style: {
      stopColor: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7005,
    style: {
      stopColor: "#BEBEBE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7723,
    style: {
      stopColor: "#A0A0A0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8386,
    style: {
      stopColor: "#7D7D7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9006,
    style: {
      stopColor: "#545454"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9569,
    style: {
      stopColor: "#282828"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000129164269630619711360000007009201987079921027_)",
      fill: "url(#SVGID_00000124140308812800879630000013634281199449967534_)"
    },
    d: " M580.05,629.06c-13.97-1.61-24.2-7.64-30.59-20.13c-6.39-12.49-4.22-34.08,5.68-44.03c2.41-2.43,5.84-5.12,9.63-7.54 c-8.97,1.21-19.68,8.32-25.26,13.93c-9.9,9.96-12.07,31.54-5.68,44.03c6.39,12.49,16.62,18.52,30.59,20.13 c13.32,1.54,21.88,0.59,32.71-6.36C592.03,629.96,586.63,629.82,580.05,629.06z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000002385253651903848740000011772288028511740345_",
    gradientUnits: "userSpaceOnUse",
    x1: 528.4726,
    y1: 620.0782,
    x2: 568.7188,
    y2: 598.7714
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E05D2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3032,
    style: {
      stopColor: "#E05F2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4476,
    style: {
      stopColor: "#E16435"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5584,
    style: {
      stopColor: "#E36E42"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6522,
    style: {
      stopColor: "#E67C54"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.735,
    style: {
      stopColor: "#EA8F6C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8103,
    style: {
      stopColor: "#EEA58A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8798,
    style: {
      stopColor: "#F3C0AD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.943,
    style: {
      stopColor: "#F9DED4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.61,
      fill: "url(#SVGID_00000002385253651903848740000011772288028511740345_)"
    },
    d: "M580.05,629.06 c-13.97-1.61-24.2-7.64-30.59-20.13c-6.39-12.49-4.22-34.08,5.68-44.03c2.41-2.43,5.84-5.12,9.63-7.54 c-8.97,1.21-19.68,8.32-25.26,13.93c-9.9,9.96-12.07,31.54-5.68,44.03c6.39,12.49,16.62,18.52,30.59,20.13 c13.32,1.54,21.88,0.59,32.71-6.36C592.03,629.96,586.63,629.82,580.05,629.06z"
  }), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "M524.01,484.11c0,0,45.81,17.58,45.81,71.56c0,0-46.16,5.68-40.48,46.88c5.68,41.19,47.23,36.93,60.37,31.96 c10.96-4.15,21.13-14.74,27.52-24.5c6.44-9.84,9.25-10.67,20.06-9.59c12.43,1.24,21.48-11.54,17.05-23.44 c-3.38-9.05-12.78-17.05-27.7-17.76c0,0,20.26,3.1,24.5,16.16c3.79,11.66-3.91,22.55-12.67,22.43c-5.99-0.08-13.26-3.79-17.52,0.47 s-15.15,29.83-36.58,34.8c-18.14,4.21-53.86-0.71-51.49-35.75c2.37-35.04,44.51-37.88,44.51-37.88S582.25,498.32,524.01,484.11z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M495.49,437.77c0,0,35.63,9.23,38.83,42.61c0,0,4.62,10.3-8.88,7.81c-13.49-2.49-85.82-9.23-85.82,74.1 c0,0-47.82-12.78-21.31-62.97c0,0-8.52,3.79-9,17.52c0,0-12.43-22.96,26.99-55.28c39.42-32.31,74.22-5.33,74.22-5.33 S510.64,444.52,495.49,437.77z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st148",
    d: "M518.57,450.41c1.41,1.73,2.89,3.4,3.98,5.34c1.54,2.73,4,18.07,5.1,18.77c-4.23-2.74-8.46-5.48-12.69-8.22 c4.6,2.4,8.24,6.61,9.94,11.51c-9.79-5.09-20.49-8.42-31.44-9.77c-10.82-1.34-23.79,0.32-29.24,9.78 c9.29-4.14,19.77-5.56,29.84-4.06c-21.5-1.63-43.39,11.09-52.61,30.59c3.62-6.65,10.83-11.19,18.39-11.58 c-18.68,9.28-32.13,28.39-34.55,49.11c3.3-8.3,6.6-16.6,9.9-24.89c-0.95,14.58-0.87,29.22,0.16,43.8c1.28,0.53,2.24,0.87,2.99,1.12 c0.51-4.09,1.23-8.13,1.98-12.17c7.01-69.92,72.35-63.87,85.12-61.52c13.49,2.49,8.88-7.81,8.88-7.81 C532.99,466.62,526.15,457.01,518.57,450.41z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M473.68,448.59c6.26,0.14,12.41,2.97,16.58,7.64c-13.71-3.05-28.69,0.22-39.88,8.7 c-8.12,6.16-14.17,14.75-22.41,20.74c8.5-6.3,16.99-12.6,25.49-18.9c-4.78,4.71-9.24,9.75-13.34,15.06 c2.34-0.7,4.38-2.33,5.58-4.46c-9.42,7.34-17.24,16.72-22.77,27.3c0.3-1.44,0.59-2.88,0.89-4.32c-1.84,8.77-2.42,17.81-1.72,26.75 c0.55-3.91,1.1-7.83,1.65-11.74c-1.31,8.21-0.31,16.77,2.85,24.46c-1.91-14.17,1.21-28.96,8.69-41.15 c-1.62,5.28-3.23,10.56-4.85,15.84c4.13-12.86,12.51-24.32,23.51-32.16c-8.59,6.01-13.37,17.03-11.89,27.41 c1.49-15.2,11.35-29.31,25.11-35.94c-6.25,6.08-9.87,14.79-9.76,23.51c2.72-14.35,11.8-27.38,24.34-34.89 c-4.49,3.26-8.97,6.52-13.46,9.78c6.03-9.77,19.9-13.72,30.17-8.6c-3.48-0.86-7.25-0.5-10.5,1.01c8.15,4.32,17.53,6.32,26.73,5.7 c-2.13-1.8-4.26-3.6-6.39-5.4c6.6,0.06,13.19,1.86,18.9,5.16c-4.45-5.21-7.88-11.3-10.03-17.8c0.44,3.59-0.34,6.78-2.93,9.16 c-1.07,0.06-4.54-1.49-5.52-1.94c-1.02,1.22,0.39,1.91-1.32,2.76C496.12,455.2,487.9,449.4,473.68,448.59z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st113",
    d: "M621.97,540c0,0-31.79-10.85-52.15,15.67c0,0,4.62-1.07,7.46-1.07c0,0,11.24-17.28,46.75-10.88l-1.54-3.08 L621.97,540z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M835.94,1162.64l-0.25-32.82c-71.48,6.02-77.32,130.01-149.39,171.59c-21.18,12.22-39.46,16.7-54.9,17.08 c17.2,2.79,38.72,4.11,65.79,2.22C747.79,1235,806.29,1184.62,835.94,1162.64z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M592.55,1114.77c0-50.84,45.45-67.79,45.45-67.79c-61.08,9.89-62.5,70.61-62.5,70.61 c-15.62-49.43,55.4-98.86,55.4-98.86c-127.84,76.26-39.77,148.29-39.77,148.29c-62.5-36.72-32.67-91.8-32.67-91.8 c-39.55,58.98,13.58,94.9,43.16,109.37c6.44,1.79,11.4,3.42,15.51,6.69c1.21,0.44,1.94,0.69,1.94,0.69l-0.43,0.71 c4.1,3.89,7.46,9.79,10.85,19.94c12.07,36.22-16.34,53.27-41.19,47.59c-3.17-0.72-6.18-1.73-8.97-2.98l-0.97,1.59 c0,0,39.77,22.6,68.18-25.42C674.94,1185.38,592.55,1165.61,592.55,1114.77z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000048481039380847035650000018394792335507914655_",
    filterUnits: "userSpaceOnUse",
    x: 290.34,
    y: 584.35,
    width: 79.17,
    height: 274.15
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend77 || (_feBlend77 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 290.34,
    y: 584.35,
    width: 79.17,
    height: 274.15,
    id: "SVGID_00000119116282979229074980000008186038720765608859_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000048481039380847035650000018394792335507914655_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000176735678109733546670000008849662565607822494_",
    filterUnits: "userSpaceOnUse",
    x: 290.34,
    y: 584.35,
    width: 79.17,
    height: 274.15
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend78 || (_feBlend78 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 290.34,
    y: 584.35,
    width: 79.17,
    height: 274.15,
    id: "SVGID_00000119116282979229074980000008186038720765608859_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000176735678109733546670000008849662565607822494_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000038414723172897767010000000271656560055936145_",
    gradientUnits: "userSpaceOnUse",
    x1: 334.1206,
    y1: 931.8338,
    x2: 328.4387,
    y2: 610.8109
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1275,
    style: {
      stopColor: "#040404"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2524,
    style: {
      stopColor: "#101010"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3764,
    style: {
      stopColor: "#232323"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4998,
    style: {
      stopColor: "#3F3F3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6229,
    style: {
      stopColor: "#636363"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7458,
    style: {
      stopColor: "#8F8F8F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8684,
    style: {
      stopColor: "#C2C2C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9881,
    style: {
      stopColor: "#FDFDFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9922,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000119116282979229074980000008186038720765608859_)",
      fill: "url(#SVGID_00000038414723172897767010000000271656560055936145_)"
    },
    d: " M315.62,708.17c-5.34,11.24-11.5,22.1-16.09,33.67c-14.86,37.52-11.55,81.77,8.71,116.66c-2.86-26.97,0.59-54.59,9.99-80.03 c5.32-7.29,10.65-14.57,15.97-21.86c-0.1,7.44-0.21,14.89-0.31,22.33c-0.05,3.4,0.83,7.91,4.22,8.21 c3.32,0.29,5.01-3.85,5.55-7.14c2.23-13.46,2.93-27.17,2.09-40.79c-1.01-16.45-4.25-33.01-1.56-49.27 c1.44-8.72,55.04-136.95,1.74-98.38c-12.32,8.92-7.47,29.6-8.88,42.41C334.24,659.84,326.8,684.63,315.62,708.17z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000094581121080867759880000015149300927647095427_",
    gradientUnits: "userSpaceOnUse",
    x1: 334.1206,
    y1: 931.8338,
    x2: 328.4387,
    y2: 610.8109
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8C0503"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9803,
    style: {
      stopColor: "#8C0503"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9922,
    style: {
      stopColor: "#8C0503"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.62,
      fill: "url(#SVGID_00000094581121080867759880000015149300927647095427_)"
    },
    d: "M315.62,708.17 c-5.34,11.24-11.5,22.1-16.09,33.67c-14.86,37.52-11.55,81.77,8.71,116.66c-2.86-26.97,0.59-54.59,9.99-80.03 c5.32-7.29,10.65-14.57,15.97-21.86c-0.1,7.44-0.21,14.89-0.31,22.33c-0.05,3.4,0.83,7.91,4.22,8.21c3.32,0.29,5.01-3.85,5.55-7.14 c2.23-13.46,2.93-27.17,2.09-40.79c-1.01-16.45-4.25-33.01-1.56-49.27c1.44-8.72,55.04-136.95,1.74-98.38 c-12.32,8.92-7.47,29.6-8.88,42.41C334.24,659.84,326.8,684.63,315.62,708.17z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000058560425902750062270000010931469446592075184_",
    filterUnits: "userSpaceOnUse",
    x: 356.76,
    y: 65.34,
    width: 380.73,
    height: 234.72
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend79 || (_feBlend79 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 356.76,
    y: 65.34,
    width: 380.73,
    height: 234.72,
    id: "SVGID_00000170237118277843556080000004643228376819943322_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000058560425902750062270000010931469446592075184_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000076601742144308791700000016263155414711141794_",
    filterUnits: "userSpaceOnUse",
    x: 356.76,
    y: 65.34,
    width: 380.73,
    height: 234.72
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend80 || (_feBlend80 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 356.76,
    y: 65.34,
    width: 380.73,
    height: 234.72,
    id: "SVGID_00000170237118277843556080000004643228376819943322_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000076601742144308791700000016263155414711141794_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000113322855026801163910000015683787854262051245_",
    gradientUnits: "userSpaceOnUse",
    x1: 541.4148,
    y1: 267.4525,
    x2: 549.9374,
    y2: 150.9752
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1269,
    style: {
      stopColor: "#040404"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#101010"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3749,
    style: {
      stopColor: "#232323"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4979,
    style: {
      stopColor: "#3F3F3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6205,
    style: {
      stopColor: "#636363"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7428,
    style: {
      stopColor: "#8F8F8F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    style: {
      stopColor: "#C2C2C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9842,
    style: {
      stopColor: "#FDFDFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9882,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000170237118277843556080000004643228376819943322_)",
      fill: "url(#SVGID_00000113322855026801163910000015683787854262051245_)"
    },
    d: " M356.76,298.56c0,0,2.84-31.25,39.77-56.82s88.07-96.59,88.07-96.59s68.18-85.23,230.11-79.55c0,0,39.77,11.36,14.2,22.73 c-25.57,11.36-139.2-8.52-190.34,36.93c-51.14,45.45-96.59,105.11-116.48,116.48C402.21,253.11,368.12,309.93,356.76,298.56z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114787047647081607490000017291864427515860609_",
    gradientUnits: "userSpaceOnUse",
    x1: 541.4148,
    y1: 267.4525,
    x2: 549.9374,
    y2: 150.9752
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9764,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9882,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.33,
      fill: "url(#SVGID_00000114787047647081607490000017291864427515860609_)"
    },
    d: "M356.76,298.56 c0,0,2.84-31.25,39.77-56.82s88.07-96.59,88.07-96.59s68.18-85.23,230.11-79.55c0,0,39.77,11.36,14.2,22.73 c-25.57,11.36-139.2-8.52-190.34,36.93c-51.14,45.45-96.59,105.11-116.48,116.48C402.21,253.11,368.12,309.93,356.76,298.56z"
  }), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M302.78,969.97c0,0-16.57,24.62,34.56,36.46C337.34,1006.42,299.7,993.4,302.78,969.97z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st201",
    d: "M312.25,962.39c0,0,14.2,32.43,65.1,22.25l-2.98-7.21C374.37,977.43,338.76,989.14,312.25,962.39z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000114069849193767373750000006919167965470107022_",
    filterUnits: "userSpaceOnUse",
    x: 664.99,
    y: 582.98,
    width: 156.96,
    height: 53.36
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend81 || (_feBlend81 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 664.99,
    y: 582.98,
    width: 156.96,
    height: 53.36,
    id: "SVGID_00000180365567966095870210000003613246321440940945_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000114069849193767373750000006919167965470107022_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000181781892896704084250000011839001337648909744_",
    filterUnits: "userSpaceOnUse",
    x: 664.99,
    y: 582.98,
    width: 156.96,
    height: 53.36
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend82 || (_feBlend82 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 664.99,
    y: 582.98,
    width: 156.96,
    height: 53.36,
    id: "SVGID_00000180365567966095870210000003613246321440940945_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000181781892896704084250000011839001337648909744_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039855547825708764810000008150640698672039312_",
    gradientUnits: "userSpaceOnUse",
    x1: 664.994,
    y1: 609.6643,
    x2: 821.9542,
    y2: 609.6643
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0892,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2219,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3853,
    style: {
      stopColor: "#BDBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    style: {
      stopColor: "#8B8B8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7816,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000180365567966095870210000003613246321440940945_)",
      fill: "url(#SVGID_00000039855547825708764810000008150640698672039312_)"
    },
    d: " M664.99,584.08c0,0,38.35-7.1,62.5,14.91c24.15,22.02,60.37,26.99,77.41,7.81c0,0-12.78,22.73-41.9,15.62 c0,0,44.74,15.62,58.95-26.28c0,0-18.85,63.01-71.02,31.25C718.26,607.51,723.23,584.08,664.99,584.08z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039822389067775025390000009966835521778273682_",
    gradientUnits: "userSpaceOnUse",
    x1: 664.994,
    y1: 609.6643,
    x2: 821.9542,
    y2: 609.6643
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#9CA5B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    style: {
      stopColor: "#A4ACB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4298,
    style: {
      stopColor: "#BAC0C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    style: {
      stopColor: "#DEE1E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000039822389067775025390000009966835521778273682_)"
    },
    d: "M664.99,584.08c0,0,38.35-7.1,62.5,14.91 c24.15,22.02,60.37,26.99,77.41,7.81c0,0-12.78,22.73-41.9,15.62c0,0,44.74,15.62,58.95-26.28c0,0-18.85,63.01-71.02,31.25 C718.26,607.51,723.23,584.08,664.99,584.08z"
  }), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M795.52,641.03c-12.04,0-24.07,2.08-35.4,6.14c13.36-0.68,26.61-3.51,39.09-8.34 c-3.59,0.12-7.06,2.2-8.84,5.31c8.09-1.39,14.56-7.87,18.12-15.26c3.56-7.39,4.69-15.68,5.76-23.82 c-0.38,8.01-0.79,16.14-3.37,23.73c-2.58,7.59-7.68,14.7-15.06,17.84c6.58-6.3,14.2-11.51,22.46-15.35 c-10.64,14.22-24.42,26.08-40.06,34.48c15.28-4.24,29.44-12.42,40.74-23.54c-11.9,15.17-29.82,25.48-48.91,28.16 c13.61,4.21,27.88-2.89,40.36-9.76c-19.83,16.87-47.35,20.57-73.22,23.57c12.71,0.81,25.51,0.28,38.12-1.57 c-27.27,8.59-56.65-0.03-83.92-8.62c-10.51-3.31-22.12-7.53-26.95-17.44c12.18,7.86,25.06,14.63,38.45,20.2 c-11.08-6.39-21.87-13.26-32.34-20.58c15.47,7,31.9,11.86,48.68,14.42c4.11,0.63,9.63,0.24,10.65-3.79 c-4.88-3.13-11.33-3.63-16.63-1.3c12.98,0.14,25.98-1.08,38.71-3.62c-19.09-5.66-38.19-11.33-57.28-16.99 c19.85,2.43,39.88,3.51,59.88,3.21c-5.91-0.55-11.83-1.09-17.75-1.64c8.47,1.78,16.93,3.55,25.4,5.33 c-6.91,1.43-13.83,2.86-20.74,4.29c9.17,3.29,19.44,3.44,28.71,0.42c-1.98,0.43-3.97,0.85-5.95,1.28 c4.51,0.41,9.08,0.13,13.51-0.82c-11.87-1.48-23.43-5.32-33.83-11.24c2.84,0.3,5.68,0.61,8.52,0.91 c-6.13-2.25-12.53-3.73-19.02-4.42c4.75-0.65,9.5-1.3,14.26-1.96c-5.55-0.35-11.14-0.21-16.66,0.41c3.14,0.3,6.27,0.61,9.41,0.91 c-7.18,0.81-14.62-0.87-20.75-4.69c2.15-0.18,4.31-0.35,6.47-0.53c-10.49-4-20.97-9.27-29.89-16.12 c14.09,4.53,27.48,11.55,41.88,15.01C756.86,639.8,776.31,640.42,795.52,641.03z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000160912961046605135410000011174401938026231940_",
    filterUnits: "userSpaceOnUse",
    x: 175.24,
    y: 922.61,
    width: 122.23,
    height: 160.41
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend83 || (_feBlend83 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 175.24,
    y: 922.61,
    width: 122.23,
    height: 160.41,
    id: "SVGID_00000073695591224444603830000014174314661208758656_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000160912961046605135410000011174401938026231940_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000052815793160348102110000015705012351454591419_",
    filterUnits: "userSpaceOnUse",
    x: 175.24,
    y: 922.61,
    width: 122.23,
    height: 160.41
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend84 || (_feBlend84 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 175.24,
    y: 922.61,
    width: 122.23,
    height: 160.41,
    id: "SVGID_00000073695591224444603830000014174314661208758656_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000052815793160348102110000015705012351454591419_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000041977524617310420020000012331631951770568091_",
    gradientUnits: "userSpaceOnUse",
    x1: 396.8715,
    y1: 979.4969,
    x2: 155.3936,
    y2: 1016.4288
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0892,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2219,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3853,
    style: {
      stopColor: "#BDBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    style: {
      stopColor: "#8B8B8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7816,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000073695591224444603830000014174314661208758656_)",
      fill: "url(#SVGID_00000041977524617310420020000012331631951770568091_)"
    },
    d: " M226.32,926.53c24.83-2.77,50.74,6.7,67.93,24.84c-8.65-1.28-17.47-1.37-26.14-0.27c-4.01,0.51-8.25,1.4-11.14,4.24 c-3.06,3-3.94,7.51-5.7,11.41c-4.38,9.7-14.29,15.67-24.19,19.55c-9.91,3.88-20.49,6.34-29.53,11.94 c-11.72,7.26-20.07,19.74-22.31,33.34c4.15-15.15,16.42-27.81,31.43-32.43c-15.16,12.5-24.48,31.8-24.86,51.44 c4.43-14.55,14.63-27.25,27.88-34.72c-13.83,12.87-18.97,34.27-12.49,52.01c0.53-15.64,8.2-30.91,20.43-40.68 c-9.69,16.29-13.18,36.17-9.61,54.78c0.01-19.04,9.54-37.84,24.9-49.1c-7.17,11.67-10.15,25.86-8.27,39.42 c4.42-14.06,16.88-34.06,30.79-38.9c-9.28,11.31-12.57,36.29-6.51,49.61c-1.94-24.88,10.3-46.77,19.77-72.34 c-10.42,4.73-26.61,23.01-32.2,33.14c0.34-11.88,6.91-28.16,13.04-38.33c-7.41,6.72-13.53,14.85-17.96,23.83 c3.49-12.94,10.96-24.77,21.15-33.48c-13.56,4.15-25.96,12-35.52,22.48c9.84-15.22,25.39-26.64,42.85-31.48 c-6.92,2.6-13.83,5.2-20.75,7.8c10.15-7.86,21.65-13.99,33.84-18.04c-6.19-0.23-12.4,0.45-18.39,2.02 c10.39-2.71,20.68-7.49,30.77-11.18c-1.5,0.5-2.96,1.04-4.43,1.58c22.08-0.72,19.59-20.86,5.84-31.49 C272.6,926.46,243.12,917.01,226.32,926.53z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072963778462636597790000006852394111338599068_",
    gradientUnits: "userSpaceOnUse",
    x1: 396.8715,
    y1: 979.4969,
    x2: 155.3936,
    y2: 1016.4288
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#9CA5B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    style: {
      stopColor: "#A4ACB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4298,
    style: {
      stopColor: "#BAC0C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    style: {
      stopColor: "#DEE1E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000072963778462636597790000006852394111338599068_)"
    },
    d: "M226.32,926.53 c24.83-2.77,50.74,6.7,67.93,24.84c-8.65-1.28-17.47-1.37-26.14-0.27c-4.01,0.51-8.25,1.4-11.14,4.24c-3.06,3-3.94,7.51-5.7,11.41 c-4.38,9.7-14.29,15.67-24.19,19.55c-9.91,3.88-20.49,6.34-29.53,11.94c-11.72,7.26-20.07,19.74-22.31,33.34 c4.15-15.15,16.42-27.81,31.43-32.43c-15.16,12.5-24.48,31.8-24.86,51.44c4.43-14.55,14.63-27.25,27.88-34.72 c-13.83,12.87-18.97,34.27-12.49,52.01c0.53-15.64,8.2-30.91,20.43-40.68c-9.69,16.29-13.18,36.17-9.61,54.78 c0.01-19.04,9.54-37.84,24.9-49.1c-7.17,11.67-10.15,25.86-8.27,39.42c4.42-14.06,16.88-34.06,30.79-38.9 c-9.28,11.31-12.57,36.29-6.51,49.61c-1.94-24.88,10.3-46.77,19.77-72.34c-10.42,4.73-26.61,23.01-32.2,33.14 c0.34-11.88,6.91-28.16,13.04-38.33c-7.41,6.72-13.53,14.85-17.96,23.83c3.49-12.94,10.96-24.77,21.15-33.48 c-13.56,4.15-25.96,12-35.52,22.48c9.84-15.22,25.39-26.64,42.85-31.48c-6.92,2.6-13.83,5.2-20.75,7.8 c10.15-7.86,21.65-13.99,33.84-18.04c-6.19-0.23-12.4,0.45-18.39,2.02c10.39-2.71,20.68-7.49,30.77-11.18 c-1.5,0.5-2.96,1.04-4.43,1.58c22.08-0.72,19.59-20.86,5.84-31.49C272.6,926.46,243.12,917.01,226.32,926.53z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000124875557655597032120000017038194487831043759_",
    filterUnits: "userSpaceOnUse",
    x: 264.26,
    y: 1008.48,
    width: 119.19,
    height: 131.35
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend85 || (_feBlend85 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 264.26,
    y: 1008.48,
    width: 119.19,
    height: 131.35,
    id: "SVGID_00000167378135108924732650000013487258031509466505_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000124875557655597032120000017038194487831043759_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000075871724884915710610000018037726613180336280_",
    filterUnits: "userSpaceOnUse",
    x: 264.26,
    y: 1008.48,
    width: 119.19,
    height: 131.35
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend86 || (_feBlend86 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 264.26,
    y: 1008.48,
    width: 119.19,
    height: 131.35,
    id: "SVGID_00000167378135108924732650000013487258031509466505_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000075871724884915710610000018037726613180336280_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000020369465981269083280000014615063359560308895_",
    gradientUnits: "userSpaceOnUse",
    x1: 382.6906,
    y1: 960.9429,
    x2: 292.7285,
    y2: 1120.9806
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0892,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2219,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3853,
    style: {
      stopColor: "#BDBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    style: {
      stopColor: "#8B8B8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7816,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000167378135108924732650000013487258031509466505_)",
      fill: "url(#SVGID_00000020369465981269083280000014615063359560308895_)"
    },
    d: " M285.14,1018.7c-17.74,20.59-24.9,49.84-18.68,76.29c2.41-10.63,6.75-20.81,12.75-29.92c-0.4,5.7-0.8,11.39-1.2,17.08 c2.16-4.8,3.47-9.99,3.85-15.24c1.04,6.25,2.09,12.5,3.13,18.75c1.45-2.89,2.91-5.78,4.36-8.66 c8.18,11.9,12.59,26.36,12.42,40.81c-2.33-4.36-0.5-10.45,3.85-12.8c6.66,10.47,5.86,25.14-1.89,34.82 c4.66-9.53,9.33-19.07,13.99-28.6c-0.61,4.22-1.22,8.44-1.84,12.66c0.31-4.7,1.34-9.34,3.04-13.73c0.05,3.2,0.11,6.4,0.16,9.61 c2.19-3.59,4.38-7.18,6.56-10.77c0.99,2.82,1.25,5.89,0.75,8.83c0.04-5.13,2.52-10.18,6.54-13.36c-0.45,3.82-0.9,7.65-1.35,11.47 c2.25-7.9,4.5-15.8,6.76-23.7c4.13,14.91,3.14,31.2-2.77,45.5c4.23-8.25,8.46-16.5,12.7-24.75c-1.7,4.48-2.95,9.13-3.72,13.85 c0.18-3.74,1.08-7.45,2.63-10.86c-0.27,3.61-0.55,7.22-0.82,10.84c1.34-3.4,3.2-6.58,5.51-9.41c0.14,3.31,0.27,6.63,0.41,9.95 c2.71-5.16,4.59-10.75,5.54-16.5c0.08,4.34,0.15,8.67,0.23,13.01c6.53-22.09,13.07-44.17,19.6-66.26 c-2.44,9.16-4.89,18.33-7.33,27.49c-1.31-15.99,3.28-32.41,12.71-45.39c-3.5,8.41-8.25,16.31-14.04,23.35 c6.75-10.19,11.66-21.59,14.43-33.5c-9.54,11.82-17.83,24.65-24.71,38.2c-0.05-7.77,0.58-15.55,1.86-23.22 c-2.09,9.3-4.18,18.6-6.26,27.9c-0.73-10.42-1.46-20.83-2.19-31.25c-1.61,6.64-3.22,13.29-4.83,19.93 c0.16-9.09,0.33-18.19,0.49-27.28c-4,12.37-6.07,25.36-6.14,38.36c-0.88-14.18-1.76-28.36-2.64-42.54 c-1.38,15.05-2.75,30.1-4.13,45.15c-1.57-14.35-3.14-28.7-4.7-43.05c-0.45,13.37-0.91,26.74-1.36,40.11 c-1.55-9.06-3.09-18.11-4.64-27.17c-1.83,10.26-3.06,20.63-3.68,31.03c-0.26-5.46-0.52-10.92-0.78-16.38 c1.22,12.88,0.28,25.97-2.77,38.54c-0.34-20.78-1.89-41.53-4.63-62.13c-3.11,22.21-3,44.88,0.32,67.06 c-8.35-25.1-16.79-51.74-11.02-77.55c-4.75,15.44-6.01,31.95-3.64,47.93c-5.01-21.09-3.12-43.13-1.2-64.72 c-8.8,16.05-12.4,34.91-10.11,53.07c-1.21-17.19,0.17-34.56,4.07-51.34c-5.01,8.68-8.75,18.1-11.05,27.85L285.14,1018.7z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018198413853764882200000006880160917843130047_",
    gradientUnits: "userSpaceOnUse",
    x1: 382.6906,
    y1: 960.9429,
    x2: 292.7285,
    y2: 1120.9806
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#9CA5B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    style: {
      stopColor: "#A4ACB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4298,
    style: {
      stopColor: "#BAC0C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    style: {
      stopColor: "#DEE1E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018198413853764882200000006880160917843130047_)"
    },
    d: "M285.14,1018.7 c-17.74,20.59-24.9,49.84-18.68,76.29c2.41-10.63,6.75-20.81,12.75-29.92c-0.4,5.7-0.8,11.39-1.2,17.08 c2.16-4.8,3.47-9.99,3.85-15.24c1.04,6.25,2.09,12.5,3.13,18.75c1.45-2.89,2.91-5.78,4.36-8.66c8.18,11.9,12.59,26.36,12.42,40.81 c-2.33-4.36-0.5-10.45,3.85-12.8c6.66,10.47,5.86,25.14-1.89,34.82c4.66-9.53,9.33-19.07,13.99-28.6 c-0.61,4.22-1.22,8.44-1.84,12.66c0.31-4.7,1.34-9.34,3.04-13.73c0.05,3.2,0.11,6.4,0.16,9.61c2.19-3.59,4.38-7.18,6.56-10.77 c0.99,2.82,1.25,5.89,0.75,8.83c0.04-5.13,2.52-10.18,6.54-13.36c-0.45,3.82-0.9,7.65-1.35,11.47c2.25-7.9,4.5-15.8,6.76-23.7 c4.13,14.91,3.14,31.2-2.77,45.5c4.23-8.25,8.46-16.5,12.7-24.75c-1.7,4.48-2.95,9.13-3.72,13.85c0.18-3.74,1.08-7.45,2.63-10.86 c-0.27,3.61-0.55,7.22-0.82,10.84c1.34-3.4,3.2-6.58,5.51-9.41c0.14,3.31,0.27,6.63,0.41,9.95c2.71-5.16,4.59-10.75,5.54-16.5 c0.08,4.34,0.15,8.67,0.23,13.01c6.53-22.09,13.07-44.17,19.6-66.26c-2.44,9.16-4.89,18.33-7.33,27.49 c-1.31-15.99,3.28-32.41,12.71-45.39c-3.5,8.41-8.25,16.31-14.04,23.35c6.75-10.19,11.66-21.59,14.43-33.5 c-9.54,11.82-17.83,24.65-24.71,38.2c-0.05-7.77,0.58-15.55,1.86-23.22c-2.09,9.3-4.18,18.6-6.26,27.9 c-0.73-10.42-1.46-20.83-2.19-31.25c-1.61,6.64-3.22,13.29-4.83,19.93c0.16-9.09,0.33-18.19,0.49-27.28 c-4,12.37-6.07,25.36-6.14,38.36c-0.88-14.18-1.76-28.36-2.64-42.54c-1.38,15.05-2.75,30.1-4.13,45.15 c-1.57-14.35-3.14-28.7-4.7-43.05c-0.45,13.37-0.91,26.74-1.36,40.11c-1.55-9.06-3.09-18.11-4.64-27.17 c-1.83,10.26-3.06,20.63-3.68,31.03c-0.26-5.46-0.52-10.92-0.78-16.38c1.22,12.88,0.28,25.97-2.77,38.54 c-0.34-20.78-1.89-41.53-4.63-62.13c-3.11,22.21-3,44.88,0.32,67.06c-8.35-25.1-16.79-51.74-11.02-77.55 c-4.75,15.44-6.01,31.95-3.64,47.93c-5.01-21.09-3.12-43.13-1.2-64.72c-8.8,16.05-12.4,34.91-10.11,53.07 c-1.21-17.19,0.17-34.56,4.07-51.34c-5.01,8.68-8.75,18.1-11.05,27.85L285.14,1018.7z"
  }), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M273.34,969.5c-33.54,6.11-64,27.5-81.12,56.98c12.14-14.47,27.03-26.62,43.63-35.62 c-20.54,14.31-35.82,36.01-42.37,60.18c13.67-15.35,27.34-30.71,41-46.06c-13.84,15.57-22.2,35.9-23.31,56.7 c9.53-18.09,22.23-34.5,37.35-48.26c-14.7,17.2-29.2,38.92-23.41,60.79c9.04-16.94,18.07-33.88,27.11-50.83 c-14.77,15.15-17.72,40.47-6.84,58.62c1.86-13.9,7.54-27.27,16.25-38.27c-7.45,12.73-7.37,29.52,0.19,42.19 c-0.18-15.58,5.29-31.17,15.19-43.22c-6.06,11.63-5.9,26.28,0.42,37.77c4.91,8.92,12.98,15.59,19.45,23.45 c6.46,7.86,11.51,18.25,8.64,28.02c5.02-14.69,3.11-31.58-5.06-44.78c2.31,7.1,4.62,14.21,6.93,21.31 c0.06-8.12,0.12-16.25,0.18-24.38c3.41,8.69,6.29,17.59,8.62,26.63c0.15-6.86,1.94-13.68,5.19-19.72 c2.2,8.57,2.97,17.51,2.25,26.34c7.8-10.63,13.33-22.93,16.1-35.82c-0.01,11.58-1.9,23.16-5.58,34.14 c5.94-10.68,11.88-21.37,17.81-32.05c-2.5,12.7-4.1,25.58-4.8,38.51c8.9-18.16,14.45-37.95,16.29-58.09 c-2.48,7.55-4.11,15.39-4.86,23.3c1.32-12.34,3.83-24.55,7.47-36.41c-2.49,3.7-4,8.04-4.35,12.48 c6.71-7.43,12.88-15.33,18.46-23.64c-4.13,5.28-7.26,11.35-9.15,17.78c3.9-7.41,6.56-15.47,7.81-23.75 c-8.88,8.06-17.76,16.12-26.63,24.19c1.13-6.3,2.76-12.51,4.87-18.56c-6.92,11.27-12.39,23.43-16.23,36.09 c-0.28-7.39-0.56-14.77-0.84-22.16c-3.9,7.59-5.91,16.15-5.8,24.68c-6.3-11.02-9.2-23.95-8.19-36.6 c-2.92,13.91-3.46,28.32-1.57,42.41c-5.63-15.33-7.94-31.87-6.7-48.15c-8.34,12.98-11.13,29.39-7.56,44.4 c-8.46-16.03-11.3-34.97-7.91-52.78c-6.16,18.83-8.55,38.88-7,58.63c-7.12-18.09-10.34-37.71-9.37-57.13 c-6.09,17.61-5.4,37.46,1.89,54.6c-9.9-24.02-11.95-51.2-5.77-76.43c-5.25,12.18-11.72,23.83-19.29,34.73 c5.51-10.93,12.07-21.34,19.55-31.03c-9.45,8.8-18.18,18.37-26.08,28.58c0.8-15.32,8.52-30.15,20.61-39.6 c-13.51,5.54-25.66,14.38-35.09,25.54c7.13-12.18,17.71-22.31,30.18-28.91c-16.81,8.1-32.76,17.99-47.48,29.45 c14.54-11.51,29.08-23.02,43.62-34.53c-16.59,8.3-31.88,19.18-45.16,32.13c11.84-17.75,28.35-32.35,47.41-41.92 c-10.99,5.89-21.99,11.79-32.99,17.68c12.84-8.2,26.87-14.54,41.51-18.76c-5.65-0.37-11.3-0.74-16.95-1.11 c4.57-0.68,9.06-1.85,13.37-3.5c-4.65-0.32-9.36,0.16-13.85,1.42c3.14-0.14,6.29-0.28,9.43-0.42c-8.16-1.59-16.91,0.09-23.91,4.59 L273.34,969.5z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000113329411041099577530000013207206843792937404_",
    filterUnits: "userSpaceOnUse",
    x: 181.92,
    y: 933.15,
    width: 103.79,
    height: 116.15
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend87 || (_feBlend87 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 181.92,
    y: 933.15,
    width: 103.79,
    height: 116.15,
    id: "SVGID_00000156552702429647308560000003812224941889301382_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000113329411041099577530000013207206843792937404_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000163778863147030422080000006796202719137720743_",
    filterUnits: "userSpaceOnUse",
    x: 181.92,
    y: 933.15,
    width: 103.79,
    height: 116.15
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend88 || (_feBlend88 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 181.92,
    y: 933.15,
    width: 103.79,
    height: 116.15,
    id: "SVGID_00000156552702429647308560000003812224941889301382_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000163778863147030422080000006796202719137720743_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000172411955943765914290000014770304071029054380_",
    gradientUnits: "userSpaceOnUse",
    x1: 334.7531,
    y1: 987.5043,
    x2: 207.8593,
    y2: 992.2391
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0892,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2219,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3853,
    style: {
      stopColor: "#BDBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    style: {
      stopColor: "#8B8B8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7816,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000156552702429647308560000003812224941889301382_)",
      fill: "url(#SVGID_00000172411955943765914290000014770304071029054380_)"
    },
    d: " M204.74,993.79c-9.53,2.7-18.62,8.61-22.82,17.58c11.93-15.96,30.8-26.54,50.64-28.38c-16.11-0.52-32.33,3.44-46.39,11.31 c11.41-1.81,21.75-7.53,32.61-11.47c10.86-3.94,23.42-5.96,33.61-0.53c-3.96-3.67-9.38-5.73-14.78-5.63 c4.55-0.45,9.1-0.89,13.64-1.34c-2.7-1.17-5.41-2.35-8.11-3.52c5.9-1.01,11.92-1.36,17.9-1.03c-0.96-5.58-1.91-11.17-2.87-16.75 c0.51,4.08,5.99,6.56,9.4,4.24c-4.46-8.66-9.45-17.06-14.93-25.13c10,7.63,18.36,17.39,24.37,28.44 c-0.35-7.81-1.47-15.59-3.36-23.18c2.24,4.34,4.49,8.67,6.73,13c1.43-3.75,1.92-7.86,1.44-11.84c2.5,8.08,3.82,16.53,3.89,25 c-4.6-4.63-14.19-0.54-14.03,5.99c1.58,0.16,3.17,0.33,4.75,0.49c-3.59,2.01-6.77,4.73-9.33,7.96c4.62,2.2,9.8,3.19,14.91,2.86 c-2.75,1.17-5.51,2.35-8.26,3.52c3.96,0.37,7.77,2.26,10.45,5.21c-5.19,2.85-10.05,6.29-14.45,10.25 c3.67,1.04,7.72,0.66,11.13-1.04c-26.62,7.1-50.06,25.4-63.42,49.49c12.58-19.72,28.79-37.1,47.59-51.02 c-15.47,9.37-30.49,19.48-45.01,30.27c7.55-7.18,15.09-14.36,22.64-21.54c-7.89-0.12-15.8,0.8-23.46,2.72 c10.29,0.85,20.89-2.98,28.25-10.23c-5.69,0.63-11.37,1.29-17.06,1.88c9.67-1.64,24.62-1.42,32.8-6.17 C248.99,986.91,219.7,989.55,204.74,993.79z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000001639562897930972400000016276600130232360091_",
    gradientUnits: "userSpaceOnUse",
    x1: 334.7531,
    y1: 987.5043,
    x2: 207.8593,
    y2: 992.2391
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#9CA5B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    style: {
      stopColor: "#A4ACB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4298,
    style: {
      stopColor: "#BAC0C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    style: {
      stopColor: "#DEE1E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000001639562897930972400000016276600130232360091_)"
    },
    d: "M204.74,993.79 c-9.53,2.7-18.62,8.61-22.82,17.58c11.93-15.96,30.8-26.54,50.64-28.38c-16.11-0.52-32.33,3.44-46.39,11.31 c11.41-1.81,21.75-7.53,32.61-11.47c10.86-3.94,23.42-5.96,33.61-0.53c-3.96-3.67-9.38-5.73-14.78-5.63 c4.55-0.45,9.1-0.89,13.64-1.34c-2.7-1.17-5.41-2.35-8.11-3.52c5.9-1.01,11.92-1.36,17.9-1.03c-0.96-5.58-1.91-11.17-2.87-16.75 c0.51,4.08,5.99,6.56,9.4,4.24c-4.46-8.66-9.45-17.06-14.93-25.13c10,7.63,18.36,17.39,24.37,28.44 c-0.35-7.81-1.47-15.59-3.36-23.18c2.24,4.34,4.49,8.67,6.73,13c1.43-3.75,1.92-7.86,1.44-11.84c2.5,8.08,3.82,16.53,3.89,25 c-4.6-4.63-14.19-0.54-14.03,5.99c1.58,0.16,3.17,0.33,4.75,0.49c-3.59,2.01-6.77,4.73-9.33,7.96c4.62,2.2,9.8,3.19,14.91,2.86 c-2.75,1.17-5.51,2.35-8.26,3.52c3.96,0.37,7.77,2.26,10.45,5.21c-5.19,2.85-10.05,6.29-14.45,10.25 c3.67,1.04,7.72,0.66,11.13-1.04c-26.62,7.1-50.06,25.4-63.42,49.49c12.58-19.72,28.79-37.1,47.59-51.02 c-15.47,9.37-30.49,19.48-45.01,30.27c7.55-7.18,15.09-14.36,22.64-21.54c-7.89-0.12-15.8,0.8-23.46,2.72 c10.29,0.85,20.89-2.98,28.25-10.23c-5.69,0.63-11.37,1.29-17.06,1.88c9.67-1.64,24.62-1.42,32.8-6.17 C248.99,986.91,219.7,989.55,204.74,993.79z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000157307802092190343070000001371834210667660708_",
    filterUnits: "userSpaceOnUse",
    x: 334.17,
    y: 811.01,
    width: 238.49,
    height: 95.41
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend89 || (_feBlend89 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 334.17,
    y: 811.01,
    width: 238.49,
    height: 95.41,
    id: "SVGID_00000178918119029272548260000000547078383724008378_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000157307802092190343070000001371834210667660708_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000137104026212903912970000011663906685731054229_",
    filterUnits: "userSpaceOnUse",
    x: 334.17,
    y: 811.01,
    width: 238.49,
    height: 95.41
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend90 || (_feBlend90 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 334.17,
    y: 811.01,
    width: 238.49,
    height: 95.41,
    id: "SVGID_00000178918119029272548260000000547078383724008378_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000137104026212903912970000011663906685731054229_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000153665295083940785340000006760169181287187889_",
    gradientUnits: "userSpaceOnUse",
    x1: 557.3104,
    y1: 722.2597,
    x2: 348.5033,
    y2: 923.9644
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0892,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2219,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3853,
    style: {
      stopColor: "#BDBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    style: {
      stopColor: "#8B8B8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7816,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000178918119029272548260000000547078383724008378_)",
      fill: "url(#SVGID_00000153665295083940785340000006760169181287187889_)"
    },
    d: " M335.45,826.97c0,0-11.36,58.24,69.6,49.72s102.04-87.83,167.61-59.66c0,0-42.61-12.78-80.97,29.83 c-38.35,42.61-110.8,56.82-146.31,24.15c0,0,49.72,75.28,161.93-18.47c0,0-73.86,68.18-129.26,51.14 C322.66,886.63,335.45,826.97,335.45,826.97z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098215352554235990880000004320552791820307329_",
    gradientUnits: "userSpaceOnUse",
    x1: 557.3104,
    y1: 722.2597,
    x2: 348.5033,
    y2: 923.9644
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#9CA5B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    style: {
      stopColor: "#A4ACB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4298,
    style: {
      stopColor: "#BAC0C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    style: {
      stopColor: "#DEE1E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000098215352554235990880000004320552791820307329_)"
    },
    d: "M335.45,826.97 c0,0-11.36,58.24,69.6,49.72s102.04-87.83,167.61-59.66c0,0-42.61-12.78-80.97,29.83c-38.35,42.61-110.8,56.82-146.31,24.15 c0,0,49.72,75.28,161.93-18.47c0,0-73.86,68.18-129.26,51.14C322.66,886.63,335.45,826.97,335.45,826.97z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000075883419663576743210000011438924274779903381_",
    filterUnits: "userSpaceOnUse",
    x: 385.53,
    y: 821.29,
    width: 181.45,
    height: 271.31
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend91 || (_feBlend91 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 385.53,
    y: 821.29,
    width: 181.45,
    height: 271.31,
    id: "SVGID_00000175290575936439458880000014297558781634473885_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000075883419663576743210000011438924274779903381_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000118362865882070531460000001702056935103709343_",
    filterUnits: "userSpaceOnUse",
    x: 385.53,
    y: 821.29,
    width: 181.45,
    height: 271.31
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend92 || (_feBlend92 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 385.53,
    y: 821.29,
    width: 181.45,
    height: 271.31,
    id: "SVGID_00000175290575936439458880000014297558781634473885_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000118362865882070531460000001702056935103709343_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000090980493781691431070000003950904753158583220_",
    gradientUnits: "userSpaceOnUse",
    x1: 583.4786,
    y1: 746.5453,
    x2: 401.6599,
    y2: 1115.8643
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0892,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2219,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3853,
    style: {
      stopColor: "#BDBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    style: {
      stopColor: "#8B8B8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7816,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000175290575936439458880000014297558781634473885_)",
      fill: "url(#SVGID_00000090980493781691431070000003950904753158583220_)"
    },
    d: " M396.53,917.88c0,0-22.73,25.57-2.84,66.76c0,0-5.68-26.99-2.84-36.93c0,0-9,43.09,27.46,50.66c36.46,7.58,83.33,9,69.13,40.25 c-14.2,31.25-42.61,25.57-42.61,25.57s42.61,11.36,51.14-32.67c0,0,4.26,38.35-32.67,42.61c0,0,65.34-8.52,49.72-63.92 c0,0,35.51,55.4-18.47,82.39c0,0,65.34-26.99,42.61-92.33c-22.73-65.34-48.3-134.94,29.83-178.98c0,0-88.07,31.25-55.4,129.26 c32.67,98.01,17.05,89.49,17.05,89.49s-1.42-55.4-24.15-86.65c-22.73-31.25-22.73-76.7,4.26-106.53c0,0-51.14,42.61-14.2,115.06 c0,0-41.19-46.88-28.41-83.81c0,0-17.05,52.56,24.15,96.59c41.19,44.03,8.52,75.28,8.52,75.28s15.62-36.93-5.68-55.4 s-107.95-24.15-52.56-105.11c0,0-51.14,48.3-1.42,85.23c0,0-31.25-1.42-32.67-49.72c0,0-24.15,66.76,58.24,68.18 C464.71,993.17,375.22,1010.21,396.53,917.88z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000006680659377042450140000013267806719402068901_",
    gradientUnits: "userSpaceOnUse",
    x1: 583.4786,
    y1: 746.5453,
    x2: 401.6599,
    y2: 1115.8643
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#9CA5B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    style: {
      stopColor: "#A4ACB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4298,
    style: {
      stopColor: "#BAC0C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    style: {
      stopColor: "#DEE1E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000006680659377042450140000013267806719402068901_)"
    },
    d: "M396.53,917.88 c0,0-22.73,25.57-2.84,66.76c0,0-5.68-26.99-2.84-36.93c0,0-9,43.09,27.46,50.66c36.46,7.58,83.33,9,69.13,40.25 c-14.2,31.25-42.61,25.57-42.61,25.57s42.61,11.36,51.14-32.67c0,0,4.26,38.35-32.67,42.61c0,0,65.34-8.52,49.72-63.92 c0,0,35.51,55.4-18.47,82.39c0,0,65.34-26.99,42.61-92.33c-22.73-65.34-48.3-134.94,29.83-178.98c0,0-88.07,31.25-55.4,129.26 c32.67,98.01,17.05,89.49,17.05,89.49s-1.42-55.4-24.15-86.65c-22.73-31.25-22.73-76.7,4.26-106.53c0,0-51.14,42.61-14.2,115.06 c0,0-41.19-46.88-28.41-83.81c0,0-17.05,52.56,24.15,96.59c41.19,44.03,8.52,75.28,8.52,75.28s15.62-36.93-5.68-55.4 s-107.95-24.15-52.56-105.11c0,0-51.14,48.3-1.42,85.23c0,0-31.25-1.42-32.67-49.72c0,0-24.15,66.76,58.24,68.18 C464.71,993.17,375.22,1010.21,396.53,917.88z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000106841333369017613430000008274420580086048938_",
    filterUnits: "userSpaceOnUse",
    x: 493.33,
    y: 895.15,
    width: 77.31,
    height: 259.94
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend93 || (_feBlend93 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 493.33,
    y: 895.15,
    width: 77.31,
    height: 259.94,
    id: "SVGID_00000038413261824466295850000014765854945340634775_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000106841333369017613430000008274420580086048938_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000026883744304017779820000011325493014777760446_",
    filterUnits: "userSpaceOnUse",
    x: 493.33,
    y: 895.15,
    width: 77.31,
    height: 259.94
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend94 || (_feBlend94 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 493.33,
    y: 895.15,
    width: 77.31,
    height: 259.94,
    id: "SVGID_00000038413261824466295850000014765854945340634775_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000026883744304017779820000011325493014777760446_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075155319922710823570000007159798909238468011_",
    gradientUnits: "userSpaceOnUse",
    x1: 629.2948,
    y1: 918.9672,
    x2: 428.1385,
    y2: 1113.2812
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0892,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2219,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3853,
    style: {
      stopColor: "#BDBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    style: {
      stopColor: "#8B8B8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7816,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000038413261824466295850000014765854945340634775_)",
      fill: "url(#SVGID_00000075155319922710823570000007159798909238468011_)"
    },
    d: " M505.9,1155.1c0,0-41.19-21.31,25.57-78.12c66.76-56.82,1.42-181.82,1.42-181.82s66.76,123.58,22.73,171.88 C511.58,1115.33,488.86,1111.06,505.9,1155.1z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000126290650625519936430000016165149912188131994_",
    gradientUnits: "userSpaceOnUse",
    x1: 629.2948,
    y1: 918.9672,
    x2: 428.1385,
    y2: 1113.2812
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#9CA5B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    style: {
      stopColor: "#A4ACB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4298,
    style: {
      stopColor: "#BAC0C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    style: {
      stopColor: "#DEE1E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000126290650625519936430000016165149912188131994_)"
    },
    d: "M505.9,1155.1 c0,0-41.19-21.31,25.57-78.12c66.76-56.82,1.42-181.82,1.42-181.82s66.76,123.58,22.73,171.88 C511.58,1115.33,488.86,1111.06,505.9,1155.1z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000124876805804759901550000016654763565657017022_",
    filterUnits: "userSpaceOnUse",
    x: 656.71,
    y: 858.58,
    width: 161.81,
    height: 305.98
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend95 || (_feBlend95 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 656.71,
    y: 858.58,
    width: 161.81,
    height: 305.98,
    id: "SVGID_00000178918234727977758410000013675412072528754861_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000124876805804759901550000016654763565657017022_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000070120131466370577060000017642792112093401513_",
    filterUnits: "userSpaceOnUse",
    x: 656.71,
    y: 858.58,
    width: 161.81,
    height: 305.98
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend96 || (_feBlend96 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 656.71,
    y: 858.58,
    width: 161.81,
    height: 305.98,
    id: "SVGID_00000178918234727977758410000013675412072528754861_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000070120131466370577060000017642792112093401513_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000037669177626942018460000006158064761714292876_",
    gradientUnits: "userSpaceOnUse",
    x1: 765.8563,
    y1: 1175.5406,
    x2: 728.9245,
    y2: 935.01
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0892,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2219,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3853,
    style: {
      stopColor: "#BDBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    style: {
      stopColor: "#8B8B8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7816,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000178918234727977758410000013675412072528754861_)",
      fill: "url(#SVGID_00000037669177626942018460000006158064761714292876_)"
    },
    d: " M665.11,1085.85c0,0-9.47,24.62,17.05,30.3c26.52,5.68,49.24-15.15,41.67-47.35c-7.58-32.2-53.03-140.15,92.8-210.23l1.89,242.42 c0,0-39.77,102.27-142.05,47.35c0,0,70.08,26.52,109.85-18.94c0,0-56.39,45.7-110.8,10.42 C640.49,1117.1,665.11,1085.85,665.11,1085.85z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029723873187630230510000009571907895260223404_",
    gradientUnits: "userSpaceOnUse",
    x1: 765.8563,
    y1: 1175.5406,
    x2: 728.9245,
    y2: 935.01
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#9CA5B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    style: {
      stopColor: "#A4ACB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4298,
    style: {
      stopColor: "#BAC0C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    style: {
      stopColor: "#DEE1E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000029723873187630230510000009571907895260223404_)"
    },
    d: "M665.11,1085.85 c0,0-9.47,24.62,17.05,30.3c26.52,5.68,49.24-15.15,41.67-47.35c-7.58-32.2-53.03-140.15,92.8-210.23l1.89,242.42 c0,0-39.77,102.27-142.05,47.35c0,0,70.08,26.52,109.85-18.94c0,0-56.39,45.7-110.8,10.42 C640.49,1117.1,665.11,1085.85,665.11,1085.85z"
  }), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M738.38,939.66c0,0-31.25,22.73-13.26,77.65c17.99,54.92,26.51,97.54-12.31,106.06c0,0,49.24-3.79,31.25-76.7 c-17.99-72.92,24.62-131.63,50.19-147.73c0,0-66.29,38.83-61.55,126.89C732.7,1025.84,711.87,982.28,738.38,939.66z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st188",
    d: "M629.75,1161.3c15.68,18.7,35.39,34.68,45.83,56.74c10.43,22.07,7.09,53.7-14.98,64.13 c8.41-6.59,16.99-13.37,22.63-22.44c5.64-9.07,7.85-21.04,2.81-30.46c-0.54,8.84,1.16,17.8,4.92,25.82 c2.43-10.2,4.85-20.41,7.28-30.61c6.04,15.97,3.65,34.87-6.17,48.84c8.01-15.56,13.85-32.24,17.31-49.4 c2.01-9.98,2.72-21.72-4.49-28.92c-7.7-7.69-20.21-6.26-30.92-8.19c-29.34-5.29-45.49-36.43-56.21-64.25 c-3.26-8.45-6.46-17.09-7.14-26.13c-2.01-26.83,17.89-49.75,36.47-69.21c-15.05,29.04-25.03,60.7-29.36,93.11 c-0.44-12.2,1.71-24.49,6.25-35.83c-0.12,21.55,4.25,43.11,12.75,62.91c-1.81-7.62-3.63-15.24-5.44-22.87 c1.88,11.16,3.75,22.32,5.63,33.48c-1.31-7.8-22.45-35.9-28.68-41.36C609.97,1133.31,619.17,1148.69,629.75,1161.3z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M717.78,856.63c-8.04,21.07-23.47,40.24-44.57,48.2c-6.66,2.51-14.54,3.75-20.6,0.02 c-9.45-5.82-7.08-23.06,3.58-26.12c-4.95,5.03-10.07,10.33-12.18,17.07c-2.11,6.74-0.14,15.32,6.21,18.41 c3.21,1.56,6.96,1.5,10.51,1.08c12.38-1.46,24.25-6.97,33.37-15.48c2.25,4.1,0.9,9.42-2.03,13.06c-2.93,3.64-7.14,5.98-11.24,8.23 c-11.6,6.35-24.02,12.9-37.21,12.01c-11.14-0.75-21.74-7.2-27.52-16.76c-5.78-9.55-6.58-21.94-2.07-32.15 c-5.8,7.8-11.78,16.21-12.48,25.91c-1.27,17.6,16.59,32.16,34.22,32.78c17.63,0.62,34.02-9.1,47.4-20.6 c31.1-26.76,66.46-87.44,45.25-129C724.57,814.44,725.7,835.85,717.78,856.63z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M742.47,869.91c-9.69,17.8-27.31,29.56-41.62,43.91c-19.6,19.65-33.54,45.54-36.22,73.16 c-2.68,27.63,6.69,56.79,27,75.71c-19.02-28.06-19.56-67.48-1.3-96.05c-9.18,15.6-10.54,35.55-3.54,52.24 c5.81,13.87,16.86,25.24,21.55,39.53c4.69,14.29-1.21,34.25-16.18,35.83c19.62-9.56,24.34-35.9,20.4-57.37 c-3.95-21.47-13.94-41.93-14.13-63.76c-0.17-18.75,7.33-37.45,20.4-50.9c9.97-10.26,22.88-17.43,32.2-28.28 c21.91-25.48,18.7-63.31,14.24-96.62c-0.95-7.12-1.99-14.48-5.83-20.56c0.74,25.03,1.44,50.4-4.31,74.78 c-5.75,24.37-18.82,48.05-40.11,61.24c30.51-18.92,45.67-70.5,40.12-103.9C744.01,823.34,752.42,851.65,742.47,869.91z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000087409403388347128030000001801951325331954831_",
    filterUnits: "userSpaceOnUse",
    x: 743.21,
    y: 923.45,
    width: 70.9,
    height: 220.45
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend97 || (_feBlend97 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 743.21,
    y: 923.45,
    width: 70.9,
    height: 220.45,
    id: "SVGID_00000169530300912953821850000005386876885662710689_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000087409403388347128030000001801951325331954831_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000011725396027227540870000010524299449449470369_",
    filterUnits: "userSpaceOnUse",
    x: 743.21,
    y: 923.45,
    width: 70.9,
    height: 220.45
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend98 || (_feBlend98 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 743.21,
    y: 923.45,
    width: 70.9,
    height: 220.45,
    id: "SVGID_00000169530300912953821850000005386876885662710689_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000011725396027227540870000010524299449449470369_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160882944896509329020000009270129600996656549_",
    gradientUnits: "userSpaceOnUse",
    x1: 867.522,
    y1: 917.3231,
    x2: 714.1131,
    y2: 1138.9133
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0892,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2219,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3853,
    style: {
      stopColor: "#BDBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    style: {
      stopColor: "#8B8B8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7816,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000169530300912953821850000005386876885662710689_)",
      fill: "url(#SVGID_00000160882944896509329020000009270129600996656549_)"
    },
    d: " M774.09,966.45c-4.82,18.04-3.72,37.06-2.59,55.7c0.61,9.94,1.21,19.89,1.82,29.83c0.8,13.12,1.58,26.46-1.42,39.26 c-3.01,12.8-10.4,25.2-22.15,31.1c24.36-15.39,37.51-46.69,31.44-74.86c1.39,18.75,2.75,37.93-2.24,56.05 c-4.99,18.12-17.65,35.29-35.75,40.37c22.51-5.97,39.11-26.41,45.77-48.72c6.66-22.31,4.77-46.29,0.53-69.19 c-4.31-23.3-10.23-50.02,4.49-68.59c-19.15,51.33,20.57,112.01-1.89,161.99c20.79-38.22,11.76-84.84,7-128.09 c-2.53-22.92-3.04-50.64,15-67.85C793.26,929.33,779.65,945.66,774.09,966.45z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054231233629406885330000010007991267778183074_",
    gradientUnits: "userSpaceOnUse",
    x1: 867.522,
    y1: 917.3231,
    x2: 714.1131,
    y2: 1138.9133
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#9CA5B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    style: {
      stopColor: "#A4ACB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4298,
    style: {
      stopColor: "#BAC0C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    style: {
      stopColor: "#DEE1E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000054231233629406885330000010007991267778183074_)"
    },
    d: "M774.09,966.45 c-4.82,18.04-3.72,37.06-2.59,55.7c0.61,9.94,1.21,19.89,1.82,29.83c0.8,13.12,1.58,26.46-1.42,39.26 c-3.01,12.8-10.4,25.2-22.15,31.1c24.36-15.39,37.51-46.69,31.44-74.86c1.39,18.75,2.75,37.93-2.24,56.05 c-4.99,18.12-17.65,35.29-35.75,40.37c22.51-5.97,39.11-26.41,45.77-48.72c6.66-22.31,4.77-46.29,0.53-69.19 c-4.31-23.3-10.23-50.02,4.49-68.59c-19.15,51.33,20.57,112.01-1.89,161.99c20.79-38.22,11.76-84.84,7-128.09 c-2.53-22.92-3.04-50.64,15-67.85C793.26,929.33,779.65,945.66,774.09,966.45z"
  }), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st238",
    d: "M1188.65,977.65c-9.06,23.9-28.99,41.93-45.49,61.67c-2.33,2.79-4.7,5.85-5.02,9.44 c-0.97,11.02,14.99,13.96,23.94,20.72c14.45,10.91,10.16,33.82,20.06,48.81c4.46,6.75,11.48,11.39,17.37,16.99 c19.11,18.21,25.29,48.2,14.88,72.22c-4.93,11.37-13.16,21.4-16.25,33.37c-6.45,24.96,10.86,50.15,10.18,75.9 c-0.92,34.52-32.63,59.71-62.07,78.78c-7.75,5.02-15.8,10.21-20.76,17.9c-3.95,6.12-5.62,13.35-8.68,19.93 c-6.38,13.74-19.11,24.51-33.93,28.71c-13.17,3.72-27.95,2.59-39.75,9.41c-6.77,3.91-11.82,10.05-16.86,15.95 c-67.6,79.13-82.1,100.53-196.9,137.81c-15.02,4.88,6.04-36.36,15.37-48.85c0.08-0.1-2-33.72-1.92-33.82 c33.82-45.24-21.62-42.47-3.76-95.72c28.33-84.43,69.69-164.02,110.88-243.22c42.42-81.57,85.44-164.02,146.54-233.33 c12.35-14.01,32.94-65.48,53.6-65.23C1206.9,905.81,1195.01,960.86,1188.65,977.65z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st239",
    d: "M1177.29,978.65c-12.02,22.22-28.99,41.38-45.49,60.85c-2.33,2.75-4.7,5.78-5.02,9.32 c-0.97,10.87,14.99,13.77,23.94,20.44c14.45,10.76,10.16,33.37,20.06,48.17c4.46,6.66,11.48,11.24,17.37,16.77 c19.11,17.97,25.29,47.56,14.88,71.27c-4.93,11.22-13.16,21.12-16.25,32.93c-6.45,24.63,10.86,49.49,10.18,74.89 c-0.92,34.06-32.63,58.92-62.07,77.74c-7.75,4.96-15.8,10.07-20.76,17.66c-3.95,6.04-5.62,13.17-8.68,19.67 c-6.38,13.56-19.11,24.19-33.93,28.33c-13.17,3.68-27.95,2.56-39.75,9.29c-6.77,3.86-11.82,9.91-16.86,15.74 c-67.6,78.08-64.18,94.46-178.99,131.24c-15.02,4.81-11.88-31.13-2.55-43.46c0.08-0.1-2-33.28-1.92-33.38 c33.82-44.64-21.62-41.91-3.76-94.45c28.33-83.31,69.69-161.85,110.88-240c42.42-80.49,85.44-161.85,146.54-230.25 c12.35-13.82,49.11-57.63,69.71-59.25C1190.56,909.36,1190.56,954.1,1177.29,978.65z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M824.8,1171.43c0,0-1.78,1.63-4.9,4.54v446.21v7.44c73.56-33.41,167.31-100.1,215.84-231.13L824.8,1171.43z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000035489343269237315530000016994256722861073826_",
    filterUnits: "userSpaceOnUse",
    x: 819.89,
    y: 1171.43,
    width: 215.84,
    height: 458.19
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend99 || (_feBlend99 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 819.89,
    y: 1171.43,
    width: 215.84,
    height: 458.19,
    id: "SVGID_00000015326426692203303190000011401485904269753505_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000035489343269237315530000016994256722861073826_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000161619397411783487080000009479059055759076522_",
    filterUnits: "userSpaceOnUse",
    x: 819.89,
    y: 1171.43,
    width: 215.84,
    height: 458.19
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend100 || (_feBlend100 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 819.89,
    y: 1171.43,
    width: 215.84,
    height: 458.19,
    id: "SVGID_00000015326426692203303190000011401485904269753505_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000161619397411783487080000009479059055759076522_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000059991294144478842050000010966972197182333058_",
    gradientUnits: "userSpaceOnUse",
    x1: 876.1932,
    y1: 1417.3031,
    x2: 1049.4886,
    y2: 1471.2803
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0985,
    style: {
      stopColor: "#1A1A1A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7317,
    style: {
      stopColor: "#BEBEBE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9922,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000015326426692203303190000011401485904269753505_)",
      fill: "url(#SVGID_00000059991294144478842050000010966972197182333058_)"
    },
    d: " M824.8,1171.43c0,0-1.78,1.63-4.9,4.54v446.21v7.44c73.56-33.41,167.31-100.1,215.84-231.13L824.8,1171.43z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000006681312775863134400000005442375631307521961_",
    gradientUnits: "userSpaceOnUse",
    x1: 876.1932,
    y1: 1417.3031,
    x2: 1049.4886,
    y2: 1471.2803
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8C0503"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7317,
    style: {
      stopColor: "#8C0503"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9922,
    style: {
      stopColor: "#8C0503"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.79,
      fill: "url(#SVGID_00000006681312775863134400000005442375631307521961_)"
    },
    d: "M824.8,1171.43 c0,0-1.78,1.63-4.9,4.54v446.21v7.44c73.56-33.41,167.31-100.1,215.84-231.13L824.8,1171.43z"
  }), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st244",
    d: "M959.97,1062.77c0,0-19.89-32.2-53.03-28.41c-33.14,3.79,11.36,90.91,51.14,115.53 c39.77,24.62,214.96,169.51,223.48,146.78c8.52-22.73-32.2-53.98-48.3-66.29C1117.17,1218.07,959.97,1062.77,959.97,1062.77z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000064337325326792938070000001862595559248712870_",
    filterUnits: "userSpaceOnUse",
    x: 893.22,
    y: 1034.05,
    width: 287.37,
    height: 265.03
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend101 || (_feBlend101 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 893.22,
    y: 1034.05,
    width: 287.37,
    height: 265.03,
    id: "SVGID_00000033329624048600370140000009149214353654997434_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000064337325326792938070000001862595559248712870_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000143604680103872813140000003961158622882026136_",
    filterUnits: "userSpaceOnUse",
    x: 893.22,
    y: 1034.05,
    width: 287.37,
    height: 265.03
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend102 || (_feBlend102 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 893.22,
    y: 1034.05,
    width: 287.37,
    height: 265.03,
    id: "SVGID_00000033329624048600370140000009149214353654997434_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000143604680103872813140000003961158622882026136_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000051367688143060401030000001506812751049954436_",
    gradientUnits: "userSpaceOnUse",
    x1: 1015.6052,
    y1: 1188.2244,
    x2: 1130.6617,
    y2: 1083.1108
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0892,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2219,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3853,
    style: {
      stopColor: "#BDBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    style: {
      stopColor: "#8B8B8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7816,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000033329624048600370140000009149214353654997434_)",
      fill: "url(#SVGID_00000051367688143060401030000001506812751049954436_)"
    },
    d: " M957.84,1062.77c0,0-19.89-32.2-53.03-28.41c-33.14,3.79,11.36,90.91,51.14,115.53c39.77,24.62,214.96,169.51,223.48,146.78 c8.52-22.73-32.2-53.98-48.3-66.29C1115.04,1218.07,957.84,1062.77,957.84,1062.77z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023983786724421534570000018353823679861691529_",
    gradientUnits: "userSpaceOnUse",
    x1: 1015.6052,
    y1: 1188.2244,
    x2: 1130.6617,
    y2: 1083.1108
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#9CA5B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    style: {
      stopColor: "#A4ACB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4298,
    style: {
      stopColor: "#BAC0C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    style: {
      stopColor: "#DEE1E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000023983786724421534570000018353823679861691529_)"
    },
    d: "M957.84,1062.77 c0,0-19.89-32.2-53.03-28.41c-33.14,3.79,11.36,90.91,51.14,115.53c39.77,24.62,214.96,169.51,223.48,146.78 c8.52-22.73-32.2-53.98-48.3-66.29C1115.04,1218.07,957.84,1062.77,957.84,1062.77z"
  }), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M936.3,1101.12c0,0,21.78-55.4,35.99-70.55c14.2-15.15,30.3-35.99,43.56-34.09 c13.26,1.89,42.61,7.58,42.61,7.58s46.4-50.19,59.66-75.76c13.26-25.57,32.2-30.3,50.19-16.1c17.99,14.2,14.2,43.56-6.63,70.08 c-20.83,26.51-69.13,75.76-69.13,75.76s15.62-0.95,19.89,16.1c2.3,9.19,8.52,17.99,24.62,17.99c16.1,0,18.94,12.78,22.73,24.62 c1.47,4.6,8.52,15.15,19.89,22.73s35.98,88.07-39.77,143.94C1064.14,1339.28,936.3,1101.12,936.3,1101.12z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000182515540858711766690000018351698153005199256_",
    filterUnits: "userSpaceOnUse",
    x: 673.03,
    y: 1138.17,
    width: 322.57,
    height: 492.8
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend103 || (_feBlend103 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 673.03,
    y: 1138.17,
    width: 322.57,
    height: 492.8,
    id: "SVGID_00000078734405556948206430000007607148468525358497_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000182515540858711766690000018351698153005199256_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000082367885353486837080000000623945772989725066_",
    filterUnits: "userSpaceOnUse",
    x: 673.03,
    y: 1138.17,
    width: 322.57,
    height: 492.8
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend104 || (_feBlend104 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 673.03,
    y: 1138.17,
    width: 322.57,
    height: 492.8,
    id: "SVGID_00000078734405556948206430000007607148468525358497_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000082367885353486837080000000623945772989725066_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183221398529285363260000008463108471476562348_",
    gradientUnits: "userSpaceOnUse",
    x1: 767.8184,
    y1: 1184.9442,
    x2: 875.7729,
    y2: 1483.2401
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00799192,
    style: {
      stopColor: "#FDFDFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1282,
    style: {
      stopColor: "#C2C2C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2513,
    style: {
      stopColor: "#8F8F8F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3746,
    style: {
      stopColor: "#636363"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4982,
    style: {
      stopColor: "#3F3F3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6222,
    style: {
      stopColor: "#232323"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7466,
    style: {
      stopColor: "#101010"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.872,
    style: {
      stopColor: "#040404"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000078734405556948206430000007607148468525358497_)",
      fill: "url(#SVGID_00000183221398529285363260000008463108471476562348_)"
    },
    d: " M870.11,1154.69c0,0-130,82.74-179.53,207.86c-49.53,125.12,20.64,270.42,28.89,268.4c8.25-2.02,255.88-96.87,274.45-330.96 C1012.5,1065.9,870.11,1154.69,870.11,1154.69z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000177471476533110022080000006140635667546316979_",
    gradientUnits: "userSpaceOnUse",
    x1: 767.8184,
    y1: 1184.9442,
    x2: 875.7729,
    y2: 1483.2401
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0158,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.53,
      fill: "url(#SVGID_00000177471476533110022080000006140635667546316979_)"
    },
    d: "M870.11,1154.69 c0,0-130,82.74-179.53,207.86c-49.53,125.12,20.64,270.42,28.89,268.4c8.25-2.02,255.88-96.87,274.45-330.96 C1012.5,1065.9,870.11,1154.69,870.11,1154.69z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000058561486533296315220000003032687357572960685_",
    filterUnits: "userSpaceOnUse",
    x: 940.56,
    y: 1058.44,
    width: 240.11,
    height: 220.27
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend105 || (_feBlend105 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 940.56,
    y: 1058.44,
    width: 240.11,
    height: 220.27,
    id: "SVGID_00000071523352504235415580000004010881848126562447_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000058561486533296315220000003032687357572960685_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000088838131507926531630000000516721422628891046_",
    filterUnits: "userSpaceOnUse",
    x: 940.56,
    y: 1058.44,
    width: 240.11,
    height: 220.27
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend106 || (_feBlend106 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 940.56,
    y: 1058.44,
    width: 240.11,
    height: 220.27,
    id: "SVGID_00000071523352504235415580000004010881848126562447_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000088838131507926531630000000516721422628891046_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168819138637486158210000002476581587799089062_",
    gradientUnits: "userSpaceOnUse",
    x1: 1039.4695,
    y1: 1197.6311,
    x2: 1065.0377,
    y2: 1156.4377
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00784314,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.093,
    style: {
      stopColor: "#F4F4F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2412,
    style: {
      stopColor: "#D8D8D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4349,
    style: {
      stopColor: "#A9A9A9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6665,
    style: {
      stopColor: "#696969"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9276,
    style: {
      stopColor: "#181818"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000071523352504235415580000004010881848126562447_)",
      fill: "url(#SVGID_00000168819138637486158210000002476581587799089062_)"
    },
    d: " M940.56,1092.6c0,0,177.56,188.92,207.39,186.08c0,0,29.83-28.41,32.67-41.19s-107.95-24.15-125-72.44 c-17.05-48.3-80.87-119.62-95.83-104.56C944.82,1075.55,940.56,1092.6,940.56,1092.6z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000107585537934789262420000014992617402550627772_",
    gradientUnits: "userSpaceOnUse",
    x1: 1039.4695,
    y1: 1197.6311,
    x2: 1065.0377,
    y2: 1156.4377
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00784314,
    style: {
      stopColor: "#8C0503"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8C0503"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "url(#SVGID_00000107585537934789262420000014992617402550627772_)"
    },
    d: "M940.56,1092.6 c0,0,177.56,188.92,207.39,186.08c0,0,29.83-28.41,32.67-41.19s-107.95-24.15-125-72.44c-17.05-48.3-80.87-119.62-95.83-104.56 C944.82,1075.55,940.56,1092.6,940.56,1092.6z"
  }), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "st257",
    d: "M816.04,1113.9c0,0,25.57-4.74,33.14-17.05c7.58-12.31,20.83-74.81,67.24-67.23c0,0-9-0.95-18.47,5.68 c0,0,29.36-12.78,61.08,22.25c0,0-15.15-11.84-27.94-9c0,0,7.34-5.21,13.73-1.89c0,0-25.33-14.44-33.85-7.34 c-8.52,7.1-7.1,27.7,17.99,51.37c0,0-9.71-13.26-2.13-24.15c0,0-7.1,8.52,10.18,24.62c17.28,16.1,40.01,15.39,47.35,34.09 c0,0-2.25-12.07-10.42-18.47c0,0,20.95,10.3,25.92,32.31c0,0,28.76-11.36,49.01,24.5c0,0-7.46-13.85-31.25-14.91 c0,0,10.53,30.54,60.25,41.9c0,0-24.15-0.47-33.14-5.21c0,0,25.57,32.2,52.56,38.35c26.99,6.15,36.46,26.04,36.46,26.04 s-15.15-15.15-26.99-16.1c-11.84-0.95,22.25,11.84,33.62,26.04c11.36,14.2,18.47,32.67,35.99,30.3c0,0-9.47,4.74-16.1,0.47 c0,0,19.41,11.36,23.2-2.37c3.79-13.73-16.57-27.94-16.57-27.94s19.89,7.1,20.83,19.41c0.95,12.31,14.2,40.25-12.78,64.39 c0,0,10.42-14.2,9-26.04c-1.42-11.84-12.78,19.89-19.89,34.09c-7.1,14.2-46.88,28.88-46.88,28.88s29.36-15.15,28.88-29.83 c-0.47-14.68-52.56,38.35-44.03,54.45c8.52,16.1-29.83,36.46-53.98,30.3c0,0,15.15,0.47,13.73-6.15c-1.42-6.63-22.25,0-37.41-14.2 c-15.15-14.2-22.25-40.72-32.2-48.77c-9.94-8.05-23.68-15.62-26.04-22.73c0,0-2.84,25.57,26.04,34.56c0,0-35.99,0.47-44.03-28.41 c-8.05-28.88-15.62-38.83-17.99-39.3c-2.37-0.47,0.47,24.62-24.15,21.78c0,0,16.1,2.37,17.05-18.94 c0.95-21.31-6.63-25.57-10.42-31.25c-3.79-5.68-7.58-10.42-5.21-14.68c0,0-4.26,16.1,6.63,28.41c0,0-10.89-9-16.57-22.25 c-5.68-13.26-11.84-19.41-25.09-26.99c-13.26-7.58-35.99-14.2-42.14-33.62c-6.16-19.41-8.05-39.3-16.57-44.03 c0,0-5.21,14.68,8.52,29.83c0,0-35.51-26.99-11.84-57.29c23.67-30.3,43.56-34.09,43.56-34.09S842.55,1120.06,816.04,1113.9z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "st257",
    d: "M819.21,1115.13c0,0,25.14-4.59,32.59-16.53c7.45-11.94,20.48-72.55,66.1-65.21c0,0-8.84-0.92-18.15,5.51 c0,0,28.86-12.4,60.05,21.58c0,0-14.9-11.48-27.46-8.72c0,0,7.21-5.05,13.5-1.84c0,0-24.9-14.01-33.28-7.12 c-8.38,6.89-6.98,26.86,17.69,49.82c0,0-9.54-12.86-2.1-23.42c0,0-6.98,8.27,10.01,23.88c16.99,15.61,39.33,14.92,46.55,33.06 c0,0-2.21-11.71-10.24-17.91c0,0,20.6,9.99,25.49,31.34c0,0,28.28-11.02,48.18,23.76c0,0-7.33-13.43-30.72-14.46 c0,0,10.36,29.62,59.24,40.64c0,0-23.74-0.46-32.59-5.05c0,0,25.14,31.22,51.67,37.2c26.53,5.97,35.84,25.26,35.84,25.26 s-14.9-14.69-26.53-15.61c-11.64-0.92,21.88,11.48,33.05,25.26c11.17,13.78,18.15,31.68,35.38,29.39c0,0-9.31,4.59-15.83,0.46 c0,0,19.09,11.02,22.81-2.3c3.72-13.32-16.29-27.09-16.29-27.09s19.55,6.89,20.48,18.83c0.93,11.94,13.96,39.03-12.57,62.45 c0,0,10.24-13.78,8.84-25.26c-1.4-11.48-12.57,19.29-19.55,33.06c-6.98,13.78-46.08,28.01-46.08,28.01s28.86-14.69,28.4-28.93 c-0.47-14.24-51.67,37.2-43.29,52.81c8.38,15.61-29.33,35.36-53.07,29.39c0,0,14.9,0.46,13.5-5.97c-1.4-6.43-21.88,0-36.78-13.78 c-14.9-13.78-21.88-39.49-31.65-47.3c-9.78-7.81-23.27-15.15-25.6-22.04c0,0-2.79,24.8,25.6,33.52c0,0-35.38,0.46-43.29-27.55 c-7.91-28.01-15.36-37.65-17.69-38.11c-2.33-0.46,0.46,23.88-23.74,21.12c0,0,15.83,2.3,16.76-18.37 c0.93-20.66-6.52-24.8-10.24-30.31c-3.72-5.51-7.45-10.1-5.12-14.23c0,0-4.19,15.61,6.52,27.55c0,0-10.71-8.72-16.29-21.58 c-5.59-12.86-11.64-18.83-24.67-26.17c-13.03-7.35-35.38-13.78-41.43-32.6c-6.05-18.83-7.91-38.11-16.29-42.71 c0,0-5.12,14.24,8.38,28.93c0,0-34.91-26.18-11.64-55.56c23.27-29.39,42.83-33.06,42.83-33.06S845.27,1121.1,819.21,1115.13z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000057863628793184178660000012007404942155424954_",
    filterUnits: "userSpaceOnUse",
    x: 928.88,
    y: 1079.14,
    width: 56,
    height: 48.49
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend107 || (_feBlend107 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 928.88,
    y: 1079.14,
    width: 56,
    height: 48.49,
    id: "SVGID_00000168813007404687233710000008045965841027965575_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000057863628793184178660000012007404942155424954_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000085219062004818952020000010912727536771709882_",
    filterUnits: "userSpaceOnUse",
    x: 928.88,
    y: 1079.14,
    width: 56,
    height: 48.49
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend108 || (_feBlend108 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 928.88,
    y: 1079.14,
    width: 56,
    height: 48.49,
    id: "SVGID_00000168813007404687233710000008045965841027965575_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000085219062004818952020000010912727536771709882_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036249947023114294560000003038087981066116787_",
    gradientUnits: "userSpaceOnUse",
    x1: 951.9102,
    y1: 1108.9747,
    x2: 967.2442,
    y2: 1091.7493
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0892,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2219,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3853,
    style: {
      stopColor: "#BDBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    style: {
      stopColor: "#8B8B8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7816,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000168813007404687233710000008045965841027965575_)",
      fill: "url(#SVGID_00000036249947023114294560000003038087981066116787_)"
    },
    d: " M984.89,1127.63c0,0-1.1-5.68-4.4-11.21c-9.63-12.22-28.56-13.66-43.48-27.65c-3.85-3.61-6.35-6.79-8.13-9.63 c0.94,3.88,3.65,9.05,10.63,15.6C956.08,1110.27,977.86,1109.58,984.89,1127.63z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000055701303432765221440000000529216264567829381_",
    gradientUnits: "userSpaceOnUse",
    x1: 951.9102,
    y1: 1108.9747,
    x2: 967.2442,
    y2: 1091.7493
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#9CA5B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    style: {
      stopColor: "#A4ACB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4298,
    style: {
      stopColor: "#BAC0C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    style: {
      stopColor: "#DEE1E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000055701303432765221440000000529216264567829381_)"
    },
    d: "M984.89,1127.63c0,0-1.1-5.68-4.4-11.21 c-9.63-12.22-28.56-13.66-43.48-27.65c-3.85-3.61-6.35-6.79-8.13-9.63c0.94,3.88,3.65,9.05,10.63,15.6 C956.08,1110.27,977.86,1109.58,984.89,1127.63z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000083768970734407764690000004304942539278476689_",
    filterUnits: "userSpaceOnUse",
    x: 910.39,
    y: 1268.75,
    width: 15.82,
    height: 55.85
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend109 || (_feBlend109 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 910.39,
    y: 1268.75,
    width: 15.82,
    height: 55.85,
    id: "SVGID_00000031196097582618708380000007675832364437251976_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000083768970734407764690000004304942539278476689_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000031927787082363942220000013384265666949768346_",
    filterUnits: "userSpaceOnUse",
    x: 910.39,
    y: 1268.75,
    width: 15.82,
    height: 55.85
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend110 || (_feBlend110 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 910.39,
    y: 1268.75,
    width: 15.82,
    height: 55.85,
    id: "SVGID_00000031196097582618708380000007675832364437251976_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000031927787082363942220000013384265666949768346_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065058963840634614740000006364271907245732998_",
    gradientUnits: "userSpaceOnUse",
    x1: 898.7542,
    y1: 1315.4257,
    x2: 946.0524,
    y2: 1262.2935
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0892,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2219,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3853,
    style: {
      stopColor: "#BDBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    style: {
      stopColor: "#8B8B8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7816,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000031196097582618708380000007675832364437251976_)",
      fill: "url(#SVGID_00000065058963840634614740000006364271907245732998_)"
    },
    d: " M926.13,1309.46c0.91-20.56-6.35-24.67-9.98-30.15c-2.61-3.94-5.14-7.39-5.56-10.56c-0.27,2.53-0.38,6.11,0.39,10.18 c0.55,0.81,1.08,1.61,1.64,2.46c3.79,5.72,11.36,10.01,10.42,31.47c-0.23,5.21-1.38,8.97-2.95,11.74 C923.14,1322.06,925.77,1317.58,926.13,1309.46z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000024696812003804459060000005428958020136552872_",
    gradientUnits: "userSpaceOnUse",
    x1: 898.7542,
    y1: 1315.4257,
    x2: 946.0524,
    y2: 1262.2935
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#9CA5B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    style: {
      stopColor: "#A4ACB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4298,
    style: {
      stopColor: "#BAC0C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    style: {
      stopColor: "#DEE1E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000024696812003804459060000005428958020136552872_)"
    },
    d: "M926.13,1309.46 c0.91-20.56-6.35-24.67-9.98-30.15c-2.61-3.94-5.14-7.39-5.56-10.56c-0.27,2.53-0.38,6.11,0.39,10.18 c0.55,0.81,1.08,1.61,1.64,2.46c3.79,5.72,11.36,10.01,10.42,31.47c-0.23,5.21-1.38,8.97-2.95,11.74 C923.14,1322.06,925.77,1317.58,926.13,1309.46z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000116218299484668730860000014697414261916247941_",
    filterUnits: "userSpaceOnUse",
    x: 925.94,
    y: 1063.98,
    width: 0.89,
    height: 1.79
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend111 || (_feBlend111 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 925.94,
    y: 1063.98,
    width: 0.89,
    height: 1.79,
    id: "SVGID_00000176765399252502128970000007354638421825907874_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000116218299484668730860000014697414261916247941_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000140707961524382514450000006856650562935680926_",
    filterUnits: "userSpaceOnUse",
    x: 925.94,
    y: 1063.98,
    width: 0.89,
    height: 1.79
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend112 || (_feBlend112 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 925.94,
    y: 1063.98,
    width: 0.89,
    height: 1.79,
    id: "SVGID_00000176765399252502128970000007354638421825907874_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000140707961524382514450000006856650562935680926_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000151503994763023791270000005767647296455989941_",
    gradientUnits: "userSpaceOnUse",
    x1: 925.481,
    y1: 1065.8888,
    x2: 928.0555,
    y2: 1062.9968
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0892,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2219,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3853,
    style: {
      stopColor: "#BDBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    style: {
      stopColor: "#8B8B8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7816,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000176765399252502128970000007354638421825907874_)",
      fill: "url(#SVGID_00000151503994763023791270000005767647296455989941_)"
    },
    d: " M925.94,1065.77c0.31-0.6,0.49-1.2,0.89-1.79C926.83,1063.98,926.35,1064.6,925.94,1065.77z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034060362060358817710000017834508730067512254_",
    gradientUnits: "userSpaceOnUse",
    x1: 925.481,
    y1: 1065.8888,
    x2: 928.0555,
    y2: 1062.9968
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#9CA5B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    style: {
      stopColor: "#A4ACB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4298,
    style: {
      stopColor: "#BAC0C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    style: {
      stopColor: "#DEE1E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000034060362060358817710000017834508730067512254_)"
    },
    d: "M925.94,1065.77 c0.31-0.6,0.49-1.2,0.89-1.79C926.83,1063.98,926.35,1064.6,925.94,1065.77z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000171693144913314120960000015451253856137334407_",
    filterUnits: "userSpaceOnUse",
    x: 924.08,
    y: 1065.77,
    width: 4.3,
    height: 21.62
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend113 || (_feBlend113 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 924.08,
    y: 1065.77,
    width: 4.3,
    height: 21.62,
    id: "SVGID_00000174600412044972697680000014114499426445952659_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000171693144913314120960000015451253856137334407_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000034792763253036022290000013152264799510234514_",
    filterUnits: "userSpaceOnUse",
    x: 924.08,
    y: 1065.77,
    width: 4.3,
    height: 21.62
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend114 || (_feBlend114 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 924.08,
    y: 1065.77,
    width: 4.3,
    height: 21.62,
    id: "SVGID_00000174600412044972697680000014114499426445952659_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000034792763253036022290000013152264799510234514_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008860667548819977650000000262740405034322577_",
    gradientUnits: "userSpaceOnUse",
    x1: 920.3235,
    y1: 1084.2518,
    x2: 939.7405,
    y2: 1062.4399
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0892,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2219,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3853,
    style: {
      stopColor: "#BDBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    style: {
      stopColor: "#8B8B8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7816,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000174600412044972697680000014114499426445952659_)",
      fill: "url(#SVGID_00000008860667548819977650000000262740405034322577_)"
    },
    d: " M928.37,1087.38c-1.09-3.1-1.71-6.89-0.9-10.78c-2.54-5.19-2.22-8.87-1.53-10.84C921.31,1074.69,926.55,1084.5,928.37,1087.38z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011022495034441771020000006635272398810593433_",
    gradientUnits: "userSpaceOnUse",
    x1: 920.3235,
    y1: 1084.2518,
    x2: 939.7405,
    y2: 1062.4399
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#9CA5B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    style: {
      stopColor: "#A4ACB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4298,
    style: {
      stopColor: "#BAC0C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    style: {
      stopColor: "#DEE1E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000011022495034441771020000006635272398810593433_)"
    },
    d: "M928.37,1087.38 c-1.09-3.1-1.71-6.89-0.9-10.78c-2.54-5.19-2.22-8.87-1.53-10.84C921.31,1074.69,926.55,1084.5,928.37,1087.38z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000110429793453991519050000011014452802233099447_",
    filterUnits: "userSpaceOnUse",
    x: 931.09,
    y: 1045.16,
    width: 2.6,
    height: 0.7
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend115 || (_feBlend115 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 931.09,
    y: 1045.16,
    width: 2.6,
    height: 0.7,
    id: "SVGID_00000154410637840705193080000003674864454945151367_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000110429793453991519050000011014452802233099447_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000065765380084643383200000015811135820221256096_",
    filterUnits: "userSpaceOnUse",
    x: 931.09,
    y: 1045.16,
    width: 2.6,
    height: 0.7
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend116 || (_feBlend116 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 931.09,
    y: 1045.16,
    width: 2.6,
    height: 0.7,
    id: "SVGID_00000154410637840705193080000003674864454945151367_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000065765380084643383200000015811135820221256096_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145774739477688730420000008503830985843681161_",
    gradientUnits: "userSpaceOnUse",
    x1: 931.498,
    y1: 1046.7468,
    x2: 934.0339,
    y2: 1043.8981
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0892,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2219,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3853,
    style: {
      stopColor: "#BDBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    style: {
      stopColor: "#8B8B8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7816,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000154410637840705193080000003674864454945151367_)",
      fill: "url(#SVGID_00000145774739477688730420000008503830985843681161_)"
    },
    d: " M933.69,1045.63c-0.48-0.18-0.98-0.3-1.46-0.47c-0.7,0.4-1.13,0.7-1.13,0.7C931.94,1045.67,932.82,1045.7,933.69,1045.63z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044891067118253109370000003832782514944676543_",
    gradientUnits: "userSpaceOnUse",
    x1: 931.498,
    y1: 1046.7468,
    x2: 934.0339,
    y2: 1043.8981
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#9CA5B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    style: {
      stopColor: "#A4ACB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4298,
    style: {
      stopColor: "#BAC0C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    style: {
      stopColor: "#DEE1E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000044891067118253109370000003832782514944676543_)"
    },
    d: "M933.69,1045.63 c-0.48-0.18-0.98-0.3-1.46-0.47c-0.7,0.4-1.13,0.7-1.13,0.7C931.94,1045.67,932.82,1045.7,933.69,1045.63z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000165229522562033476200000011317105449043447182_",
    filterUnits: "userSpaceOnUse",
    x: 1153.44,
    y: 1287.08,
    width: 19.78,
    height: 4.17
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend117 || (_feBlend117 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 1153.44,
    y: 1287.08,
    width: 19.78,
    height: 4.17,
    id: "SVGID_00000176733932083838362830000008527302927655067044_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000165229522562033476200000011317105449043447182_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000064325248141318809330000009773092393043579053_",
    filterUnits: "userSpaceOnUse",
    x: 1153.44,
    y: 1287.08,
    width: 19.78,
    height: 4.17
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend118 || (_feBlend118 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 1153.44,
    y: 1287.08,
    width: 19.78,
    height: 4.17,
    id: "SVGID_00000176733932083838362830000008527302927655067044_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000064325248141318809330000009773092393043579053_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000151526207284873070990000008286170843480698808_",
    gradientUnits: "userSpaceOnUse",
    x1: 1157.8207,
    y1: 1294.2273,
    x2: 1173.4779,
    y2: 1276.6388
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0892,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2219,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3853,
    style: {
      stopColor: "#BDBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    style: {
      stopColor: "#8B8B8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7816,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000176733932083838362830000008527302927655067044_)",
      fill: "url(#SVGID_00000151526207284873070990000008286170843480698808_)"
    },
    d: " M1153.44,1287.08c0,0,4.4,2.56,9.33,3.7c-1.47-0.7-2.51-1.28-2.51-1.28c1.43,0.92,2.99,1.37,4.55,1.59 c0.43,0.06,0.86,0.12,1.29,0.15c0.53,0.03,1.06,0.02,1.58,0c2.1-0.11,4.03-0.76,5.54-2.23c-2.54-0.03-4.9-0.45-7.04-1.33 C1163.02,1288.71,1157.66,1289.81,1153.44,1287.08z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098194968999181440380000006665660391149920182_",
    gradientUnits: "userSpaceOnUse",
    x1: 1157.8207,
    y1: 1294.2273,
    x2: 1173.4779,
    y2: 1276.6388
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#9CA5B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    style: {
      stopColor: "#A4ACB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4298,
    style: {
      stopColor: "#BAC0C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    style: {
      stopColor: "#DEE1E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000098194968999181440380000006665660391149920182_)"
    },
    d: "M1153.44,1287.08c0,0,4.4,2.56,9.33,3.7 c-1.47-0.7-2.51-1.28-2.51-1.28c1.43,0.92,2.99,1.37,4.55,1.59c0.43,0.06,0.86,0.12,1.29,0.15c0.53,0.03,1.06,0.02,1.58,0 c2.1-0.11,4.03-0.76,5.54-2.23c-2.54-0.03-4.9-0.45-7.04-1.33C1163.02,1288.71,1157.66,1289.81,1153.44,1287.08z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000115497573398186172080000008193109161521814201_",
    filterUnits: "userSpaceOnUse",
    x: 1048.45,
    y: 1161.04,
    width: 0.42,
    height: 0.68
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend119 || (_feBlend119 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 1048.45,
    y: 1161.04,
    width: 0.42,
    height: 0.68,
    id: "SVGID_00000029727947883807022070000014511028393964986757_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000115497573398186172080000008193109161521814201_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000168828956485142790220000003186648935119116175_",
    filterUnits: "userSpaceOnUse",
    x: 1048.45,
    y: 1161.04,
    width: 0.42,
    height: 0.68
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend120 || (_feBlend120 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 1048.45,
    y: 1161.04,
    width: 0.42,
    height: 0.68,
    id: "SVGID_00000029727947883807022070000014511028393964986757_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000168828956485142790220000003186648935119116175_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072259901214903171480000009955235994939670439_",
    gradientUnits: "userSpaceOnUse",
    x1: 1048.5557,
    y1: 1161.4977,
    x2: 1048.8549,
    y2: 1161.1616
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0892,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2219,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3853,
    style: {
      stopColor: "#BDBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    style: {
      stopColor: "#8B8B8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7816,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000029727947883807022070000014511028393964986757_)",
      fill: "url(#SVGID_00000072259901214903171480000009955235994939670439_)"
    },
    d: " M1048.45,1161.04c0.14,0.24,0.29,0.43,0.42,0.68C1048.87,1161.72,1048.73,1161.46,1048.45,1161.04z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065050211644018565390000007873972541608757182_",
    gradientUnits: "userSpaceOnUse",
    x1: 1048.5557,
    y1: 1161.4977,
    x2: 1048.8549,
    y2: 1161.1616
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#9CA5B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    style: {
      stopColor: "#A4ACB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4298,
    style: {
      stopColor: "#BAC0C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    style: {
      stopColor: "#DEE1E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000065050211644018565390000007873972541608757182_)"
    },
    d: "M1048.45,1161.04 c0.14,0.24,0.29,0.43,0.42,0.68C1048.87,1161.72,1048.73,1161.46,1048.45,1161.04z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000015327248883682053830000016553540105901783223_",
    filterUnits: "userSpaceOnUse",
    x: 1099.81,
    y: 1232.2,
    width: 64.1,
    height: 54.38
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend121 || (_feBlend121 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 1099.81,
    y: 1232.2,
    width: 64.1,
    height: 54.38,
    id: "SVGID_00000011001379105910298900000009507531033668616383_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000015327248883682053830000016553540105901783223_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000167383386220121485740000013231467364414845875_",
    filterUnits: "userSpaceOnUse",
    x: 1099.81,
    y: 1232.2,
    width: 64.1,
    height: 54.38
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend122 || (_feBlend122 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 1099.81,
    y: 1232.2,
    width: 64.1,
    height: 54.38,
    id: "SVGID_00000011001379105910298900000009507531033668616383_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000167383386220121485740000013231467364414845875_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000128483702171071175910000006735594230966676615_",
    gradientUnits: "userSpaceOnUse",
    x1: 1129.0426,
    y1: 1262.7314,
    x2: 1141.4226,
    y2: 1248.8245
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0892,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2219,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3853,
    style: {
      stopColor: "#BDBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    style: {
      stopColor: "#8B8B8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7816,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000011001379105910298900000009507531033668616383_)",
      fill: "url(#SVGID_00000128483702171071175910000006735594230966676615_)"
    },
    d: " M1104.38,1232.72c-0.74-0.16-1.49-0.41-2.21-0.47c-11.34-0.91,21.32,11.42,32.21,25.13c9.74,12.26,16.26,27.69,29.53,29.21 c-9.29-5.29-15.33-17.75-23.54-28.08C1130.65,1246.26,1104.35,1235.09,1104.38,1232.72z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000148620177876020811170000010830565569997599163_",
    gradientUnits: "userSpaceOnUse",
    x1: 1129.0426,
    y1: 1262.7314,
    x2: 1141.4226,
    y2: 1248.8245
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#9CA5B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    style: {
      stopColor: "#A4ACB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4298,
    style: {
      stopColor: "#BAC0C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    style: {
      stopColor: "#DEE1E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000148620177876020811170000010830565569997599163_)"
    },
    d: "M1104.38,1232.72 c-0.74-0.16-1.49-0.41-2.21-0.47c-11.34-0.91,21.32,11.42,32.21,25.13c9.74,12.26,16.26,27.69,29.53,29.21 c-9.29-5.29-15.33-17.75-23.54-28.08C1130.65,1246.26,1104.35,1235.09,1104.38,1232.72z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000087378063413288665480000014629741036165541817_",
    filterUnits: "userSpaceOnUse",
    x: 902.09,
    y: 1036.37,
    width: 9.31,
    height: 4.45
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend123 || (_feBlend123 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 902.09,
    y: 1036.37,
    width: 9.31,
    height: 4.45,
    id: "SVGID_00000158015586813856293010000012258061190179982002_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000087378063413288665480000014629741036165541817_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000159452901272831085880000002055622488936051620_",
    filterUnits: "userSpaceOnUse",
    x: 902.09,
    y: 1036.37,
    width: 9.31,
    height: 4.45
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend124 || (_feBlend124 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 902.09,
    y: 1036.37,
    width: 9.31,
    height: 4.45,
    id: "SVGID_00000158015586813856293010000012258061190179982002_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000159452901272831085880000002055622488936051620_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000007409150712088576680000001577032301305162159_",
    gradientUnits: "userSpaceOnUse",
    x1: 902.2659,
    y1: 1043.6257,
    x2: 914.9775,
    y2: 1029.3462
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0892,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2219,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3853,
    style: {
      stopColor: "#BDBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    style: {
      stopColor: "#8B8B8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7816,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000158015586813856293010000012258061190179982002_)",
      fill: "url(#SVGID_00000007409150712088576680000001577032301305162159_)"
    },
    d: " M908.88,1039.11c0.62-0.93,1.26-1.85,2.08-2.54c0.12-0.1,0.3-0.1,0.42-0.19c-2.79,0.79-6.01,2.13-9.31,4.45 C902.09,1040.83,904.61,1039.75,908.88,1039.11z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000086670244315219590530000006862459561455505567_",
    gradientUnits: "userSpaceOnUse",
    x1: 902.2659,
    y1: 1043.6257,
    x2: 914.9775,
    y2: 1029.3462
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#9CA5B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    style: {
      stopColor: "#A4ACB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4298,
    style: {
      stopColor: "#BAC0C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    style: {
      stopColor: "#DEE1E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000086670244315219590530000006862459561455505567_)"
    },
    d: "M908.88,1039.11 c0.62-0.93,1.26-1.85,2.08-2.54c0.12-0.1,0.3-0.1,0.42-0.19c-2.79,0.79-6.01,2.13-9.31,4.45 C902.09,1040.83,904.61,1039.75,908.88,1039.11z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000041284808687307096480000010149779025298776459_",
    filterUnits: "userSpaceOnUse",
    x: 1042.73,
    y: 1185.65,
    width: 91.01,
    height: 62.84
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend125 || (_feBlend125 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 1042.73,
    y: 1185.65,
    width: 91.01,
    height: 62.84,
    id: "SVGID_00000036232214196680102330000010432169064142220932_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000041284808687307096480000010149779025298776459_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000132051662701228823980000010997200635225183165_",
    filterUnits: "userSpaceOnUse",
    x: 1042.73,
    y: 1185.65,
    width: 91.01,
    height: 62.84
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend126 || (_feBlend126 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 1042.73,
    y: 1185.65,
    width: 91.01,
    height: 62.84,
    id: "SVGID_00000036232214196680102330000010432169064142220932_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000132051662701228823980000010997200635225183165_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080172830617798384190000011868248068929084058_",
    gradientUnits: "userSpaceOnUse",
    x1: 1079.9724,
    y1: 1226.3583,
    x2: 1104.3094,
    y2: 1199.0193
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0892,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2219,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3853,
    style: {
      stopColor: "#BDBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    style: {
      stopColor: "#8B8B8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7816,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000036232214196680102330000010432169064142220932_)",
      fill: "url(#SVGID_00000080172830617798384190000011868248068929084058_)"
    },
    d: " M1048.02,1187.54c-2.01-0.54-3.88-1.14-5.29-1.89c0,0,24.5,31.07,50.36,37.01c13.4,3.08,22.22,9.69,27.68,15.37 c7.19,4.67,12.97,10.47,12.97,10.47s-9.47-20.03-36.46-26.22C1076.04,1217.39,1055.72,1196.31,1048.02,1187.54z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132084920706692740890000008896873992922002874_",
    gradientUnits: "userSpaceOnUse",
    x1: 1079.9724,
    y1: 1226.3583,
    x2: 1104.3094,
    y2: 1199.0193
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#9CA5B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    style: {
      stopColor: "#A4ACB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4298,
    style: {
      stopColor: "#BAC0C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    style: {
      stopColor: "#DEE1E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000132084920706692740890000008896873992922002874_)"
    },
    d: "M1048.02,1187.54 c-2.01-0.54-3.88-1.14-5.29-1.89c0,0,24.5,31.07,50.36,37.01c13.4,3.08,22.22,9.69,27.68,15.37c7.19,4.67,12.97,10.47,12.97,10.47 s-9.47-20.03-36.46-26.22C1076.04,1217.39,1055.72,1196.31,1048.02,1187.54z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000100343377682927480760000004761736341647421080_",
    filterUnits: "userSpaceOnUse",
    x: 1016.76,
    y: 1150.24,
    width: 61.11,
    height: 38.65
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend127 || (_feBlend127 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 1016.76,
    y: 1150.24,
    width: 61.11,
    height: 38.65,
    id: "SVGID_00000120520290626443494310000017596518565055090869_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000100343377682927480760000004761736341647421080_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000100341798313311488090000015190710885024874384_",
    filterUnits: "userSpaceOnUse",
    x: 1016.76,
    y: 1150.24,
    width: 61.11,
    height: 38.65
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend128 || (_feBlend128 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 1016.76,
    y: 1150.24,
    width: 61.11,
    height: 38.65,
    id: "SVGID_00000120520290626443494310000017596518565055090869_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000100341798313311488090000015190710885024874384_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106142830039732518270000017019032811881793961_",
    gradientUnits: "userSpaceOnUse",
    x1: 1037.8766,
    y1: 1180.1736,
    x2: 1060.1003,
    y2: 1155.2086
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0892,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2219,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3853,
    style: {
      stopColor: "#BDBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    style: {
      stopColor: "#8B8B8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7816,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000120520290626443494310000017596518565055090869_)",
      fill: "url(#SVGID_00000106142830039732518270000017019032811881793961_)"
    },
    d: " M1019.43,1150.56c-0.92-0.09-1.7-0.27-2.67-0.31c0,0,8.77,25.45,48.29,37.85c6.99,0.68,12.83,0.8,12.83,0.8 C1038.9,1179.92,1024.05,1159.14,1019.43,1150.56z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000169515728511800125160000010886571723339717046_",
    gradientUnits: "userSpaceOnUse",
    x1: 1037.8766,
    y1: 1180.1736,
    x2: 1060.1003,
    y2: 1155.2086
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#9CA5B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    style: {
      stopColor: "#A4ACB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4298,
    style: {
      stopColor: "#BAC0C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    style: {
      stopColor: "#DEE1E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000169515728511800125160000010886571723339717046_)"
    },
    d: "M1019.43,1150.56 c-0.92-0.09-1.7-0.27-2.67-0.31c0,0,8.77,25.45,48.29,37.85c6.99,0.68,12.83,0.8,12.83,0.8 C1038.9,1179.92,1024.05,1159.14,1019.43,1150.56z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000128469610477354192510000005328371379048409000_",
    filterUnits: "userSpaceOnUse",
    x: 973.94,
    y: 1104.5,
    width: 74.51,
    height: 56.54
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend129 || (_feBlend129 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 973.94,
    y: 1104.5,
    width: 74.51,
    height: 56.54,
    id: "SVGID_00000129902488148049031590000008988716663270951605_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000128469610477354192510000005328371379048409000_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000006685630779683428970000009139929154070909108_",
    filterUnits: "userSpaceOnUse",
    x: 973.94,
    y: 1104.5,
    width: 74.51,
    height: 56.54
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend130 || (_feBlend130 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 973.94,
    y: 1104.5,
    width: 74.51,
    height: 56.54,
    id: "SVGID_00000129902488148049031590000008988716663270951605_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000006685630779683428970000009139929154070909108_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181797275822069429880000016336603331171054474_",
    gradientUnits: "userSpaceOnUse",
    x1: 999.1767,
    y1: 1146.2747,
    x2: 1027.0521,
    y2: 1114.9609
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0892,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2219,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3853,
    style: {
      stopColor: "#BDBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    style: {
      stopColor: "#8B8B8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7816,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000129902488148049031590000008988716663270951605_)",
      fill: "url(#SVGID_00000181797275822069429880000016336603331171054474_)"
    },
    d: " M981.09,1113.78c6.32,4.69,15.61,13.6,18.66,27.21c0,0,19.5-7.66,37.25,10.49c6.91,3.52,10.37,7.91,11.46,9.55 c-20.22-35.23-48.58-24-48.58-24c-4.97-22.17-25.92-32.54-25.92-32.54C977.2,1107.07,979.48,1110.53,981.09,1113.78z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054267118168010060510000010464974811994856365_",
    gradientUnits: "userSpaceOnUse",
    x1: 999.1767,
    y1: 1146.2747,
    x2: 1027.0521,
    y2: 1114.9609
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#9CA5B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    style: {
      stopColor: "#A4ACB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4298,
    style: {
      stopColor: "#BAC0C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    style: {
      stopColor: "#DEE1E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000054267118168010060510000010464974811994856365_)"
    },
    d: "M981.09,1113.78 c6.32,4.69,15.61,13.6,18.66,27.21c0,0,19.5-7.66,37.25,10.49c6.91,3.52,10.37,7.91,11.46,9.55c-20.22-35.23-48.58-24-48.58-24 c-4.97-22.17-25.92-32.54-25.92-32.54C977.2,1107.07,979.48,1110.53,981.09,1113.78z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000178924338613778687500000012789313148517011332_",
    filterUnits: "userSpaceOnUse",
    x: 967.35,
    y: 1338.7,
    width: 91.81,
    height: 87.54
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend131 || (_feBlend131 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 967.35,
    y: 1338.7,
    width: 91.81,
    height: 87.54,
    id: "SVGID_00000137104940682783762700000015115848978457526952_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000178924338613778687500000012789313148517011332_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000004525769421884594520000009285789810100796808_",
    filterUnits: "userSpaceOnUse",
    x: 967.35,
    y: 1338.7,
    width: 91.81,
    height: 87.54
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend132 || (_feBlend132 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 967.35,
    y: 1338.7,
    width: 91.81,
    height: 87.54,
    id: "SVGID_00000137104940682783762700000015115848978457526952_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000004525769421884594520000009285789810100796808_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176001086230053450470000012559137179830360454_",
    gradientUnits: "userSpaceOnUse",
    x1: 998.4279,
    y1: 1397.7412,
    x2: 1024.6663,
    y2: 1368.2665
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0892,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2219,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3853,
    style: {
      stopColor: "#BDBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    style: {
      stopColor: "#8B8B8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7816,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000137104940682783762700000015115848978457526952_)",
      fill: "url(#SVGID_00000176001086230053450470000012559137179830360454_)"
    },
    d: " M1059.07,1421.39c-1.36-6.4-21.32,0-35.84-13.71c-14.52-13.71-21.32-39.29-30.85-47.06c-9.53-7.77-22.68-15.08-24.95-21.93 c0,0-0.35,3.3,0.54,7.9c4.61,6.21,15.75,12.76,24.22,19.66c9.94,8.1,17.05,34.8,32.2,49.11c10.21,9.64,22.88,9.78,30.57,10.87 C1057.56,1425.41,1059.62,1423.97,1059.07,1421.39z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085251909355276289610000007943022519874232481_",
    gradientUnits: "userSpaceOnUse",
    x1: 998.4279,
    y1: 1397.7412,
    x2: 1024.6663,
    y2: 1368.2665
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#9CA5B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    style: {
      stopColor: "#A4ACB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4298,
    style: {
      stopColor: "#BAC0C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    style: {
      stopColor: "#DEE1E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000085251909355276289610000007943022519874232481_)"
    },
    d: "M1059.07,1421.39 c-1.36-6.4-21.32,0-35.84-13.71c-14.52-13.71-21.32-39.29-30.85-47.06c-9.53-7.77-22.68-15.08-24.95-21.93c0,0-0.35,3.3,0.54,7.9 c4.61,6.21,15.75,12.76,24.22,19.66c9.94,8.1,17.05,34.8,32.2,49.11c10.21,9.64,22.88,9.78,30.57,10.87 C1057.56,1425.41,1059.62,1423.97,1059.07,1421.39z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000080197076791012987080000015795644813027991681_",
    filterUnits: "userSpaceOnUse",
    x: 1048.04,
    y: 1343.1,
    width: 91.79,
    height: 93.9
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend133 || (_feBlend133 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 1048.04,
    y: 1343.1,
    width: 91.79,
    height: 93.9,
    id: "SVGID_00000086665681654477215410000010023857991768605877_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000080197076791012987080000015795644813027991681_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000052104604256367435470000010304054317928321953_",
    filterUnits: "userSpaceOnUse",
    x: 1048.04,
    y: 1343.1,
    width: 91.79,
    height: 93.9
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend134 || (_feBlend134 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 1048.04,
    y: 1343.1,
    width: 91.79,
    height: 93.9,
    id: "SVGID_00000086665681654477215410000010023857991768605877_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000052104604256367435470000010304054317928321953_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000125575045090067882110000018295121290790530736_",
    gradientUnits: "userSpaceOnUse",
    x1: 1040.4495,
    y1: 1465.0388,
    x2: 1213.4695,
    y2: 1270.6775
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0892,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2219,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3853,
    style: {
      stopColor: "#BDBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    style: {
      stopColor: "#8B8B8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7816,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000086665681654477215410000010023857991768605877_)",
      fill: "url(#SVGID_00000125575045090067882110000018295121290790530736_)"
    },
    d: " M1114.94,1373.25c-1.71,0.68-2.79,1.09-2.79,1.09s1.37-0.72,3.44-1.94c7.91-9.98,17.24-18.88,23.5-22.56 c0.48-1.42,0.79-2.85,0.74-4.28c-0.45-14.16-50.36,37.01-42.19,52.54c6.57,12.49-15.91,27.61-37,29.98 c0.53,0.44,1,0.91,1.14,1.59c1.42,6.68-13.73,6.2-13.73,6.2c24.15,6.2,62.5-14.3,53.98-30.51 C1098.46,1398.58,1105.52,1385.32,1114.94,1373.25z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083066188732358570420000004433192722913045150_",
    gradientUnits: "userSpaceOnUse",
    x1: 1040.4495,
    y1: 1465.0388,
    x2: 1213.4695,
    y2: 1270.6775
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#9CA5B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    style: {
      stopColor: "#A4ACB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4298,
    style: {
      stopColor: "#BAC0C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    style: {
      stopColor: "#DEE1E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000083066188732358570420000004433192722913045150_)"
    },
    d: "M1114.94,1373.25 c-1.71,0.68-2.79,1.09-2.79,1.09s1.37-0.72,3.44-1.94c7.91-9.98,17.24-18.88,23.5-22.56c0.48-1.42,0.79-2.85,0.74-4.28 c-0.45-14.16-50.36,37.01-42.19,52.54c6.57,12.49-15.91,27.61-37,29.98c0.53,0.44,1,0.91,1.14,1.59c1.42,6.68-13.73,6.2-13.73,6.2 c24.15,6.2,62.5-14.3,53.98-30.51C1098.46,1398.58,1105.52,1385.32,1114.94,1373.25z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000147206405820920795390000014226488164763798161_",
    filterUnits: "userSpaceOnUse",
    x: 931.52,
    y: 1306.71,
    width: 60.65,
    height: 71.46
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend135 || (_feBlend135 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 931.52,
    y: 1306.71,
    width: 60.65,
    height: 71.46,
    id: "SVGID_00000137852379284511516410000009458857644388419228_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000147206405820920795390000014226488164763798161_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000083079319293609578640000010248701032465695141_",
    filterUnits: "userSpaceOnUse",
    x: 931.52,
    y: 1306.71,
    width: 60.65,
    height: 71.46
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend136 || (_feBlend136 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 931.52,
    y: 1306.71,
    width: 60.65,
    height: 71.46,
    id: "SVGID_00000137852379284511516410000009458857644388419228_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000083079319293609578640000010248701032465695141_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000118390092879801684030000016017883338652247730_",
    gradientUnits: "userSpaceOnUse",
    x1: 944.9819,
    y1: 1362.0734,
    x2: 982.1622,
    y2: 1320.307
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0892,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2219,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3853,
    style: {
      stopColor: "#BDBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    style: {
      stopColor: "#8B8B8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7816,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000137852379284511516410000009458857644388419228_)",
      fill: "url(#SVGID_00000118390092879801684030000016017883338652247730_)"
    },
    d: " M950.18,1344.64c-7.71-27.87-14.97-37.46-17.24-37.92c-0.62-0.12-0.9,1.67-1.42,4.19c3.23,2.95,9.74,13.8,16.62,38.66 c8.05,29.08,44.03,28.61,44.03,28.61c-6.77-2.12-11.74-5.18-15.47-8.59C966.52,1366.57,954.38,1359.82,950.18,1344.64z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000167380463585012537480000017041266070267440287_",
    gradientUnits: "userSpaceOnUse",
    x1: 944.9819,
    y1: 1362.0734,
    x2: 982.1622,
    y2: 1320.307
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#9CA5B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    style: {
      stopColor: "#A4ACB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4298,
    style: {
      stopColor: "#BAC0C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    style: {
      stopColor: "#DEE1E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000167380463585012537480000017041266070267440287_)"
    },
    d: "M950.18,1344.64 c-7.71-27.87-14.97-37.46-17.24-37.92c-0.62-0.12-0.9,1.67-1.42,4.19c3.23,2.95,9.74,13.8,16.62,38.66 c8.05,29.08,44.03,28.61,44.03,28.61c-6.77-2.12-11.74-5.18-15.47-8.59C966.52,1366.57,954.38,1359.82,950.18,1344.64z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000154396842761789762280000003937813400990389146_",
    filterUnits: "userSpaceOnUse",
    x: 1166.89,
    y: 1258.98,
    width: 24.92,
    height: 84.39
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend137 || (_feBlend137 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 1166.89,
    y: 1258.98,
    width: 24.92,
    height: 84.39,
    id: "SVGID_00000142152500164554371020000012192100771295316380_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000154396842761789762280000003937813400990389146_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000001634517422758028020000001909965665637625500_",
    filterUnits: "userSpaceOnUse",
    x: 1166.89,
    y: 1258.98,
    width: 24.92,
    height: 84.39
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend138 || (_feBlend138 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 1166.89,
    y: 1258.98,
    width: 24.92,
    height: 84.39,
    id: "SVGID_00000142152500164554371020000012192100771295316380_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000001634517422758028020000001909965665637625500_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155116959107540234270000018250388011714986162_",
    gradientUnits: "userSpaceOnUse",
    x1: 1143.4758,
    y1: 1332.2823,
    x2: 1224.941,
    y2: 1240.7688
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0892,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2219,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3853,
    style: {
      stopColor: "#BDBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    style: {
      stopColor: "#8B8B8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7816,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000142152500164554371020000012192100771295316380_)",
      fill: "url(#SVGID_00000155116959107540234270000018250388011714986162_)"
    },
    d: " M1187.72,1278.53c-0.95-12.4-20.83-19.55-20.83-19.55s20.36,14.3,16.57,28.13c-0.29,1.07-0.83,1.74-1.3,2.53 c1.37,7.24,2.36,15.92,0.21,25.01c0.76-0.23,1.32,0.44,1.56,2.5c1.42,11.92-9,26.22-9,26.22 C1201.93,1319.06,1188.67,1290.93,1187.72,1278.53z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049925333183672421780000009736519626945004181_",
    gradientUnits: "userSpaceOnUse",
    x1: 1143.4758,
    y1: 1332.2823,
    x2: 1224.941,
    y2: 1240.7688
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#9CA5B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    style: {
      stopColor: "#A4ACB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4298,
    style: {
      stopColor: "#BAC0C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    style: {
      stopColor: "#DEE1E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000049925333183672421780000009736519626945004181_)"
    },
    d: "M1187.72,1278.53 c-0.95-12.4-20.83-19.55-20.83-19.55s20.36,14.3,16.57,28.13c-0.29,1.07-0.83,1.74-1.3,2.53c1.37,7.24,2.36,15.92,0.21,25.01 c0.76-0.23,1.32,0.44,1.56,2.5c1.42,11.92-9,26.22-9,26.22C1201.93,1319.06,1188.67,1290.93,1187.72,1278.53z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000136377504130947168110000012159219970068118934_",
    filterUnits: "userSpaceOnUse",
    x: 1117.17,
    y: 1311.07,
    width: 59.08,
    height: 69.49
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend139 || (_feBlend139 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 1117.17,
    y: 1311.07,
    width: 59.08,
    height: 69.49,
    id: "SVGID_00000102513407918986390180000008231114487664454801_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000136377504130947168110000012159219970068118934_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000139255218630876463410000007754223152567653789_",
    filterUnits: "userSpaceOnUse",
    x: 1117.17,
    y: 1311.07,
    width: 59.08,
    height: 69.49
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend140 || (_feBlend140 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 1117.17,
    y: 1311.07,
    width: 59.08,
    height: 69.49,
    id: "SVGID_00000102513407918986390180000008231114487664454801_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000139255218630876463410000007754223152567653789_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106856173732527576010000000532877532021900197_",
    gradientUnits: "userSpaceOnUse",
    x1: 1109.4673,
    y1: 1398.7996,
    x2: 1230.3185,
    y2: 1263.0417
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0892,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2219,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3853,
    style: {
      stopColor: "#BDBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    style: {
      stopColor: "#8B8B8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7816,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000102513407918986390180000008231114487664454801_)",
      fill: "url(#SVGID_00000106856173732527576010000000532877532021900197_)"
    },
    d: " M1167.5,1338.7c0,0,9.98-13.71,8.62-25.13c-1.36-11.42-12.25,19.19-19.06,32.89c-2.17,4.37-7.53,8.78-13.81,12.77 c-7.23,11.51-26.08,21.32-26.08,21.32s39.77-14.78,46.88-29.08c2.24-4.51,4.9-10.77,7.54-16.86 C1170.34,1335.99,1169,1337.35,1167.5,1338.7z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067947614491021070130000017569565221526231471_",
    gradientUnits: "userSpaceOnUse",
    x1: 1109.4673,
    y1: 1398.7996,
    x2: 1230.3185,
    y2: 1263.0417
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#9CA5B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    style: {
      stopColor: "#A4ACB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4298,
    style: {
      stopColor: "#BAC0C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    style: {
      stopColor: "#DEE1E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000067947614491021070130000017569565221526231471_)"
    },
    d: "M1167.5,1338.7 c0,0,9.98-13.71,8.62-25.13c-1.36-11.42-12.25,19.19-19.06,32.89c-2.17,4.37-7.53,8.78-13.81,12.77 c-7.23,11.51-26.08,21.32-26.08,21.32s39.77-14.78,46.88-29.08c2.24-4.51,4.9-10.77,7.54-16.86 C1170.34,1335.99,1169,1337.35,1167.5,1338.7z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000079483846270835945700000017982726713734037652_",
    filterUnits: "userSpaceOnUse",
    x: 907.09,
    y: 1323.2,
    width: 18.63,
    height: 8.89
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend141 || (_feBlend141 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 907.09,
    y: 1323.2,
    width: 18.63,
    height: 8.89,
    id: "SVGID_00000013879620473495439040000012865555367461532560_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000079483846270835945700000017982726713734037652_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000018220625825645298540000006067970627340333234_",
    filterUnits: "userSpaceOnUse",
    x: 907.09,
    y: 1323.2,
    width: 18.63,
    height: 8.89
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend142 || (_feBlend142 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 907.09,
    y: 1323.2,
    width: 18.63,
    height: 8.89,
    id: "SVGID_00000013879620473495439040000012865555367461532560_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000018220625825645298540000006067970627340333234_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000123427213528677128870000011038860792858847884_",
    gradientUnits: "userSpaceOnUse",
    x1: 907.6833,
    y1: 1337.774,
    x2: 933.0007,
    y2: 1309.3339
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0892,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2219,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3853,
    style: {
      stopColor: "#BDBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    style: {
      stopColor: "#8B8B8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7816,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000013879620473495439040000012865555367461532560_)",
      fill: "url(#SVGID_00000123427213528677128870000011038860792858847884_)"
    },
    d: " M917.95,1327.43c-3.87,4.15-8.75,4.62-10.86,4.56c10.59,0.88,15.85-3.6,18.63-8.78C923.82,1325.12,921.37,1326.7,917.95,1327.43 z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129925661404298590770000011911594851010254245_",
    gradientUnits: "userSpaceOnUse",
    x1: 907.6833,
    y1: 1337.774,
    x2: 933.0007,
    y2: 1309.3339
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#9CA5B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    style: {
      stopColor: "#A4ACB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4298,
    style: {
      stopColor: "#BAC0C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    style: {
      stopColor: "#DEE1E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000129925661404298590770000011911594851010254245_)"
    },
    d: "M917.95,1327.43 c-3.87,4.15-8.75,4.62-10.86,4.56c10.59,0.88,15.85-3.6,18.63-8.78C923.82,1325.12,921.37,1326.7,917.95,1327.43z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000003085805294063241060000016711852482948895410_",
    filterUnits: "userSpaceOnUse",
    x: 910.99,
    y: 1265.15,
    width: 0.17,
    height: 0.8
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend143 || (_feBlend143 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 910.99,
    y: 1265.15,
    width: 0.17,
    height: 0.8,
    id: "SVGID_00000137095318105570295030000000060379531091931795_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000003085805294063241060000016711852482948895410_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000057116558031735295050000003282453085068274612_",
    filterUnits: "userSpaceOnUse",
    x: 910.99,
    y: 1265.15,
    width: 0.17,
    height: 0.8
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend144 || (_feBlend144 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 910.99,
    y: 1265.15,
    width: 0.17,
    height: 0.8,
    id: "SVGID_00000137095318105570295030000000060379531091931795_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000057116558031735295050000003282453085068274612_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111151959416386472950000011946523695323491742_",
    gradientUnits: "userSpaceOnUse",
    x1: 910.7371,
    y1: 1265.9266,
    x2: 911.6945,
    y2: 1264.8513
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0892,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2219,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3853,
    style: {
      stopColor: "#BDBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    style: {
      stopColor: "#8B8B8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7816,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000137095318105570295030000000060379531091931795_)",
      fill: "url(#SVGID_00000111151959416386472950000011946523695323491742_)"
    },
    d: " M910.99,1265.95c0.1-0.26,0.03-0.54,0.17-0.8C911.16,1265.15,911.09,1265.45,910.99,1265.95z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000069400036500282800730000011560848114484957877_",
    gradientUnits: "userSpaceOnUse",
    x1: 910.7371,
    y1: 1265.9266,
    x2: 911.6945,
    y2: 1264.8513
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#9CA5B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    style: {
      stopColor: "#A4ACB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4298,
    style: {
      stopColor: "#BAC0C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    style: {
      stopColor: "#DEE1E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000069400036500282800730000011560848114484957877_)"
    },
    d: "M910.99,1265.95 c0.1-0.26,0.03-0.54,0.17-0.8C911.16,1265.15,911.09,1265.45,910.99,1265.95z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000000181263553513162750000011647362884794596510_",
    filterUnits: "userSpaceOnUse",
    x: 816.04,
    y: 1026.15,
    width: 142.99,
    height: 87.18
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend145 || (_feBlend145 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 816.04,
    y: 1026.15,
    width: 142.99,
    height: 87.18,
    id: "SVGID_00000083074864189341218420000000292626381086012307_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000000181263553513162750000011647362884794596510_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000065073248761431855190000006701559642238858377_",
    filterUnits: "userSpaceOnUse",
    x: 816.04,
    y: 1026.15,
    width: 142.99,
    height: 87.18
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend146 || (_feBlend146 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 816.04,
    y: 1026.15,
    width: 142.99,
    height: 87.18,
    id: "SVGID_00000083074864189341218420000000292626381086012307_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000065073248761431855190000006701559642238858377_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000091012632287348939910000011064998770644802986_",
    gradientUnits: "userSpaceOnUse",
    x1: 822.3413,
    y1: 1155.5847,
    x2: 1006.8442,
    y2: 948.3242
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0892,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2219,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3853,
    style: {
      stopColor: "#BDBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    style: {
      stopColor: "#8B8B8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7816,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000083074864189341218420000000292626381086012307_)",
      fill: "url(#SVGID_00000091012632287348939910000011064998770644802986_)"
    },
    d: " M837.04,1112.77c6.96-2.63,14.73-6.7,18.31-12.55c6.96-11.4,19.02-67.19,59.24-65.27c10.48-2.3,30.23,9,30.23,9 c-2.99-1.56-6.16-1.22-8.72-0.44c1.67,0.77,3.36,1.66,5.1,2.66c9.5,2.23,17.83,8.75,17.83,8.75 c-31.72-35.28-61.08-22.41-61.08-22.41c9.47-6.68,18.47-5.72,18.47-5.72c-46.4-7.63-59.66,55.31-67.24,67.7 c-7.58,12.4-33.14,17.16-33.14,17.16C824.65,1113.67,831.5,1113.62,837.04,1112.77z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039830155557303105920000007687185191057338791_",
    gradientUnits: "userSpaceOnUse",
    x1: 822.3413,
    y1: 1155.5847,
    x2: 1006.8442,
    y2: 948.3242
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#9CA5B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    style: {
      stopColor: "#A4ACB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4298,
    style: {
      stopColor: "#BAC0C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    style: {
      stopColor: "#DEE1E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000039830155557303105920000007687185191057338791_)"
    },
    d: "M837.04,1112.77 c6.96-2.63,14.73-6.7,18.31-12.55c6.96-11.4,19.02-67.19,59.24-65.27c10.48-2.3,30.23,9,30.23,9c-2.99-1.56-6.16-1.22-8.72-0.44 c1.67,0.77,3.36,1.66,5.1,2.66c9.5,2.23,17.83,8.75,17.83,8.75c-31.72-35.28-61.08-22.41-61.08-22.41 c9.47-6.68,18.47-5.72,18.47-5.72c-46.4-7.63-59.66,55.31-67.24,67.7c-7.58,12.4-33.14,17.16-33.14,17.16 C824.65,1113.67,831.5,1113.62,837.04,1112.77z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000005245476389120735890000013635717736468611997_",
    filterUnits: "userSpaceOnUse",
    x: 906,
    y: 1331.93,
    width: 1.09,
    height: 0.06
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend147 || (_feBlend147 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 906,
    y: 1331.93,
    width: 1.09,
    height: 0.06,
    id: "SVGID_00000016037077759855013290000001986846492081415058_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000005245476389120735890000013635717736468611997_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000032620034638819514060000001906651253479421875_",
    filterUnits: "userSpaceOnUse",
    x: 906,
    y: 1331.93,
    width: 1.09,
    height: 0.06
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend148 || (_feBlend148 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 906,
    y: 1331.93,
    width: 1.09,
    height: 0.06,
    id: "SVGID_00000016037077759855013290000001986846492081415058_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000032620034638819514060000001906651253479421875_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163068356388013953110000003132095046467217317_",
    gradientUnits: "userSpaceOnUse",
    x1: 906.2209,
    y1: 1332.317,
    x2: 907.1324,
    y2: 1331.2931
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0892,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2219,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3853,
    style: {
      stopColor: "#BDBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    style: {
      stopColor: "#8B8B8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7816,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000016037077759855013290000001986846492081415058_)",
      fill: "url(#SVGID_00000163068356388013953110000003132095046467217317_)"
    },
    d: " M907.09,1331.98c-0.38-0.03-0.7-0.01-1.09-0.06C906,1331.93,906.45,1331.97,907.09,1331.98z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000068660929388061875600000007432977273665005228_",
    gradientUnits: "userSpaceOnUse",
    x1: 906.2209,
    y1: 1332.317,
    x2: 907.1324,
    y2: 1331.2931
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#9CA5B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    style: {
      stopColor: "#A4ACB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4298,
    style: {
      stopColor: "#BAC0C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    style: {
      stopColor: "#DEE1E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000068660929388061875600000007432977273665005228_)"
    },
    d: "M907.09,1331.98 c-0.38-0.03-0.7-0.01-1.09-0.06C906,1331.93,906.45,1331.97,907.09,1331.98z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000182509083545289434020000008939614057107601842_",
    filterUnits: "userSpaceOnUse",
    x: 913.07,
    y: 1068.84,
    width: 18.74,
    height: 25.44
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend149 || (_feBlend149 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 913.07,
    y: 1068.84,
    width: 18.74,
    height: 25.44,
    id: "SVGID_00000062169284717371556690000017380960178669851012_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000182509083545289434020000008939614057107601842_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000061441417705721094820000001215698695836520855_",
    filterUnits: "userSpaceOnUse",
    x: 913.07,
    y: 1068.84,
    width: 18.74,
    height: 25.44
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend150 || (_feBlend150 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 913.07,
    y: 1068.84,
    width: 18.74,
    height: 25.44,
    id: "SVGID_00000062169284717371556690000017380960178669851012_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000061441417705721094820000001215698695836520855_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000084525857438600534830000000919972469549223082_",
    gradientUnits: "userSpaceOnUse",
    x1: 919.3589,
    y1: 1085.015,
    x2: 928.1031,
    y2: 1075.1923
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0892,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2219,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3853,
    style: {
      stopColor: "#BDBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    style: {
      stopColor: "#8B8B8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7816,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000062169284717371556690000017380960178669851012_)",
      fill: "url(#SVGID_00000084525857438600534830000000919972469549223082_)"
    },
    d: " M928.55,1087.86c-6.97-6.69-11.94-13.07-15.49-19.03c3.19,7.58,9.05,16.24,18.74,25.44 C931.81,1094.28,929.96,1091.64,928.55,1087.86z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000066474583668653516780000004035435106422346883_",
    gradientUnits: "userSpaceOnUse",
    x1: 919.3589,
    y1: 1085.015,
    x2: 928.1031,
    y2: 1075.1923
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#9CA5B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    style: {
      stopColor: "#A4ACB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4298,
    style: {
      stopColor: "#BAC0C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    style: {
      stopColor: "#DEE1E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000066474583668653516780000004035435106422346883_)"
    },
    d: "M928.55,1087.86 c-6.97-6.69-11.94-13.07-15.49-19.03c3.19,7.58,9.05,16.24,18.74,25.44C931.81,1094.28,929.96,1091.64,928.55,1087.86z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000147930271086778819950000006709513021208757401_",
    filterUnits: "userSpaceOnUse",
    x: 802.22,
    y: 1117.48,
    width: 43.42,
    height: 80
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend151 || (_feBlend151 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 802.22,
    y: 1117.48,
    width: 43.42,
    height: 80,
    id: "SVGID_00000142892369567922497980000003190684791909699471_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000147930271086778819950000006709513021208757401_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000174567057734993613000000010139829574387082909_",
    filterUnits: "userSpaceOnUse",
    x: 802.22,
    y: 1117.48,
    width: 43.42,
    height: 80
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend152 || (_feBlend152 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 802.22,
    y: 1117.48,
    width: 43.42,
    height: 80,
    id: "SVGID_00000142892369567922497980000003190684791909699471_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000174567057734993613000000010139829574387082909_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000136371440270846206380000009414589322880763032_",
    gradientUnits: "userSpaceOnUse",
    x1: 793.9938,
    y1: 1193.3964,
    x2: 894.7513,
    y2: 1080.2108
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0892,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2219,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3853,
    style: {
      stopColor: "#BDBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    style: {
      stopColor: "#8B8B8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7816,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000142892369567922497980000003190684791909699471_)",
      fill: "url(#SVGID_00000136371440270846206380000009414589322880763032_)"
    },
    d: " M818.15,1143.62c10.48-13.5,20.07-21.39,27.48-26.14c-3.85,0.77-8.53,1.07-14.1,0.49c-6.33,5.06-13.51,11.93-21.18,21.82 c-23.67,30.51,11.84,57.69,11.84,57.69c-6.88-7.64-9-15.16-9.41-20.77C809.14,1167.31,808.74,1155.76,818.15,1143.62z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155851989787712504000000010234401431709707172_",
    gradientUnits: "userSpaceOnUse",
    x1: 793.9938,
    y1: 1193.3964,
    x2: 894.7513,
    y2: 1080.2108
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#9CA5B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    style: {
      stopColor: "#A4ACB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4298,
    style: {
      stopColor: "#BAC0C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    style: {
      stopColor: "#DEE1E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000155851989787712504000000010234401431709707172_)"
    },
    d: "M818.15,1143.62 c10.48-13.5,20.07-21.39,27.48-26.14c-3.85,0.77-8.53,1.07-14.1,0.49c-6.33,5.06-13.51,11.93-21.18,21.82 c-23.67,30.51,11.84,57.69,11.84,57.69c-6.88-7.64-9-15.16-9.41-20.77C809.14,1167.31,808.74,1155.76,818.15,1143.62z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000065758242212586683790000011594141443570394815_",
    filterUnits: "userSpaceOnUse",
    x: 820.46,
    y: 1170.12,
    width: 93.59,
    height: 125.1
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend153 || (_feBlend153 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 820.46,
    y: 1170.12,
    width: 93.59,
    height: 125.1,
    id: "SVGID_00000007404388516320367560000003792623988647524265_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000065758242212586683790000011594141443570394815_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000101821600812592263440000009812065591818756226_",
    filterUnits: "userSpaceOnUse",
    x: 820.46,
    y: 1170.12,
    width: 93.59,
    height: 125.1
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend154 || (_feBlend154 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 820.46,
    y: 1170.12,
    width: 93.59,
    height: 125.1,
    id: "SVGID_00000007404388516320367560000003792623988647524265_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000101821600812592263440000009812065591818756226_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023966080592755920080000011611668586171699609_",
    gradientUnits: "userSpaceOnUse",
    x1: 852.7032,
    y1: 1249.4998,
    x2: 895.4651,
    y2: 1201.4633
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0892,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2219,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3853,
    style: {
      stopColor: "#BDBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    style: {
      stopColor: "#8B8B8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7816,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000007404388516320367560000003792623988647524265_)",
      fill: "url(#SVGID_00000023966080592755920080000011611668586171699609_)"
    },
    d: " M914.05,1295.22c-4.01-4.57-5.95-9.64-6.82-14.24c-2.03-2.9-4.03-6.19-5.6-9.89c-5.44-12.79-11.34-18.73-24.05-26.04 c-12.7-7.31-34.48-13.71-40.38-32.44c-5.9-18.73-7.71-37.92-15.88-42.49c0,0-0.88,2.75-0.87,6.95 c1.77,4.48,3.26,10.03,4.78,16.16c1.15,1.87,2.53,3.76,4.25,5.68c0,0-1.51-1.18-3.64-3.24c1.29,5.19,2.67,10.65,4.39,16.11 c6.15,19.55,28.88,26.22,42.14,33.85c13.26,7.63,19.41,13.83,25.09,27.18C903.16,1286.16,914.05,1295.22,914.05,1295.22z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160181552602957242710000013744319000674791091_",
    gradientUnits: "userSpaceOnUse",
    x1: 852.7032,
    y1: 1249.4998,
    x2: 895.4651,
    y2: 1201.4633
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#9CA5B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    style: {
      stopColor: "#A4ACB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4298,
    style: {
      stopColor: "#BAC0C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    style: {
      stopColor: "#DEE1E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000160181552602957242710000013744319000674791091_)"
    },
    d: "M914.05,1295.22 c-4.01-4.57-5.95-9.64-6.82-14.24c-2.03-2.9-4.03-6.19-5.6-9.89c-5.44-12.79-11.34-18.73-24.05-26.04 c-12.7-7.31-34.48-13.71-40.38-32.44c-5.9-18.73-7.71-37.92-15.88-42.49c0,0-0.88,2.75-0.87,6.95c1.77,4.48,3.26,10.03,4.78,16.16 c1.15,1.87,2.53,3.76,4.25,5.68c0,0-1.51-1.18-3.64-3.24c1.29,5.19,2.67,10.65,4.39,16.11c6.15,19.55,28.88,26.22,42.14,33.85 c13.26,7.63,19.41,13.83,25.09,27.18C903.16,1286.16,914.05,1295.22,914.05,1295.22z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000072282346058619403510000005830875629901509273_",
    filterUnits: "userSpaceOnUse",
    x: 871.78,
    y: 1049.51,
    width: 263.74,
    height: 369.54
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend155 || (_feBlend155 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 871.78,
    y: 1049.51,
    width: 263.74,
    height: 369.54,
    id: "SVGID_00000057143427937790401400000008669776006956700300_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000072282346058619403510000005830875629901509273_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000023253008213704301090000006600135935679286693_",
    filterUnits: "userSpaceOnUse",
    x: 871.78,
    y: 1049.51,
    width: 263.74,
    height: 369.54
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend156 || (_feBlend156 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 871.78,
    y: 1049.51,
    width: 263.74,
    height: 369.54,
    id: "SVGID_00000057143427937790401400000008669776006956700300_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000023253008213704301090000006600135935679286693_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075883389977329419810000006847777849975549592_",
    gradientUnits: "userSpaceOnUse",
    x1: 876.8342,
    y1: 1508.6893,
    x2: 1051.5497,
    y2: 1085.3955
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0892,
    style: {
      stopColor: "#F7F7F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2219,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3853,
    style: {
      stopColor: "#BDBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    style: {
      stopColor: "#8B8B8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7816,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000057143427937790401400000008669776006956700300_)",
      fill: "url(#SVGID_00000075883389977329419810000006847777849975549592_)"
    },
    d: " M888.39,1147.47c6.48,12.86,12.07,27.11,9.77,41.33c1.45-13.78,0.02-27.86-4.16-41.07c10.09,19.09,14.99,40.88,14.06,62.45 c2.84-10.95,4.61-22.17,5.27-33.47c0.51,12.65,2.2,25.25,5.04,37.59c0.53-2.71,1.07-5.42,1.6-8.13 c-1.18,30.31,13.96,60.77,38.84,78.14c-16.22-14.89-25.08-37.44-23.33-59.39c-0.88,11.59,1.81,23.43,7.61,33.5 c-0.49-2.53-0.98-5.07-1.47-7.6c23.25,21.14,39.02,50.36,43.94,81.4c1.29-17.92-2.47-36.17-10.74-52.12 c3.94,9.76,7.89,19.52,11.83,29.28c-1.34-4.54-1.12-9.53,0.62-13.93c12.99,11.81,13.5,31.6,18.91,48.3 c7.33,22.65,25.58,41.48,47.98,49.52c-19.79-7.07-33.27-28.72-30.87-49.6c2.3,5.47,4.61,10.93,6.91,16.4 c-1.13-3.73,0.09-8.08,3-10.67c24.28,13.08,38.6,42.48,33.93,69.66c4.48-11.13,5.95-23.45,4.21-35.32 c0.81,4.54,1.62,9.08,2.43,13.61c0.3-13.17-0.77-26.37-3.2-39.31c0.65,7.7,3.39,15.21,7.86,21.51 c-9.43-18.39-18.86-36.77-28.3-55.15c18.26,13.52,31.22,34.01,35.6,56.3c2.69-12.81,1.85-26.34-2.42-38.72 c-0.54,5.25,0.6,10.66,3.2,15.26c0.21-8.46-1.46-16.97-4.86-24.72c0.91,8.36,9.25,15.17,17.62,14.39 c8.37-0.78,15.3-9.03,14.64-17.41c-3.06,7.18-13.57,9.78-19.63,4.85c16.74,0.79,33.52-8.88,41.23-23.76 c-1.16,1.89-2.32,3.79-3.48,5.68c-11.63-0.19-23.26-0.38-34.89-0.57c-1.16,1.25,2.44,1.9,2.47,0.2c0.04-1.71-1.91-2.65-3.52-3.22 c-21.05-7.46-39.07-23.15-49.35-42.97c0.59,10.8,12.52,16.92,22.97,19.71c10.45,2.79,22.6,5.55,27.47,15.21 c-2.86-16.53-15.54-30.96-31.57-35.92c3.86,2.54,7.72,5.09,11.58,7.63c-17.57-11.37-35.14-22.75-52.7-34.12 c25.84-1.39,52.08,6.49,72.88,21.9c-17.75-16.82-41.5-27.18-65.91-28.74c2.87,0.42,5.75,0.84,8.62,1.26 c-14.19-11.62-37.1-10.18-48.44-24.59c-11.99-15.24-3.47-37.87-8.6-56.57c-1.56,10.62-0.39,21.62,3.37,31.67 c-1.92-7.26-3.85-14.53-5.77-21.79c-4.81,17.62-4.27,36.68,1.54,54c-6.42-22.12-12.85-44.24-19.27-66.36 c-4.44,15.81-3.93,32.98,1.46,48.5c-13.46-21.32-24.22-44.36-31.93-68.37c1.24,24.04,9.01,47.7,22.27,67.79 c-24.69-13.53-35.92-42.38-45.28-68.93c2.86,6.46,3.29,13.96,1.18,20.7c-23.38-28.09-30.82-68.61-18.94-103.17 c-4.31,12.54-13.42,20.62-15.11,35.12c-1.56,13.32,0.69,27.45,7.39,39.15c-2.33-8.25-4.82-17.52-11.44-23.23 C868.52,1115.12,881.89,1134.59,888.39,1147.47z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023999280629937003920000005685810538648939392_",
    gradientUnits: "userSpaceOnUse",
    x1: 876.8342,
    y1: 1508.6893,
    x2: 1051.5497,
    y2: 1085.3955
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00392157,
    style: {
      stopColor: "#9CA5B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1707,
    style: {
      stopColor: "#A4ACB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4298,
    style: {
      stopColor: "#BAC0C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7469,
    style: {
      stopColor: "#DEE1E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000023999280629937003920000005685810538648939392_)"
    },
    d: "M888.39,1147.47 c6.48,12.86,12.07,27.11,9.77,41.33c1.45-13.78,0.02-27.86-4.16-41.07c10.09,19.09,14.99,40.88,14.06,62.45 c2.84-10.95,4.61-22.17,5.27-33.47c0.51,12.65,2.2,25.25,5.04,37.59c0.53-2.71,1.07-5.42,1.6-8.13 c-1.18,30.31,13.96,60.77,38.84,78.14c-16.22-14.89-25.08-37.44-23.33-59.39c-0.88,11.59,1.81,23.43,7.61,33.5 c-0.49-2.53-0.98-5.07-1.47-7.6c23.25,21.14,39.02,50.36,43.94,81.4c1.29-17.92-2.47-36.17-10.74-52.12 c3.94,9.76,7.89,19.52,11.83,29.28c-1.34-4.54-1.12-9.53,0.62-13.93c12.99,11.81,13.5,31.6,18.91,48.3 c7.33,22.65,25.58,41.48,47.98,49.52c-19.79-7.07-33.27-28.72-30.87-49.6c2.3,5.47,4.61,10.93,6.91,16.4 c-1.13-3.73,0.09-8.08,3-10.67c24.28,13.08,38.6,42.48,33.93,69.66c4.48-11.13,5.95-23.45,4.21-35.32 c0.81,4.54,1.62,9.08,2.43,13.61c0.3-13.17-0.77-26.37-3.2-39.31c0.65,7.7,3.39,15.21,7.86,21.51 c-9.43-18.39-18.86-36.77-28.3-55.15c18.26,13.52,31.22,34.01,35.6,56.3c2.69-12.81,1.85-26.34-2.42-38.72 c-0.54,5.25,0.6,10.66,3.2,15.26c0.21-8.46-1.46-16.97-4.86-24.72c0.91,8.36,9.25,15.17,17.62,14.39 c8.37-0.78,15.3-9.03,14.64-17.41c-3.06,7.18-13.57,9.78-19.63,4.85c16.74,0.79,33.52-8.88,41.23-23.76 c-1.16,1.89-2.32,3.79-3.48,5.68c-11.63-0.19-23.26-0.38-34.89-0.57c-1.16,1.25,2.44,1.9,2.47,0.2c0.04-1.71-1.91-2.65-3.52-3.22 c-21.05-7.46-39.07-23.15-49.35-42.97c0.59,10.8,12.52,16.92,22.97,19.71c10.45,2.79,22.6,5.55,27.47,15.21 c-2.86-16.53-15.54-30.96-31.57-35.92c3.86,2.54,7.72,5.09,11.58,7.63c-17.57-11.37-35.14-22.75-52.7-34.12 c25.84-1.39,52.08,6.49,72.88,21.9c-17.75-16.82-41.5-27.18-65.91-28.74c2.87,0.42,5.75,0.84,8.62,1.26 c-14.19-11.62-37.1-10.18-48.44-24.59c-11.99-15.24-3.47-37.87-8.6-56.57c-1.56,10.62-0.39,21.62,3.37,31.67 c-1.92-7.26-3.85-14.53-5.77-21.79c-4.81,17.62-4.27,36.68,1.54,54c-6.42-22.12-12.85-44.24-19.27-66.36 c-4.44,15.81-3.93,32.98,1.46,48.5c-13.46-21.32-24.22-44.36-31.93-68.37c1.24,24.04,9.01,47.7,22.27,67.79 c-24.69-13.53-35.92-42.38-45.28-68.93c2.86,6.46,3.29,13.96,1.18,20.7c-23.38-28.09-30.82-68.61-18.94-103.17 c-4.31,12.54-13.42,20.62-15.11,35.12c-1.56,13.32,0.69,27.45,7.39,39.15c-2.33-8.25-4.82-17.52-11.44-23.23 C868.52,1115.12,881.89,1134.59,888.39,1147.47z"
  }), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M870.15,1230.74c-8.17-14.25-11.35-31.31-8.86-47.55c-3.95,10.79-1.27,23.15,4.58,33.05 c5.85,9.89,14.56,17.74,23.37,25.13c-2.38-1.58-3.38-4.95-2.24-7.57c14.43,5.73,26.04,18.17,30.76,32.96 c-8.92-22.29-21.89-42.95-38.09-60.67c6.61,7.08,13.23,14.16,19.84,21.24c1.62,1.73,3.47,3.58,5.84,3.74 c2.36,0.16,4.81-2.6,3.43-4.54c12.84,12.1,21.83,28.24,25.34,45.53c-1.29,0.61-1.67-2.2-0.28-2.54c1.39-0.34,2.63,0.89,3.53,2 c9.02,11.28,16.31,23.96,21.52,37.43c-20.93-36.55-38.31-75.13-51.82-115.02c-2.36,6.2-2.41,13.24-0.12,19.47 c-8.65-11.48-17.3-22.96-25.95-34.45c0.78,6.44,0.22,13.04-1.62,19.26c-7.01-8.83-12.51-18.87-16.19-29.53 c-1.28,18.03,3.19,36.42,12.6,51.86c-11.28-22.42-17.44-47.4-17.9-72.49c-2.81,8.09-5.61,16.17-8.42,24.26 c-0.36-17.22,3.97-34.51,12.4-49.52c-2.43,8.19-4.86,16.38-7.29,24.57c4.53-15.26,9.47-30.01,15.84-44.61 c-17.83,27.41-50.37,62.63-24.67,94.46c-2.26-12.21-2.75-24.19-0.32-36.44C837.61,1186.33,855.16,1211.62,870.15,1230.74z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M1118.73,1270.47c-6.51-20.64-27.88-32.15-47.37-41.56c14.37,6.09,26.46,17.41,33.48,31.35 c-22.18-14.56-46.88-25.52-66.86-42.98c-19.98-17.46-34.99-44.07-29.12-69.95c-8.65,16.63-7.58,37.89,2.7,53.56 c-3.76-7.74-7.53-15.48-11.29-23.23c0.69,15.28,3.51,30.47,8.36,44.98c-15.27-10.77-27.02-26.47-33.04-44.16 c-3.53,19.99,7.32,40.38,22.82,53.5c15.5,13.11,35.05,20.27,54.3,26.72c-11.53,1.2-23.28,0.18-34.43-2.99 c7.77-1.14,15.73-1.02,23.47,0.36c-16.31-0.66-32.66-0.32-48.93,1.03c21.79,3.57,43.58,7.15,65.36,10.72 c-12.71-18.53-44.39-21.19-49.8-43c11.18,9.02,24.25,15.7,38.11,19.48c-12.76-5.96-22.78-17.53-26.86-31.01 c16.07,23.7,38.67,42.92,64.64,54.97c-7.04-1.4-14.37-1.32-21.38,0.22c7.08,3.39,15.14,4.71,22.93,3.77 c-8.91,10.4-23.73,15.34-37.1,12.37c18.51,2.67,36.91,6.19,55.1,10.55c-1.3-8.33-4.39-16.39-8.98-23.46 c2.05,5.38,5.25,10.32,9.33,14.38c-1.63,1.31-1.56-3.5,0.03-2.13c9.4,8.07,18.19,16.85,26.27,26.23c-2.83,0.65-5.65,1.31-8.48,1.96 c-1.21,15.26-12.5,29.22-27.17,33.59c13.33-5.47,25.45-13.88,35.24-24.45c-2.78,3.31-5.55,6.63-8.33,9.94 c9.42-2.75,16.94-11.16,18.62-20.83c-1.11,7.13-2.21,14.25-3.32,21.38c-1.14-3.91,0.76-8.49,4.33-10.44 c1.4,6.47,1.61,13.19,0.61,19.73c1.04-7.77,3.83-15.3,8.11-21.87c3.67,6.31,3.32,14.74-0.86,20.72c2.16-9.03,3.58-18.23,4.24-27.49 c-4.69-1.89-9.37-3.79-14.05-5.69c4.88,3,9.75,5.99,14.63,8.99c0.21-3.84,2.2-7.54,5.29-9.83c2.53,6.38,3.33,13.28,2.81,20.09 C1175.41,1291.07,1128.02,1299.9,1118.73,1270.47z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000016765510470574791030000014997773520331789720_",
    filterUnits: "userSpaceOnUse",
    x: 940.56,
    y: 996.33,
    width: 117.9,
    height: 96.27
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend157 || (_feBlend157 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 940.56,
    y: 996.33,
    width: 117.9,
    height: 96.27,
    id: "SVGID_00000069371383659529128610000009281087806912131770_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000016765510470574791030000014997773520331789720_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000056388786488707663010000008162736187701605279_",
    filterUnits: "userSpaceOnUse",
    x: 940.56,
    y: 996.33,
    width: 117.9,
    height: 96.27
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend158 || (_feBlend158 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 940.56,
    y: 996.33,
    width: 117.9,
    height: 96.27,
    id: "SVGID_00000069371383659529128610000009281087806912131770_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000056388786488707663010000008162736187701605279_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000102503478099392571340000003255476139696911774_",
    gradientUnits: "userSpaceOnUse",
    x1: 972.8262,
    y1: 1018.3066,
    x2: 989.8715,
    y2: 1037.4827
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00784314,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.093,
    style: {
      stopColor: "#F4F4F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2412,
    style: {
      stopColor: "#D8D8D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4349,
    style: {
      stopColor: "#A9A9A9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6665,
    style: {
      stopColor: "#696969"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9276,
    style: {
      stopColor: "#181818"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000069371383659529128610000009281087806912131770_)",
      fill: "url(#SVGID_00000102503478099392571340000003255476139696911774_)"
    },
    d: " M941.27,1086.92c0,0,17.28-41.67,31.01-56.34c13.73-14.68,23.67-28.88,32.2-31.72c8.52-2.84,5.68-3.55,19.89-0.71 c14.2,2.84,34.09,5.92,34.09,5.92s-40.04-8.96-53.27,1.89c-27.7,22.73-64.63,86.65-64.63,86.65L941.27,1086.92z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000182489010144075704320000014965787742890211736_",
    gradientUnits: "userSpaceOnUse",
    x1: 972.8262,
    y1: 1018.3066,
    x2: 989.8715,
    y2: 1037.4827
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00784314,
    style: {
      stopColor: "#8C0503"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8C0503"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000182489010144075704320000014965787742890211736_)"
    },
    d: "M941.27,1086.92 c0,0,17.28-41.67,31.01-56.34c13.73-14.68,23.67-28.88,32.2-31.72c8.52-2.84,5.68-3.55,19.89-0.71c14.2,2.84,34.09,5.92,34.09,5.92 s-40.04-8.96-53.27,1.89c-27.7,22.73-64.63,86.65-64.63,86.65L941.27,1086.92z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000069358241445779727980000000399120941541213833_",
    filterUnits: "userSpaceOnUse",
    x: 1060.1,
    y: 908.19,
    width: 105.73,
    height: 97.64
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend159 || (_feBlend159 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 1060.1,
    y: 908.19,
    width: 105.73,
    height: 97.64,
    id: "SVGID_00000090294995722319580600000007166437401567976836_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000069358241445779727980000000399120941541213833_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000156558824263211926700000004353856357878942646_",
    filterUnits: "userSpaceOnUse",
    x: 1060.1,
    y: 908.19,
    width: 105.73,
    height: 97.64
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend160 || (_feBlend160 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 1060.1,
    y: 908.19,
    width: 105.73,
    height: 97.64,
    id: "SVGID_00000090294995722319580600000007166437401567976836_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000156558824263211926700000004353856357878942646_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000071556554026021797750000002678427226437238184_",
    gradientUnits: "userSpaceOnUse",
    x1: 1099.3279,
    y1: 947.5739,
    x2: 1115.7784,
    y2: 962.8058
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00784314,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.093,
    style: {
      stopColor: "#F4F4F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2412,
    style: {
      stopColor: "#D8D8D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4349,
    style: {
      stopColor: "#A9A9A9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6665,
    style: {
      stopColor: "#696969"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9276,
    style: {
      stopColor: "#181818"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000090294995722319580600000007166437401567976836_)",
      fill: "url(#SVGID_00000071556554026021797750000002678427226437238184_)"
    },
    d: " M1060.1,1005.83c0,0,44.76-49.4,53.15-63.95c8.39-14.54,19.58-40.86,44.76-31.86c25.18,9-16.09,15.24-44.06,54.71 C1085.98,1004.22,1060.1,1005.83,1060.1,1005.83z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170277368030667182790000007783940418062137501_",
    gradientUnits: "userSpaceOnUse",
    x1: 1099.3279,
    y1: 947.5739,
    x2: 1115.7784,
    y2: 962.8058
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00784314,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "url(#SVGID_00000170277368030667182790000007783940418062137501_)"
    },
    d: "M1060.1,1005.83 c0,0,44.76-49.4,53.15-63.95c8.39-14.54,19.58-40.86,44.76-31.86c25.18,9-16.09,15.24-44.06,54.71 C1085.98,1004.22,1060.1,1005.83,1060.1,1005.83z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000082341437337061235250000011204794714961527199_",
    filterUnits: "userSpaceOnUse",
    x: 1065.03,
    y: 912.2,
    width: 127.46,
    height: 360.8
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend161 || (_feBlend161 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 1065.03,
    y: 912.2,
    width: 127.46,
    height: 360.8,
    id: "SVGID_00000038388547930274691150000017264009649002511025_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000082341437337061235250000011204794714961527199_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000002363770874647191130000013872302959074867857_",
    filterUnits: "userSpaceOnUse",
    x: 1065.03,
    y: 912.2,
    width: 127.46,
    height: 360.8
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend162 || (_feBlend162 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 1065.03,
    y: 912.2,
    width: 127.46,
    height: 360.8,
    id: "SVGID_00000038388547930274691150000017264009649002511025_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000002363770874647191130000013872302959074867857_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000069363943548183594200000013386102953533232530_",
    gradientUnits: "userSpaceOnUse",
    x1: 1284.0236,
    y1: 969.3365,
    x2: 1072.9708,
    y2: 1179.6788
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00784314,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.093,
    style: {
      stopColor: "#F4F4F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2412,
    style: {
      stopColor: "#D8D8D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4349,
    style: {
      stopColor: "#A9A9A9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6665,
    style: {
      stopColor: "#696969"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9276,
    style: {
      stopColor: "#181818"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000038388547930274691150000017264009649002511025_)",
      fill: "url(#SVGID_00000069363943548183594200000013386102953533232530_)"
    },
    d: " M1168.31,912.2c0,0,10.49,22.77-4.74,44.74c-44.03,63.56-95.17,110.09-95.17,110.09s25.57-8.52,34.8,7.1 c9.23,15.62-44.03,74.57-37.64,78.84c6.39,4.26,19.89-36.22,36.93-45.45c17.05-9.23,38.35-17.76,45.45-0.71 c7.1,17.05,4.97,22.73-0.71,39.06c-5.68,16.34-37.64,51.14-30.54,55.4c7.1,4.26,8.52-11.36,17.05-22.02 c8.52-10.65,25.57-48.3,41.9-35.51c16.34,12.78,11.36,90.2-25.57,129.26c0,0,2.13,0,5.68-3.55c3.55-3.55,25.57-22.02,31.96-51.14 c6.39-29.12,7.81-61.08-4.97-73.86c-12.78-12.78-19.65-19.89-22.96-27.7c-3.31-7.81-6.63-24.38-22.73-24.62 c-16.1-0.24-22.49-8.05-24.62-17.99c-2.13-9.94-10.3-17.52-18.82-14.91c-8.52,2.6,44.81-42.77,71.73-81.32 C1194.11,936.7,1174.94,917.88,1168.31,912.2z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000060732431591071903910000010715270790433614995_",
    gradientUnits: "userSpaceOnUse",
    x1: 1284.0236,
    y1: 969.3365,
    x2: 1072.9708,
    y2: 1179.6788
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00784314,
    style: {
      stopColor: "#8C0503"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8C0503"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000060732431591071903910000010715270790433614995_)"
    },
    d: "M1168.31,912.2 c0,0,10.49,22.77-4.74,44.74c-44.03,63.56-95.17,110.09-95.17,110.09s25.57-8.52,34.8,7.1c9.23,15.62-44.03,74.57-37.64,78.84 c6.39,4.26,19.89-36.22,36.93-45.45c17.05-9.23,38.35-17.76,45.45-0.71c7.1,17.05,4.97,22.73-0.71,39.06 c-5.68,16.34-37.64,51.14-30.54,55.4c7.1,4.26,8.52-11.36,17.05-22.02c8.52-10.65,25.57-48.3,41.9-35.51 c16.34,12.78,11.36,90.2-25.57,129.26c0,0,2.13,0,5.68-3.55c3.55-3.55,25.57-22.02,31.96-51.14c6.39-29.12,7.81-61.08-4.97-73.86 c-12.78-12.78-19.65-19.89-22.96-27.7c-3.31-7.81-6.63-24.38-22.73-24.62c-16.1-0.24-22.49-8.05-24.62-17.99 c-2.13-9.94-10.3-17.52-18.82-14.91c-8.52,2.6,44.81-42.77,71.73-81.32C1194.11,936.7,1174.94,917.88,1168.31,912.2z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000174591830130169281500000002315952294742324650_",
    filterUnits: "userSpaceOnUse",
    x: 973.92,
    y: 1001.93,
    width: 84.54,
    height: 104.95
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend163 || (_feBlend163 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 973.92,
    y: 1001.93,
    width: 84.54,
    height: 104.95,
    id: "SVGID_00000179615474310452303280000002453206280710468005_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000174591830130169281500000002315952294742324650_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000132809097518727985210000010888026970049324698_",
    filterUnits: "userSpaceOnUse",
    x: 973.92,
    y: 1001.93,
    width: 84.54,
    height: 104.95
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend164 || (_feBlend164 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 973.92,
    y: 1001.93,
    width: 84.54,
    height: 104.95,
    id: "SVGID_00000179615474310452303280000002453206280710468005_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000132809097518727985210000010888026970049324698_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000060017383651916113550000007140163485613992605_",
    gradientUnits: "userSpaceOnUse",
    x1: 1002.0682,
    y1: 1042.3889,
    x2: 1015.5266,
    y2: 1054.8503
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00784314,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.093,
    style: {
      stopColor: "#F4F4F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2412,
    style: {
      stopColor: "#D8D8D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4349,
    style: {
      stopColor: "#A9A9A9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6665,
    style: {
      stopColor: "#696969"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9276,
    style: {
      stopColor: "#181818"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000179615474310452303280000002453206280710468005_)",
      fill: "url(#SVGID_00000060017383651916113550000007140163485613992605_)"
    },
    d: " M973.95,1106.79c-1.54,3.01,59.54-78.21,84.51-102.74c0,0-13.26-7.1-23.72,4.65C1020.56,1024.64,976.12,1102.53,973.95,1106.79z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000037650496905070724750000016071330189365691049_",
    gradientUnits: "userSpaceOnUse",
    x1: 1002.0682,
    y1: 1042.3889,
    x2: 1015.5266,
    y2: 1054.8503
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00784314,
    style: {
      stopColor: "#8C0503"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8C0503"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000037650496905070724750000016071330189365691049_)"
    },
    d: "M973.95,1106.79 c-1.54,3.01,59.54-78.21,84.51-102.74c0,0-13.26-7.1-23.72,4.65C1020.56,1024.64,976.12,1102.53,973.95,1106.79z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChristmasMobileProductDetailsCardSanta1);
export default __webpack_public_path__ + "static/media/christmas_mobile_product_details_card_santa1.23ce34a97a3d7190f7e97d50cbbdbb43.svg";
export { ForwardRef as ReactComponent };